// Generated code: do not modify this file as it will be overwritten
// Template: ClientSync.cst

/* eslint-disable import/order */
import { EntityStore } from 'src/util/entity-store/entity-store.models';
import { Record } from 'immutable';

import {
  ActivationRuleRecord,
  selectActivationRuleById,
  selectActivationRuleEntitiesByIds,
} from './activation-rule-record.generated';
import {
  ActiveAlertAcknowledgementRecord,
  selectActiveAlertAcknowledgementById,
  selectActiveAlertAcknowledgementEntitiesByIds,
} from './active-alert-acknowledgement-record.generated';
import {
  ActiveAlertRecord,
  selectActiveAlertById,
  selectActiveAlertEntitiesByIds,
} from './active-alert-record.generated';
import {
  ActiveTimelineRecord,
  selectActiveTimelineById,
  selectActiveTimelineEntitiesByIds,
} from './active-timeline-record.generated';
import { AlertRecord, selectAlertById, selectAlertEntitiesByIds } from './alert-record.generated';
import {
  ApplicationNotificationRecord,
  selectApplicationNotificationById,
  selectApplicationNotificationEntitiesByIds,
} from './application-notification-record.generated';
import {
  AssignmentDelayedReasonRecord,
  selectAssignmentDelayedReasonById,
  selectAssignmentDelayedReasonEntitiesByIds,
} from './assignment-delayed-reason-record.generated';
import {
  CancellationCategoryRecord,
  selectCancellationCategoryById,
  selectCancellationCategoryEntitiesByIds,
} from './cancellation-category-record.generated';
import {
  CancellationReasonRecord,
  selectCancellationReasonById,
  selectCancellationReasonEntitiesByIds,
} from './cancellation-reason-record.generated';
import {
  CancellationSecondaryReasonRecord,
  selectCancellationSecondaryReasonById,
  selectCancellationSecondaryReasonEntitiesByIds,
} from './cancellation-secondary-reason-record.generated';
import { CardRecord, selectCardById, selectCardEntitiesByIds } from './card-record.generated';
import {
  CardLinkRecord,
  selectCardLinkById,
  selectCardLinkEntitiesByIds,
} from './card-link-record.generated';
import {
  CardNoteArchiveRecord,
  selectCardNoteArchiveById,
  selectCardNoteArchiveEntitiesByIds,
} from './card-note-archive-record.generated';
import {
  CardNoteRecord,
  selectCardNoteById,
  selectCardNoteEntitiesByIds,
} from './card-note-record.generated';
import {
  CardReOpenReasonRecord,
  selectCardReOpenReasonById,
  selectCardReOpenReasonEntitiesByIds,
} from './card-re-open-reason-record.generated';
import {
  CardSummaryRecord,
  selectCardSummaryById,
  selectCardSummaryEntitiesByIds,
} from './card-summary-record.generated';
import {
  ConfigurationSettingRecord,
  selectConfigurationSettingById,
  selectConfigurationSettingEntitiesByIds,
} from './configuration-setting-record.generated';
import {
  ConversationRecord,
  selectConversationById,
  selectConversationEntitiesByIds,
} from './conversation-record.generated';
import {
  ConversationParticipantRecord,
  selectConversationParticipantById,
  selectConversationParticipantEntitiesByIds,
} from './conversation-participant-record.generated';
import {
  DeclineCategoryRecord,
  selectDeclineCategoryById,
  selectDeclineCategoryEntitiesByIds,
} from './decline-category-record.generated';
import {
  DeclineReasonRecord,
  selectDeclineReasonById,
  selectDeclineReasonEntitiesByIds,
} from './decline-reason-record.generated';
import {
  DeclineSecondaryReasonRecord,
  selectDeclineSecondaryReasonById,
  selectDeclineSecondaryReasonEntitiesByIds,
} from './decline-secondary-reason-record.generated';
import {
  DiversionReasonRecord,
  selectDiversionReasonById,
  selectDiversionReasonEntitiesByIds,
} from './diversion-reason-record.generated';
import {
  EscortRequestRecord,
  selectEscortRequestById,
  selectEscortRequestEntitiesByIds,
} from './escort-request-record.generated';
import {
  EstimatedDurationRecord,
  selectEstimatedDurationById,
  selectEstimatedDurationEntitiesByIds,
} from './estimated-duration-record.generated';
import { EtaRecord, selectEtaById, selectEtaEntitiesByIds } from './eta-record.generated';
import {
  ExternalActionRecord,
  selectExternalActionById,
  selectExternalActionEntitiesByIds,
} from './external-action-record.generated';
import {
  ExternalActionTypeRecord,
  selectExternalActionTypeById,
  selectExternalActionTypeEntitiesByIds,
} from './external-action-type-record.generated';
import {
  ExternalSystemUnitRecord,
  selectExternalSystemUnitById,
  selectExternalSystemUnitEntitiesByIds,
} from './external-system-unit-record.generated';
import {
  FacilityNonAcceptanceReasonRecord,
  selectFacilityNonAcceptanceReasonById,
  selectFacilityNonAcceptanceReasonEntitiesByIds,
} from './facility-non-acceptance-reason-record.generated';
import {
  FirewallRuleRecord,
  selectFirewallRuleById,
  selectFirewallRuleEntitiesByIds,
} from './firewall-rule-record.generated';
import {
  FlightFollowingReportRecord,
  selectFlightFollowingReportById,
  selectFlightFollowingReportEntitiesByIds,
} from './flight-following-report-record.generated';
import {
  LandingZoneOutOfServiceReasonRecord,
  selectLandingZoneOutOfServiceReasonById,
  selectLandingZoneOutOfServiceReasonEntitiesByIds,
} from './landing-zone-out-of-service-reason-record.generated';
import {
  LocationHazardAttachmentRecord,
  selectLocationHazardAttachmentById,
  selectLocationHazardAttachmentEntitiesByIds,
} from './location-hazard-attachment-record.generated';
import {
  LocationHazardRecord,
  selectLocationHazardById,
  selectLocationHazardEntitiesByIds,
} from './location-hazard-record.generated';
import {
  ManifestEntryRecord,
  selectManifestEntryById,
  selectManifestEntryEntitiesByIds,
} from './manifest-entry-record.generated';
import {
  MedicalControlContactLogEntryRecord,
  selectMedicalControlContactLogEntryById,
  selectMedicalControlContactLogEntryEntitiesByIds,
} from './medical-control-contact-log-entry-record.generated';
import {
  MessageStatusUpdateRecord,
  selectMessageStatusUpdateById,
  selectMessageStatusUpdateEntitiesByIds,
} from './message-status-update-record.generated';
import {
  NewAgencyLocationRequestRecord,
  selectNewAgencyLocationRequestById,
  selectNewAgencyLocationRequestEntitiesByIds,
} from './new-agency-location-request-record.generated';
import {
  NextDueTypeRecord,
  selectNextDueTypeById,
  selectNextDueTypeEntitiesByIds,
} from './next-due-type-record.generated';
import {
  NonReferralReasonRecord,
  selectNonReferralReasonById,
  selectNonReferralReasonEntitiesByIds,
} from './non-referral-reason-record.generated';
import {
  NotificationRecord,
  selectNotificationById,
  selectNotificationEntitiesByIds,
} from './notification-record.generated';
import {
  NotificationGroupRecord,
  selectNotificationGroupById,
  selectNotificationGroupEntitiesByIds,
} from './notification-group-record.generated';
import {
  NotificationGroupMemberRecord,
  selectNotificationGroupMemberById,
  selectNotificationGroupMemberEntitiesByIds,
} from './notification-group-member-record.generated';
import {
  NotificationRecipientRecord,
  selectNotificationRecipientById,
  selectNotificationRecipientEntitiesByIds,
} from './notification-recipient-record.generated';
import {
  NotificationSubscriptionRecord,
  selectNotificationSubscriptionById,
  selectNotificationSubscriptionEntitiesByIds,
} from './notification-subscription-record.generated';
import {
  NotificationTemplateRecord,
  selectNotificationTemplateById,
  selectNotificationTemplateEntitiesByIds,
} from './notification-template-record.generated';
import {
  OemActivityRecord,
  selectOemActivityById,
  selectOemActivityEntitiesByIds,
} from './oem-activity-record.generated';
import {
  OemAssetRecord,
  selectOemAssetById,
  selectOemAssetEntitiesByIds,
} from './oem-asset-record.generated';
import {
  OemPlanChangeRequestRecord,
  selectOemPlanChangeRequestById,
  selectOemPlanChangeRequestEntitiesByIds,
} from './oem-plan-change-request-record.generated';
import {
  OemPlanRecord,
  selectOemPlanById,
  selectOemPlanEntitiesByIds,
} from './oem-plan-record.generated';
import {
  OfferAlgorithmRecord,
  selectOfferAlgorithmById,
  selectOfferAlgorithmEntitiesByIds,
} from './offer-algorithm-record.generated';
import {
  OperationRecord,
  selectOperationById,
  selectOperationEntitiesByIds,
} from './operation-record.generated';
import {
  OutOfServiceEventRecord,
  selectOutOfServiceEventById,
  selectOutOfServiceEventEntitiesByIds,
} from './out-of-service-event-record.generated';
import {
  OutOfServiceEventNoteRecord,
  selectOutOfServiceEventNoteById,
  selectOutOfServiceEventNoteEntitiesByIds,
} from './out-of-service-event-note-record.generated';
import {
  OutOfServiceReasonRecord,
  selectOutOfServiceReasonById,
  selectOutOfServiceReasonEntitiesByIds,
} from './out-of-service-reason-record.generated';
import {
  OutOfServiceSecondaryReasonRecord,
  selectOutOfServiceSecondaryReasonById,
  selectOutOfServiceSecondaryReasonEntitiesByIds,
} from './out-of-service-secondary-reason-record.generated';
import {
  OutOfServiceTicketRecord,
  selectOutOfServiceTicketById,
  selectOutOfServiceTicketEntitiesByIds,
} from './out-of-service-ticket-record.generated';
import {
  PaipEventRecord,
  selectPaipEventById,
  selectPaipEventEntitiesByIds,
} from './paip-event-record.generated';
import {
  PaipReasonRecord,
  selectPaipReasonById,
  selectPaipReasonEntitiesByIds,
} from './paip-reason-record.generated';
import {
  PassdownLogAcknowledgementRecord,
  selectPassdownLogAcknowledgementById,
  selectPassdownLogAcknowledgementEntitiesByIds,
} from './passdown-log-acknowledgement-record.generated';
import {
  PassdownLogArchivedLogRecord,
  selectPassdownLogArchivedLogById,
  selectPassdownLogArchivedLogEntitiesByIds,
} from './passdown-log-archived-log-record.generated';
import {
  PassdownLogRecord,
  selectPassdownLogById,
  selectPassdownLogEntitiesByIds,
} from './passdown-log-record.generated';
import {
  PatientRecord,
  selectPatientById,
  selectPatientEntitiesByIds,
} from './patient-record.generated';
import {
  PositionReportAlertRecord,
  selectPositionReportAlertById,
  selectPositionReportAlertEntitiesByIds,
} from './position-report-alert-record.generated';
import {
  PositionReportArchiveRecord,
  selectPositionReportArchiveById,
  selectPositionReportArchiveEntitiesByIds,
} from './position-report-archive-record.generated';
import {
  PositionReportRecord,
  selectPositionReportById,
  selectPositionReportEntitiesByIds,
} from './position-report-record.generated';
import {
  QuestionChoiceRecord,
  selectQuestionChoiceById,
  selectQuestionChoiceEntitiesByIds,
} from './question-choice-record.generated';
import {
  QuestionRecord,
  selectQuestionById,
  selectQuestionEntitiesByIds,
} from './question-record.generated';
import {
  QuestionnaireRecord,
  selectQuestionnaireById,
  selectQuestionnaireEntitiesByIds,
} from './questionnaire-record.generated';
import {
  QuestionnaireQuestionResponseRecord,
  selectQuestionnaireQuestionResponseById,
  selectQuestionnaireQuestionResponseEntitiesByIds,
} from './questionnaire-question-response-record.generated';
import {
  QuestionnaireQuestionResponseNoteRecord,
  selectQuestionnaireQuestionResponseNoteById,
  selectQuestionnaireQuestionResponseNoteEntitiesByIds,
} from './questionnaire-question-response-note-record.generated';
import {
  QuestionnaireResponseRecord,
  selectQuestionnaireResponseById,
  selectQuestionnaireResponseEntitiesByIds,
} from './questionnaire-response-record.generated';
import {
  QuestionnaireSectionRecord,
  selectQuestionnaireSectionById,
  selectQuestionnaireSectionEntitiesByIds,
} from './questionnaire-section-record.generated';
import {
  QuestionnaireSectionQuestionRecord,
  selectQuestionnaireSectionQuestionById,
  selectQuestionnaireSectionQuestionEntitiesByIds,
} from './questionnaire-section-question-record.generated';
import {
  ReceivingFacilityRequestRecord,
  selectReceivingFacilityRequestById,
  selectReceivingFacilityRequestEntitiesByIds,
} from './receiving-facility-request-record.generated';
import {
  RendezvousRequestRecord,
  selectRendezvousRequestById,
  selectRendezvousRequestEntitiesByIds,
} from './rendezvous-request-record.generated';
import {
  RequestRecord,
  selectRequestById,
  selectRequestEntitiesByIds,
} from './request-record.generated';
import {
  RequesterRecord,
  selectRequesterById,
  selectRequesterEntitiesByIds,
} from './requester-record.generated';
import {
  RequesterReferralReasonRecord,
  selectRequesterReferralReasonById,
  selectRequesterReferralReasonEntitiesByIds,
} from './requester-referral-reason-record.generated';
import {
  RequesterRoleRecord,
  selectRequesterRoleById,
  selectRequesterRoleEntitiesByIds,
} from './requester-role-record.generated';
import {
  RequestLocationRecord,
  selectRequestLocationById,
  selectRequestLocationEntitiesByIds,
} from './request-location-record.generated';
import {
  RequestPatientRecord,
  selectRequestPatientById,
  selectRequestPatientEntitiesByIds,
} from './request-patient-record.generated';
import {
  SystemTimerRecord,
  selectSystemTimerById,
  selectSystemTimerEntitiesByIds,
} from './system-timer-record.generated';
import {
  TimelineRecord,
  selectTimelineById,
  selectTimelineEntitiesByIds,
} from './timeline-record.generated';
import {
  TimelineItemRecord,
  selectTimelineItemById,
  selectTimelineItemEntitiesByIds,
} from './timeline-item-record.generated';
import {
  TimestampRecord,
  selectTimestampById,
  selectTimestampEntitiesByIds,
} from './timestamp-record.generated';
import {
  TimestampTypeRecord,
  selectTimestampTypeById,
  selectTimestampTypeEntitiesByIds,
} from './timestamp-type-record.generated';
import {
  TrackedMessageRecord,
  selectTrackedMessageById,
  selectTrackedMessageEntitiesByIds,
} from './tracked-message-record.generated';
import {
  TransferReasonRecord,
  selectTransferReasonById,
  selectTransferReasonEntitiesByIds,
} from './transfer-reason-record.generated';
import {
  TransportOfferRecord,
  selectTransportOfferById,
  selectTransportOfferEntitiesByIds,
} from './transport-offer-record.generated';
import {
  TransportOfferOptionRecord,
  selectTransportOfferOptionById,
  selectTransportOfferOptionEntitiesByIds,
} from './transport-offer-option-record.generated';
import {
  TransportReasonRecord,
  selectTransportReasonById,
  selectTransportReasonEntitiesByIds,
} from './transport-reason-record.generated';
import { TripRecord, selectTripById, selectTripEntitiesByIds } from './trip-record.generated';
import {
  TripLegRecord,
  selectTripLegById,
  selectTripLegEntitiesByIds,
} from './trip-leg-record.generated';
import {
  TripPassengerRecord,
  selectTripPassengerById,
  selectTripPassengerEntitiesByIds,
} from './trip-passenger-record.generated';
import {
  UnitActivationRuleRecord,
  selectUnitActivationRuleById,
  selectUnitActivationRuleEntitiesByIds,
} from './unit-activation-rule-record.generated';
import {
  UnitEMSystemMappingRecord,
  selectUnitEMSystemMappingById,
  selectUnitEMSystemMappingEntitiesByIds,
} from './unit-em-system-mapping-record.generated';
import { UnitRecord, selectUnitById, selectUnitEntitiesByIds } from './unit-record.generated';
import {
  UnitNoteRecord,
  selectUnitNoteById,
  selectUnitNoteEntitiesByIds,
} from './unit-note-record.generated';
import {
  UnitPositionRecord,
  selectUnitPositionById,
  selectUnitPositionEntitiesByIds,
} from './unit-position-record.generated';
import {
  UnitShiftRecord,
  selectUnitShiftById,
  selectUnitShiftEntitiesByIds,
} from './unit-shift-record.generated';
import {
  UnitStatusHistoryEntryRecord,
  selectUnitStatusHistoryEntryById,
  selectUnitStatusHistoryEntryEntitiesByIds,
} from './unit-status-history-entry-record.generated';
import {
  UnitSummaryRecord,
  selectUnitSummaryById,
  selectUnitSummaryEntitiesByIds,
} from './unit-summary-record.generated';
import {
  VehicleDispositionRecord,
  selectVehicleDispositionById,
  selectVehicleDispositionEntitiesByIds,
} from './vehicle-disposition-record.generated';
import {
  VehicleNotificationGroupRecord,
  selectVehicleNotificationGroupById,
  selectVehicleNotificationGroupEntitiesByIds,
} from './vehicle-notification-group-record.generated';
import {
  VehicleSummaryRecord,
  selectVehicleSummaryById,
  selectVehicleSummaryEntitiesByIds,
} from './vehicle-summary-record.generated';
import {
  WaypointRecord,
  selectWaypointById,
  selectWaypointEntitiesByIds,
} from './waypoint-record.generated';
import {
  WebOrderLogRecord,
  selectWebOrderLogById,
  selectWebOrderLogEntitiesByIds,
} from './web-order-log-record.generated';
import {
  AccessibleItemRecord,
  selectAccessibleItemById,
  selectAccessibleItemEntitiesByIds,
} from './accessible-item-record.generated';
import {
  AgencyRecord,
  selectAgencyById,
  selectAgencyEntitiesByIds,
} from './agency-record.generated';
import {
  AgencyLocationRecord,
  selectAgencyLocationById,
  selectAgencyLocationEntitiesByIds,
} from './agency-location-record.generated';
import {
  AirportRecord,
  selectAirportById,
  selectAirportEntitiesByIds,
} from './airport-record.generated';
import {
  ArchiveLogRecord,
  selectArchiveLogById,
  selectArchiveLogEntitiesByIds,
} from './archive-log-record.generated';
import {
  AttachmentRecord,
  selectAttachmentById,
  selectAttachmentEntitiesByIds,
} from './attachment-record.generated';
import {
  BaseControlZoneRecord,
  selectBaseControlZoneById,
  selectBaseControlZoneEntitiesByIds,
} from './base-control-zone-record.generated';
import { BaseRecord, selectBaseById, selectBaseEntitiesByIds } from './base-record.generated';
import {
  BaseMedicalControlContactRecord,
  selectBaseMedicalControlContactById,
  selectBaseMedicalControlContactEntitiesByIds,
} from './base-medical-control-contact-record.generated';
import {
  BaseMedicalControlContactStateRecord,
  selectBaseMedicalControlContactStateById,
  selectBaseMedicalControlContactStateEntitiesByIds,
} from './base-medical-control-contact-state-record.generated';
import {
  CapabilityRecord,
  selectCapabilityById,
  selectCapabilityEntitiesByIds,
} from './capability-record.generated';
import {
  CommunicationCenterRecord,
  selectCommunicationCenterById,
  selectCommunicationCenterEntitiesByIds,
} from './communication-center-record.generated';
import {
  CommunicationCenterTransportOfferOptionRecord,
  selectCommunicationCenterTransportOfferOptionById,
  selectCommunicationCenterTransportOfferOptionEntitiesByIds,
} from './communication-center-transport-offer-option-record.generated';
import {
  CompanyRecord,
  selectCompanyById,
  selectCompanyEntitiesByIds,
} from './company-record.generated';
import {
  CompleteFlightInstanceRecord,
  selectCompleteFlightInstanceById,
  selectCompleteFlightInstanceEntitiesByIds,
} from './complete-flight-instance-record.generated';
import {
  ControlZoneRecord,
  selectControlZoneById,
  selectControlZoneEntitiesByIds,
} from './control-zone-record.generated';
import {
  DepartmentRecord,
  selectDepartmentById,
  selectDepartmentEntitiesByIds,
} from './department-record.generated';
import {
  EntityCapabilityRecord,
  selectEntityCapabilityById,
  selectEntityCapabilityEntitiesByIds,
} from './entity-capability-record.generated';
import {
  ExternalReferenceRecord,
  selectExternalReferenceById,
  selectExternalReferenceEntitiesByIds,
} from './external-reference-record.generated';
import { FboRecord, selectFboById, selectFboEntitiesByIds } from './fbo-record.generated';
import {
  FuelTankRecord,
  selectFuelTankById,
  selectFuelTankEntitiesByIds,
} from './fuel-tank-record.generated';
import {
  LocationRecord,
  selectLocationById,
  selectLocationEntitiesByIds,
} from './location-record.generated';
import {
  MaintenanceFacilityRecord,
  selectMaintenanceFacilityById,
  selectMaintenanceFacilityEntitiesByIds,
} from './maintenance-facility-record.generated';
import {
  MedicalFacilityContactRecord,
  selectMedicalFacilityContactById,
  selectMedicalFacilityContactEntitiesByIds,
} from './medical-facility-contact-record.generated';
import {
  MedicalFacilityRecord,
  selectMedicalFacilityById,
  selectMedicalFacilityEntitiesByIds,
} from './medical-facility-record.generated';
import {
  MedicalFacilityPhysicianRecord,
  selectMedicalFacilityPhysicianById,
  selectMedicalFacilityPhysicianEntitiesByIds,
} from './medical-facility-physician-record.generated';
import {
  MedicalFacilityUnitRecord,
  selectMedicalFacilityUnitById,
  selectMedicalFacilityUnitEntitiesByIds,
} from './medical-facility-unit-record.generated';
import {
  MedicalUnitRecord,
  selectMedicalUnitById,
  selectMedicalUnitEntitiesByIds,
} from './medical-unit-record.generated';
import {
  OutOfServiceQARReasonRecord,
  selectOutOfServiceQARReasonById,
  selectOutOfServiceQARReasonEntitiesByIds,
} from './out-of-service-qar-reason-record.generated';
import {
  PersonRecord,
  selectPersonById,
  selectPersonEntitiesByIds,
} from './person-record.generated';
import {
  PhysicianRecord,
  selectPhysicianById,
  selectPhysicianEntitiesByIds,
} from './physician-record.generated';
import {
  ProgramBaseRecord,
  selectProgramBaseById,
  selectProgramBaseEntitiesByIds,
} from './program-base-record.generated';
import {
  ProgramRecord,
  selectProgramById,
  selectProgramEntitiesByIds,
} from './program-record.generated';
import {
  RamcoVehicleConfigurationRecord,
  selectRamcoVehicleConfigurationById,
  selectRamcoVehicleConfigurationEntitiesByIds,
} from './ramco-vehicle-configuration-record.generated';
import {
  RegionBaseRecord,
  selectRegionBaseById,
  selectRegionBaseEntitiesByIds,
} from './region-base-record.generated';
import {
  RegionRecord,
  selectRegionById,
  selectRegionEntitiesByIds,
} from './region-record.generated';
import {
  RegionGroupRecord,
  selectRegionGroupById,
  selectRegionGroupEntitiesByIds,
} from './region-group-record.generated';
import {
  ReleaseNoteRecord,
  selectReleaseNoteById,
  selectReleaseNoteEntitiesByIds,
} from './release-note-record.generated';
import {
  SpecialtyTeamRecord,
  selectSpecialtyTeamById,
  selectSpecialtyTeamEntitiesByIds,
} from './specialty-team-record.generated';
import {
  SpecialtyTeamMemberRecord,
  selectSpecialtyTeamMemberById,
  selectSpecialtyTeamMemberEntitiesByIds,
} from './specialty-team-member-record.generated';
import { StateRecord, selectStateById, selectStateEntitiesByIds } from './state-record.generated';
import {
  SupportRequestRecord,
  selectSupportRequestById,
  selectSupportRequestEntitiesByIds,
} from './support-request-record.generated';
import {
  TimezoneRecord,
  selectTimezoneById,
  selectTimezoneEntitiesByIds,
} from './timezone-record.generated';
import {
  TransferCenterRecord,
  selectTransferCenterById,
  selectTransferCenterEntitiesByIds,
} from './transfer-center-record.generated';
import {
  TrmUserAgencyRecord,
  selectTrmUserAgencyById,
  selectTrmUserAgencyEntitiesByIds,
} from './trm-user-agency-record.generated';
import {
  TrmUserRecord,
  selectTrmUserById,
  selectTrmUserEntitiesByIds,
} from './trm-user-record.generated';
import {
  TrmUserMedicalFacilityRecord,
  selectTrmUserMedicalFacilityById,
  selectTrmUserMedicalFacilityEntitiesByIds,
} from './trm-user-medical-facility-record.generated';
import {
  TrmUserProgramRecord,
  selectTrmUserProgramById,
  selectTrmUserProgramEntitiesByIds,
} from './trm-user-program-record.generated';
import {
  VehicleControlZoneRecord,
  selectVehicleControlZoneById,
  selectVehicleControlZoneEntitiesByIds,
} from './vehicle-control-zone-record.generated';
import {
  VehicleRecord,
  selectVehicleById,
  selectVehicleEntitiesByIds,
} from './vehicle-record.generated';
import {
  VehicleMaintenanceRecord,
  selectVehicleMaintenanceById,
  selectVehicleMaintenanceEntitiesByIds,
} from './vehicle-maintenance-record.generated';
import {
  VehicleMakeRecord,
  selectVehicleMakeById,
  selectVehicleMakeEntitiesByIds,
} from './vehicle-make-record.generated';
import {
  VehicleModelRecord,
  selectVehicleModelById,
  selectVehicleModelEntitiesByIds,
} from './vehicle-model-record.generated';
import {
  VehicleStateInspectionRecord,
  selectVehicleStateInspectionById,
  selectVehicleStateInspectionEntitiesByIds,
} from './vehicle-state-inspection-record.generated';
import {
  ActiveCardUnitOfferingRecord,
  selectActiveCardUnitOfferingById,
  selectActiveCardUnitOfferingEntitiesByIds,
} from './active-card-unit-offering-record.generated';
import {
  VehiclePositionSummaryRecord,
  selectVehiclePositionSummaryById,
  selectVehiclePositionSummaryEntitiesByIds,
} from './vehicle-position-summary-record.generated';
import {
  FetchActivationRuleByIdGQL,
  FetchActivationRuleByIdsGQL,
  FetchActiveAlertAcknowledgementByIdGQL,
  FetchActiveAlertAcknowledgementByIdsGQL,
  FetchActiveAlertByIdGQL,
  FetchActiveAlertByIdsGQL,
  FetchActiveTimelineByIdGQL,
  FetchActiveTimelineByIdsGQL,
  FetchAlertByIdGQL,
  FetchAlertByIdsGQL,
  FetchApplicationNotificationByIdGQL,
  FetchApplicationNotificationByIdsGQL,
  FetchAssignmentDelayedReasonByIdGQL,
  FetchAssignmentDelayedReasonByIdsGQL,
  FetchCancellationCategoryByIdGQL,
  FetchCancellationCategoryByIdsGQL,
  FetchCancellationReasonByIdGQL,
  FetchCancellationReasonByIdsGQL,
  FetchCancellationSecondaryReasonByIdGQL,
  FetchCancellationSecondaryReasonByIdsGQL,
  FetchCardByIdGQL,
  FetchCardByIdsGQL,
  FetchCardLinkByIdGQL,
  FetchCardLinkByIdsGQL,
  FetchCardNoteArchiveByIdGQL,
  FetchCardNoteArchiveByIdsGQL,
  FetchCardNoteByIdGQL,
  FetchCardNoteByIdsGQL,
  FetchCardReOpenReasonByIdGQL,
  FetchCardReOpenReasonByIdsGQL,
  FetchCardSummaryByIdGQL,
  FetchCardSummaryByIdsGQL,
  FetchConfigurationSettingByIdGQL,
  FetchConfigurationSettingByIdsGQL,
  FetchConversationByIdGQL,
  FetchConversationByIdsGQL,
  FetchConversationParticipantByIdGQL,
  FetchConversationParticipantByIdsGQL,
  FetchDeclineCategoryByIdGQL,
  FetchDeclineCategoryByIdsGQL,
  FetchDeclineReasonByIdGQL,
  FetchDeclineReasonByIdsGQL,
  FetchDeclineSecondaryReasonByIdGQL,
  FetchDeclineSecondaryReasonByIdsGQL,
  FetchDiversionReasonByIdGQL,
  FetchDiversionReasonByIdsGQL,
  FetchEscortRequestByIdGQL,
  FetchEscortRequestByIdsGQL,
  FetchEstimatedDurationByIdGQL,
  FetchEstimatedDurationByIdsGQL,
  FetchEtaByIdGQL,
  FetchEtaByIdsGQL,
  FetchExternalActionByIdGQL,
  FetchExternalActionByIdsGQL,
  FetchExternalActionTypeByIdGQL,
  FetchExternalActionTypeByIdsGQL,
  FetchExternalSystemUnitByIdGQL,
  FetchExternalSystemUnitByIdsGQL,
  FetchFacilityNonAcceptanceReasonByIdGQL,
  FetchFacilityNonAcceptanceReasonByIdsGQL,
  FetchFirewallRuleByIdGQL,
  FetchFirewallRuleByIdsGQL,
  FetchFlightFollowingReportByIdGQL,
  FetchFlightFollowingReportByIdsGQL,
  FetchLandingZoneOutOfServiceReasonByIdGQL,
  FetchLandingZoneOutOfServiceReasonByIdsGQL,
  FetchLocationHazardAttachmentByIdGQL,
  FetchLocationHazardAttachmentByIdsGQL,
  FetchLocationHazardByIdGQL,
  FetchLocationHazardByIdsGQL,
  FetchManifestEntryByIdGQL,
  FetchManifestEntryByIdsGQL,
  FetchMedicalControlContactLogEntryByIdGQL,
  FetchMedicalControlContactLogEntryByIdsGQL,
  FetchMessageStatusUpdateByIdGQL,
  FetchMessageStatusUpdateByIdsGQL,
  FetchNewAgencyLocationRequestByIdGQL,
  FetchNewAgencyLocationRequestByIdsGQL,
  FetchNextDueTypeByIdGQL,
  FetchNextDueTypeByIdsGQL,
  FetchNonReferralReasonByIdGQL,
  FetchNonReferralReasonByIdsGQL,
  FetchNotificationByIdGQL,
  FetchNotificationByIdsGQL,
  FetchNotificationGroupByIdGQL,
  FetchNotificationGroupByIdsGQL,
  FetchNotificationGroupMemberByIdGQL,
  FetchNotificationGroupMemberByIdsGQL,
  FetchNotificationRecipientByIdGQL,
  FetchNotificationRecipientByIdsGQL,
  FetchNotificationSubscriptionByIdGQL,
  FetchNotificationSubscriptionByIdsGQL,
  FetchNotificationTemplateByIdGQL,
  FetchNotificationTemplateByIdsGQL,
  FetchOemActivityByIdGQL,
  FetchOemActivityByIdsGQL,
  FetchOemAssetByIdGQL,
  FetchOemAssetByIdsGQL,
  FetchOemPlanChangeRequestByIdGQL,
  FetchOemPlanChangeRequestByIdsGQL,
  FetchOemPlanByIdGQL,
  FetchOemPlanByIdsGQL,
  FetchOfferAlgorithmByIdGQL,
  FetchOfferAlgorithmByIdsGQL,
  FetchOperationByIdGQL,
  FetchOperationByIdsGQL,
  FetchOutOfServiceEventByIdGQL,
  FetchOutOfServiceEventByIdsGQL,
  FetchOutOfServiceEventNoteByIdGQL,
  FetchOutOfServiceEventNoteByIdsGQL,
  FetchOutOfServiceReasonByIdGQL,
  FetchOutOfServiceReasonByIdsGQL,
  FetchOutOfServiceSecondaryReasonByIdGQL,
  FetchOutOfServiceSecondaryReasonByIdsGQL,
  FetchOutOfServiceTicketByIdGQL,
  FetchOutOfServiceTicketByIdsGQL,
  FetchPaipEventByIdGQL,
  FetchPaipEventByIdsGQL,
  FetchPaipReasonByIdGQL,
  FetchPaipReasonByIdsGQL,
  FetchPassdownLogAcknowledgementByIdGQL,
  FetchPassdownLogAcknowledgementByIdsGQL,
  FetchPassdownLogArchivedLogByIdGQL,
  FetchPassdownLogArchivedLogByIdsGQL,
  FetchPassdownLogByIdGQL,
  FetchPassdownLogByIdsGQL,
  FetchPatientByIdGQL,
  FetchPatientByIdsGQL,
  FetchPositionReportAlertByIdGQL,
  FetchPositionReportAlertByIdsGQL,
  FetchPositionReportArchiveByIdGQL,
  FetchPositionReportArchiveByIdsGQL,
  FetchPositionReportByIdGQL,
  FetchPositionReportByIdsGQL,
  FetchQuestionChoiceByIdGQL,
  FetchQuestionChoiceByIdsGQL,
  FetchQuestionByIdGQL,
  FetchQuestionByIdsGQL,
  FetchQuestionnaireByIdGQL,
  FetchQuestionnaireByIdsGQL,
  FetchQuestionnaireQuestionResponseByIdGQL,
  FetchQuestionnaireQuestionResponseByIdsGQL,
  FetchQuestionnaireQuestionResponseNoteByIdGQL,
  FetchQuestionnaireQuestionResponseNoteByIdsGQL,
  FetchQuestionnaireResponseByIdGQL,
  FetchQuestionnaireResponseByIdsGQL,
  FetchQuestionnaireSectionByIdGQL,
  FetchQuestionnaireSectionByIdsGQL,
  FetchQuestionnaireSectionQuestionByIdGQL,
  FetchQuestionnaireSectionQuestionByIdsGQL,
  FetchReceivingFacilityRequestByIdGQL,
  FetchReceivingFacilityRequestByIdsGQL,
  FetchRendezvousRequestByIdGQL,
  FetchRendezvousRequestByIdsGQL,
  FetchRequestByIdGQL,
  FetchRequestByIdsGQL,
  FetchRequesterByIdGQL,
  FetchRequesterByIdsGQL,
  FetchRequesterReferralReasonByIdGQL,
  FetchRequesterReferralReasonByIdsGQL,
  FetchRequesterRoleByIdGQL,
  FetchRequesterRoleByIdsGQL,
  FetchRequestLocationByIdGQL,
  FetchRequestLocationByIdsGQL,
  FetchRequestPatientByIdGQL,
  FetchRequestPatientByIdsGQL,
  FetchSystemTimerByIdGQL,
  FetchSystemTimerByIdsGQL,
  FetchTimelineByIdGQL,
  FetchTimelineByIdsGQL,
  FetchTimelineItemByIdGQL,
  FetchTimelineItemByIdsGQL,
  FetchTimestampByIdGQL,
  FetchTimestampByIdsGQL,
  FetchTimestampTypeByIdGQL,
  FetchTimestampTypeByIdsGQL,
  FetchTrackedMessageByIdGQL,
  FetchTrackedMessageByIdsGQL,
  FetchTransferReasonByIdGQL,
  FetchTransferReasonByIdsGQL,
  FetchTransportOfferByIdGQL,
  FetchTransportOfferByIdsGQL,
  FetchTransportOfferOptionByIdGQL,
  FetchTransportOfferOptionByIdsGQL,
  FetchTransportReasonByIdGQL,
  FetchTransportReasonByIdsGQL,
  FetchTripByIdGQL,
  FetchTripByIdsGQL,
  FetchTripLegByIdGQL,
  FetchTripLegByIdsGQL,
  FetchTripPassengerByIdGQL,
  FetchTripPassengerByIdsGQL,
  FetchUnitActivationRuleByIdGQL,
  FetchUnitActivationRuleByIdsGQL,
  FetchUnitEMSystemMappingByIdGQL,
  FetchUnitEMSystemMappingByIdsGQL,
  FetchUnitByIdGQL,
  FetchUnitByIdsGQL,
  FetchUnitNoteByIdGQL,
  FetchUnitNoteByIdsGQL,
  FetchUnitPositionByIdGQL,
  FetchUnitPositionByIdsGQL,
  FetchUnitShiftByIdGQL,
  FetchUnitShiftByIdsGQL,
  FetchUnitStatusHistoryEntryByIdGQL,
  FetchUnitStatusHistoryEntryByIdsGQL,
  FetchUnitSummaryByIdGQL,
  FetchUnitSummaryByIdsGQL,
  FetchVehicleDispositionByIdGQL,
  FetchVehicleDispositionByIdsGQL,
  FetchVehicleNotificationGroupByIdGQL,
  FetchVehicleNotificationGroupByIdsGQL,
  FetchVehicleSummaryByIdGQL,
  FetchVehicleSummaryByIdsGQL,
  FetchWaypointByIdGQL,
  FetchWaypointByIdsGQL,
  FetchWebOrderLogByIdGQL,
  FetchWebOrderLogByIdsGQL,
  FetchAccessibleItemByIdGQL,
  FetchAccessibleItemByIdsGQL,
  FetchAgencyByIdGQL,
  FetchAgencyByIdsGQL,
  FetchAgencyLocationByIdGQL,
  FetchAgencyLocationByIdsGQL,
  FetchAirportByIdGQL,
  FetchAirportByIdsGQL,
  FetchArchiveLogByIdGQL,
  FetchArchiveLogByIdsGQL,
  FetchAttachmentByIdGQL,
  FetchAttachmentByIdsGQL,
  FetchBaseControlZoneByIdGQL,
  FetchBaseControlZoneByIdsGQL,
  FetchBaseByIdGQL,
  FetchBaseByIdsGQL,
  FetchBaseMedicalControlContactByIdGQL,
  FetchBaseMedicalControlContactByIdsGQL,
  FetchBaseMedicalControlContactStateByIdGQL,
  FetchBaseMedicalControlContactStateByIdsGQL,
  FetchCapabilityByIdGQL,
  FetchCapabilityByIdsGQL,
  FetchCommunicationCenterByIdGQL,
  FetchCommunicationCenterByIdsGQL,
  FetchCommunicationCenterTransportOfferOptionByIdGQL,
  FetchCommunicationCenterTransportOfferOptionByIdsGQL,
  FetchCompanyByIdGQL,
  FetchCompanyByIdsGQL,
  FetchCompleteFlightInstanceByIdGQL,
  FetchCompleteFlightInstanceByIdsGQL,
  FetchControlZoneByIdGQL,
  FetchControlZoneByIdsGQL,
  FetchDepartmentByIdGQL,
  FetchDepartmentByIdsGQL,
  FetchEntityCapabilityByIdGQL,
  FetchEntityCapabilityByIdsGQL,
  FetchExternalReferenceByIdGQL,
  FetchExternalReferenceByIdsGQL,
  FetchFboByIdGQL,
  FetchFboByIdsGQL,
  FetchFuelTankByIdGQL,
  FetchFuelTankByIdsGQL,
  FetchLocationByIdGQL,
  FetchLocationByIdsGQL,
  FetchMaintenanceFacilityByIdGQL,
  FetchMaintenanceFacilityByIdsGQL,
  FetchMedicalFacilityContactByIdGQL,
  FetchMedicalFacilityContactByIdsGQL,
  FetchMedicalFacilityByIdGQL,
  FetchMedicalFacilityByIdsGQL,
  FetchMedicalFacilityPhysicianByIdGQL,
  FetchMedicalFacilityPhysicianByIdsGQL,
  FetchMedicalFacilityUnitByIdGQL,
  FetchMedicalFacilityUnitByIdsGQL,
  FetchMedicalUnitByIdGQL,
  FetchMedicalUnitByIdsGQL,
  FetchOutOfServiceQARReasonByIdGQL,
  FetchOutOfServiceQARReasonByIdsGQL,
  FetchPersonByIdGQL,
  FetchPersonByIdsGQL,
  FetchPhysicianByIdGQL,
  FetchPhysicianByIdsGQL,
  FetchProgramBaseByIdGQL,
  FetchProgramBaseByIdsGQL,
  FetchProgramByIdGQL,
  FetchProgramByIdsGQL,
  FetchRamcoVehicleConfigurationByIdGQL,
  FetchRamcoVehicleConfigurationByIdsGQL,
  FetchRegionBaseByIdGQL,
  FetchRegionBaseByIdsGQL,
  FetchRegionByIdGQL,
  FetchRegionByIdsGQL,
  FetchRegionGroupByIdGQL,
  FetchRegionGroupByIdsGQL,
  FetchReleaseNoteByIdGQL,
  FetchReleaseNoteByIdsGQL,
  FetchSpecialtyTeamByIdGQL,
  FetchSpecialtyTeamByIdsGQL,
  FetchSpecialtyTeamMemberByIdGQL,
  FetchSpecialtyTeamMemberByIdsGQL,
  FetchStateByIdGQL,
  FetchStateByIdsGQL,
  FetchSupportRequestByIdGQL,
  FetchSupportRequestByIdsGQL,
  FetchTimezoneByIdGQL,
  FetchTimezoneByIdsGQL,
  FetchTransferCenterByIdGQL,
  FetchTransferCenterByIdsGQL,
  FetchTrmUserAgencyByIdGQL,
  FetchTrmUserAgencyByIdsGQL,
  FetchTrmUserByIdGQL,
  FetchTrmUserByIdsGQL,
  FetchTrmUserMedicalFacilityByIdGQL,
  FetchTrmUserMedicalFacilityByIdsGQL,
  FetchTrmUserProgramByIdGQL,
  FetchTrmUserProgramByIdsGQL,
  FetchVehicleControlZoneByIdGQL,
  FetchVehicleControlZoneByIdsGQL,
  FetchVehicleByIdGQL,
  FetchVehicleByIdsGQL,
  FetchVehicleMaintenanceByIdGQL,
  FetchVehicleMaintenanceByIdsGQL,
  FetchVehicleMakeByIdGQL,
  FetchVehicleMakeByIdsGQL,
  FetchVehicleModelByIdGQL,
  FetchVehicleModelByIdsGQL,
  FetchVehicleStateInspectionByIdGQL,
  FetchVehicleStateInspectionByIdsGQL,
  FetchActiveCardUnitOfferingByIdGQL,
  FetchActiveCardUnitOfferingByIdsGQL,
  FetchVehiclePositionSummaryByIdGQL,
  FetchVehiclePositionSummaryByIdsGQL,
} from 'src/graphql/generated/graphql.generated';

import { Injectable } from '@angular/core';
import { ClientSyncFetchService } from 'src/store/fetch-services';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { StoreService } from 'src/store/store.service';

export type TcsEntityRecord =
  | ActivationRuleRecord
  | ActiveAlertAcknowledgementRecord
  | ActiveAlertRecord
  | ActiveTimelineRecord
  | AlertRecord
  | ApplicationNotificationRecord
  | AssignmentDelayedReasonRecord
  | CancellationCategoryRecord
  | CancellationReasonRecord
  | CancellationSecondaryReasonRecord
  | CardRecord
  | CardLinkRecord
  | CardNoteArchiveRecord
  | CardNoteRecord
  | CardReOpenReasonRecord
  | CardSummaryRecord
  | ConfigurationSettingRecord
  | ConversationRecord
  | ConversationParticipantRecord
  | DeclineCategoryRecord
  | DeclineReasonRecord
  | DeclineSecondaryReasonRecord
  | DiversionReasonRecord
  | EscortRequestRecord
  | EstimatedDurationRecord
  | EtaRecord
  | ExternalActionRecord
  | ExternalActionTypeRecord
  | ExternalSystemUnitRecord
  | FacilityNonAcceptanceReasonRecord
  | FirewallRuleRecord
  | FlightFollowingReportRecord
  | LandingZoneOutOfServiceReasonRecord
  | LocationHazardAttachmentRecord
  | LocationHazardRecord
  | ManifestEntryRecord
  | MedicalControlContactLogEntryRecord
  | MessageStatusUpdateRecord
  | NewAgencyLocationRequestRecord
  | NextDueTypeRecord
  | NonReferralReasonRecord
  | NotificationRecord
  | NotificationGroupRecord
  | NotificationGroupMemberRecord
  | NotificationRecipientRecord
  | NotificationSubscriptionRecord
  | NotificationTemplateRecord
  | OemActivityRecord
  | OemAssetRecord
  | OemPlanChangeRequestRecord
  | OemPlanRecord
  | OfferAlgorithmRecord
  | OperationRecord
  | OutOfServiceEventRecord
  | OutOfServiceEventNoteRecord
  | OutOfServiceReasonRecord
  | OutOfServiceSecondaryReasonRecord
  | OutOfServiceTicketRecord
  | PaipEventRecord
  | PaipReasonRecord
  | PassdownLogAcknowledgementRecord
  | PassdownLogArchivedLogRecord
  | PassdownLogRecord
  | PatientRecord
  | PositionReportAlertRecord
  | PositionReportArchiveRecord
  | PositionReportRecord
  | QuestionChoiceRecord
  | QuestionRecord
  | QuestionnaireRecord
  | QuestionnaireQuestionResponseRecord
  | QuestionnaireQuestionResponseNoteRecord
  | QuestionnaireResponseRecord
  | QuestionnaireSectionRecord
  | QuestionnaireSectionQuestionRecord
  | ReceivingFacilityRequestRecord
  | RendezvousRequestRecord
  | RequestRecord
  | RequesterRecord
  | RequesterReferralReasonRecord
  | RequesterRoleRecord
  | RequestLocationRecord
  | RequestPatientRecord
  | SystemTimerRecord
  | TimelineRecord
  | TimelineItemRecord
  | TimestampRecord
  | TimestampTypeRecord
  | TrackedMessageRecord
  | TransferReasonRecord
  | TransportOfferRecord
  | TransportOfferOptionRecord
  | TransportReasonRecord
  | TripRecord
  | TripLegRecord
  | TripPassengerRecord
  | UnitActivationRuleRecord
  | UnitEMSystemMappingRecord
  | UnitRecord
  | UnitNoteRecord
  | UnitPositionRecord
  | UnitShiftRecord
  | UnitStatusHistoryEntryRecord
  | UnitSummaryRecord
  | VehicleDispositionRecord
  | VehicleNotificationGroupRecord
  | VehicleSummaryRecord
  | WaypointRecord
  | WebOrderLogRecord
  | AccessibleItemRecord
  | AgencyRecord
  | AgencyLocationRecord
  | AirportRecord
  | ArchiveLogRecord
  | AttachmentRecord
  | BaseControlZoneRecord
  | BaseRecord
  | BaseMedicalControlContactRecord
  | BaseMedicalControlContactStateRecord
  | CapabilityRecord
  | CommunicationCenterRecord
  | CommunicationCenterTransportOfferOptionRecord
  | CompanyRecord
  | CompleteFlightInstanceRecord
  | ControlZoneRecord
  | DepartmentRecord
  | EntityCapabilityRecord
  | ExternalReferenceRecord
  | FboRecord
  | FuelTankRecord
  | LocationRecord
  | MaintenanceFacilityRecord
  | MedicalFacilityContactRecord
  | MedicalFacilityRecord
  | MedicalFacilityPhysicianRecord
  | MedicalFacilityUnitRecord
  | MedicalUnitRecord
  | OutOfServiceQARReasonRecord
  | PersonRecord
  | PhysicianRecord
  | ProgramBaseRecord
  | ProgramRecord
  | RamcoVehicleConfigurationRecord
  | RegionBaseRecord
  | RegionRecord
  | RegionGroupRecord
  | ReleaseNoteRecord
  | SpecialtyTeamRecord
  | SpecialtyTeamMemberRecord
  | StateRecord
  | SupportRequestRecord
  | TimezoneRecord
  | TransferCenterRecord
  | TrmUserAgencyRecord
  | TrmUserRecord
  | TrmUserMedicalFacilityRecord
  | TrmUserProgramRecord
  | VehicleControlZoneRecord
  | VehicleRecord
  | VehicleMaintenanceRecord
  | VehicleMakeRecord
  | VehicleModelRecord
  | VehicleStateInspectionRecord
  | ActiveCardUnitOfferingRecord
  | VehiclePositionSummaryRecord;

@Injectable({ providedIn: 'root' })
export class ActivationRuleEntityFetchService extends ClientSyncFetchService<ActivationRuleRecord> {
  constructor(
    byIdQuery: FetchActivationRuleByIdGQL,
    byIdsQuery: FetchActivationRuleByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectActivationRuleById,
      selectActivationRuleEntitiesByIds,
      ActivationRuleRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ActivationRuleEntityResolver {
  constructor(private readonly _fetchService: ActivationRuleEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<ActivationRuleRecord> {
    const activationRuleId: string | undefined = [
      route.params.activationRuleId,
      route.params.id,
      route.queryParams.activationRuleId,
    ].find((id) => id != null);
    if (activationRuleId == null) {
      throw new Error(
        `ActivationRuleEntityResolver: Unable to resolve entity of type 'ActivationRule'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(activationRuleId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((activationRule) => {
        if (activationRule == null) {
          throw new Error(
            `ActivationRuleEntityResolver: unable to resolve entity of type 'ActivationRule' for id '${activationRuleId}'`,
          );
        }
        return activationRule;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ActiveAlertAcknowledgementEntityFetchService extends ClientSyncFetchService<ActiveAlertAcknowledgementRecord> {
  constructor(
    byIdQuery: FetchActiveAlertAcknowledgementByIdGQL,
    byIdsQuery: FetchActiveAlertAcknowledgementByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectActiveAlertAcknowledgementById,
      selectActiveAlertAcknowledgementEntitiesByIds,
      ActiveAlertAcknowledgementRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ActiveAlertAcknowledgementEntityResolver {
  constructor(private readonly _fetchService: ActiveAlertAcknowledgementEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<ActiveAlertAcknowledgementRecord> {
    const activeAlertAcknowledgementId: string | undefined = [
      route.params.activeAlertAcknowledgementId,
      route.params.id,
      route.queryParams.activeAlertAcknowledgementId,
    ].find((id) => id != null);
    if (activeAlertAcknowledgementId == null) {
      throw new Error(
        `ActiveAlertAcknowledgementEntityResolver: Unable to resolve entity of type 'ActiveAlertAcknowledgement'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(activeAlertAcknowledgementId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((activeAlertAcknowledgement) => {
          if (activeAlertAcknowledgement == null) {
            throw new Error(
              `ActiveAlertAcknowledgementEntityResolver: unable to resolve entity of type 'ActiveAlertAcknowledgement' for id '${activeAlertAcknowledgementId}'`,
            );
          }
          return activeAlertAcknowledgement;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class ActiveAlertEntityFetchService extends ClientSyncFetchService<ActiveAlertRecord> {
  constructor(
    byIdQuery: FetchActiveAlertByIdGQL,
    byIdsQuery: FetchActiveAlertByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectActiveAlertById,
      selectActiveAlertEntitiesByIds,
      ActiveAlertRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ActiveAlertEntityResolver {
  constructor(private readonly _fetchService: ActiveAlertEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<ActiveAlertRecord> {
    const activeAlertId: string | undefined = [
      route.params.activeAlertId,
      route.params.id,
      route.queryParams.activeAlertId,
    ].find((id) => id != null);
    if (activeAlertId == null) {
      throw new Error(
        `ActiveAlertEntityResolver: Unable to resolve entity of type 'ActiveAlert'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(activeAlertId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((activeAlert) => {
        if (activeAlert == null) {
          throw new Error(
            `ActiveAlertEntityResolver: unable to resolve entity of type 'ActiveAlert' for id '${activeAlertId}'`,
          );
        }
        return activeAlert;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ActiveTimelineEntityFetchService extends ClientSyncFetchService<ActiveTimelineRecord> {
  constructor(
    byIdQuery: FetchActiveTimelineByIdGQL,
    byIdsQuery: FetchActiveTimelineByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectActiveTimelineById,
      selectActiveTimelineEntitiesByIds,
      ActiveTimelineRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ActiveTimelineEntityResolver {
  constructor(private readonly _fetchService: ActiveTimelineEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<ActiveTimelineRecord> {
    const activeTimelineId: string | undefined = [
      route.params.activeTimelineId,
      route.params.id,
      route.queryParams.activeTimelineId,
    ].find((id) => id != null);
    if (activeTimelineId == null) {
      throw new Error(
        `ActiveTimelineEntityResolver: Unable to resolve entity of type 'ActiveTimeline'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(activeTimelineId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((activeTimeline) => {
        if (activeTimeline == null) {
          throw new Error(
            `ActiveTimelineEntityResolver: unable to resolve entity of type 'ActiveTimeline' for id '${activeTimelineId}'`,
          );
        }
        return activeTimeline;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class AlertEntityFetchService extends ClientSyncFetchService<AlertRecord> {
  constructor(
    byIdQuery: FetchAlertByIdGQL,
    byIdsQuery: FetchAlertByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectAlertById,
      selectAlertEntitiesByIds,
      AlertRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class AlertEntityResolver {
  constructor(private readonly _fetchService: AlertEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<AlertRecord> {
    const alertId: string | undefined = [
      route.params.alertId,
      route.params.id,
      route.queryParams.alertId,
    ].find((id) => id != null);
    if (alertId == null) {
      throw new Error(
        `AlertEntityResolver: Unable to resolve entity of type 'Alert'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(alertId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((alert) => {
        if (alert == null) {
          throw new Error(
            `AlertEntityResolver: unable to resolve entity of type 'Alert' for id '${alertId}'`,
          );
        }
        return alert;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ApplicationNotificationEntityFetchService extends ClientSyncFetchService<ApplicationNotificationRecord> {
  constructor(
    byIdQuery: FetchApplicationNotificationByIdGQL,
    byIdsQuery: FetchApplicationNotificationByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectApplicationNotificationById,
      selectApplicationNotificationEntitiesByIds,
      ApplicationNotificationRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ApplicationNotificationEntityResolver {
  constructor(private readonly _fetchService: ApplicationNotificationEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<ApplicationNotificationRecord> {
    const applicationNotificationId: string | undefined = [
      route.params.applicationNotificationId,
      route.params.id,
      route.queryParams.applicationNotificationId,
    ].find((id) => id != null);
    if (applicationNotificationId == null) {
      throw new Error(
        `ApplicationNotificationEntityResolver: Unable to resolve entity of type 'ApplicationNotification'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(applicationNotificationId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((applicationNotification) => {
          if (applicationNotification == null) {
            throw new Error(
              `ApplicationNotificationEntityResolver: unable to resolve entity of type 'ApplicationNotification' for id '${applicationNotificationId}'`,
            );
          }
          return applicationNotification;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class AssignmentDelayedReasonEntityFetchService extends ClientSyncFetchService<AssignmentDelayedReasonRecord> {
  constructor(
    byIdQuery: FetchAssignmentDelayedReasonByIdGQL,
    byIdsQuery: FetchAssignmentDelayedReasonByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectAssignmentDelayedReasonById,
      selectAssignmentDelayedReasonEntitiesByIds,
      AssignmentDelayedReasonRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class AssignmentDelayedReasonEntityResolver {
  constructor(private readonly _fetchService: AssignmentDelayedReasonEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<AssignmentDelayedReasonRecord> {
    const assignmentDelayedReasonId: string | undefined = [
      route.params.assignmentDelayedReasonId,
      route.params.id,
      route.queryParams.assignmentDelayedReasonId,
    ].find((id) => id != null);
    if (assignmentDelayedReasonId == null) {
      throw new Error(
        `AssignmentDelayedReasonEntityResolver: Unable to resolve entity of type 'AssignmentDelayedReason'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(assignmentDelayedReasonId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((assignmentDelayedReason) => {
          if (assignmentDelayedReason == null) {
            throw new Error(
              `AssignmentDelayedReasonEntityResolver: unable to resolve entity of type 'AssignmentDelayedReason' for id '${assignmentDelayedReasonId}'`,
            );
          }
          return assignmentDelayedReason;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class CancellationCategoryEntityFetchService extends ClientSyncFetchService<CancellationCategoryRecord> {
  constructor(
    byIdQuery: FetchCancellationCategoryByIdGQL,
    byIdsQuery: FetchCancellationCategoryByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectCancellationCategoryById,
      selectCancellationCategoryEntitiesByIds,
      CancellationCategoryRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class CancellationCategoryEntityResolver {
  constructor(private readonly _fetchService: CancellationCategoryEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<CancellationCategoryRecord> {
    const cancellationCategoryId: string | undefined = [
      route.params.cancellationCategoryId,
      route.params.id,
      route.queryParams.cancellationCategoryId,
    ].find((id) => id != null);
    if (cancellationCategoryId == null) {
      throw new Error(
        `CancellationCategoryEntityResolver: Unable to resolve entity of type 'CancellationCategory'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(cancellationCategoryId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((cancellationCategory) => {
          if (cancellationCategory == null) {
            throw new Error(
              `CancellationCategoryEntityResolver: unable to resolve entity of type 'CancellationCategory' for id '${cancellationCategoryId}'`,
            );
          }
          return cancellationCategory;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class CancellationReasonEntityFetchService extends ClientSyncFetchService<CancellationReasonRecord> {
  constructor(
    byIdQuery: FetchCancellationReasonByIdGQL,
    byIdsQuery: FetchCancellationReasonByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectCancellationReasonById,
      selectCancellationReasonEntitiesByIds,
      CancellationReasonRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class CancellationReasonEntityResolver {
  constructor(private readonly _fetchService: CancellationReasonEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<CancellationReasonRecord> {
    const cancellationReasonId: string | undefined = [
      route.params.cancellationReasonId,
      route.params.id,
      route.queryParams.cancellationReasonId,
    ].find((id) => id != null);
    if (cancellationReasonId == null) {
      throw new Error(
        `CancellationReasonEntityResolver: Unable to resolve entity of type 'CancellationReason'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(cancellationReasonId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((cancellationReason) => {
          if (cancellationReason == null) {
            throw new Error(
              `CancellationReasonEntityResolver: unable to resolve entity of type 'CancellationReason' for id '${cancellationReasonId}'`,
            );
          }
          return cancellationReason;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class CancellationSecondaryReasonEntityFetchService extends ClientSyncFetchService<CancellationSecondaryReasonRecord> {
  constructor(
    byIdQuery: FetchCancellationSecondaryReasonByIdGQL,
    byIdsQuery: FetchCancellationSecondaryReasonByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectCancellationSecondaryReasonById,
      selectCancellationSecondaryReasonEntitiesByIds,
      CancellationSecondaryReasonRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class CancellationSecondaryReasonEntityResolver {
  constructor(private readonly _fetchService: CancellationSecondaryReasonEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<CancellationSecondaryReasonRecord> {
    const cancellationSecondaryReasonId: string | undefined = [
      route.params.cancellationSecondaryReasonId,
      route.params.id,
      route.queryParams.cancellationSecondaryReasonId,
    ].find((id) => id != null);
    if (cancellationSecondaryReasonId == null) {
      throw new Error(
        `CancellationSecondaryReasonEntityResolver: Unable to resolve entity of type 'CancellationSecondaryReason'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(cancellationSecondaryReasonId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((cancellationSecondaryReason) => {
          if (cancellationSecondaryReason == null) {
            throw new Error(
              `CancellationSecondaryReasonEntityResolver: unable to resolve entity of type 'CancellationSecondaryReason' for id '${cancellationSecondaryReasonId}'`,
            );
          }
          return cancellationSecondaryReason;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class CardEntityFetchService extends ClientSyncFetchService<CardRecord> {
  constructor(
    byIdQuery: FetchCardByIdGQL,
    byIdsQuery: FetchCardByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectCardById,
      selectCardEntitiesByIds,
      CardRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class CardEntityResolver {
  constructor(private readonly _fetchService: CardEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<CardRecord> {
    const cardId: string | undefined = [
      route.params.cardId,
      route.params.id,
      route.queryParams.cardId,
    ].find((id) => id != null);
    if (cardId == null) {
      throw new Error(
        `CardEntityResolver: Unable to resolve entity of type 'Card'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(cardId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((card) => {
        if (card == null) {
          throw new Error(
            `CardEntityResolver: unable to resolve entity of type 'Card' for id '${cardId}'`,
          );
        }
        return card;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class CardLinkEntityFetchService extends ClientSyncFetchService<CardLinkRecord> {
  constructor(
    byIdQuery: FetchCardLinkByIdGQL,
    byIdsQuery: FetchCardLinkByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectCardLinkById,
      selectCardLinkEntitiesByIds,
      CardLinkRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class CardLinkEntityResolver {
  constructor(private readonly _fetchService: CardLinkEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<CardLinkRecord> {
    const cardLinkId: string | undefined = [
      route.params.cardLinkId,
      route.params.id,
      route.queryParams.cardLinkId,
    ].find((id) => id != null);
    if (cardLinkId == null) {
      throw new Error(
        `CardLinkEntityResolver: Unable to resolve entity of type 'CardLink'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(cardLinkId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((cardLink) => {
        if (cardLink == null) {
          throw new Error(
            `CardLinkEntityResolver: unable to resolve entity of type 'CardLink' for id '${cardLinkId}'`,
          );
        }
        return cardLink;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class CardNoteArchiveEntityFetchService extends ClientSyncFetchService<CardNoteArchiveRecord> {
  constructor(
    byIdQuery: FetchCardNoteArchiveByIdGQL,
    byIdsQuery: FetchCardNoteArchiveByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectCardNoteArchiveById,
      selectCardNoteArchiveEntitiesByIds,
      CardNoteArchiveRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class CardNoteArchiveEntityResolver {
  constructor(private readonly _fetchService: CardNoteArchiveEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<CardNoteArchiveRecord> {
    const cardNoteArchiveId: string | undefined = [
      route.params.cardNoteArchiveId,
      route.params.id,
      route.queryParams.cardNoteArchiveId,
    ].find((id) => id != null);
    if (cardNoteArchiveId == null) {
      throw new Error(
        `CardNoteArchiveEntityResolver: Unable to resolve entity of type 'CardNoteArchive'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(cardNoteArchiveId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((cardNoteArchive) => {
          if (cardNoteArchive == null) {
            throw new Error(
              `CardNoteArchiveEntityResolver: unable to resolve entity of type 'CardNoteArchive' for id '${cardNoteArchiveId}'`,
            );
          }
          return cardNoteArchive;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class CardNoteEntityFetchService extends ClientSyncFetchService<CardNoteRecord> {
  constructor(
    byIdQuery: FetchCardNoteByIdGQL,
    byIdsQuery: FetchCardNoteByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectCardNoteById,
      selectCardNoteEntitiesByIds,
      CardNoteRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class CardNoteEntityResolver {
  constructor(private readonly _fetchService: CardNoteEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<CardNoteRecord> {
    const cardNoteId: string | undefined = [
      route.params.cardNoteId,
      route.params.id,
      route.queryParams.cardNoteId,
    ].find((id) => id != null);
    if (cardNoteId == null) {
      throw new Error(
        `CardNoteEntityResolver: Unable to resolve entity of type 'CardNote'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(cardNoteId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((cardNote) => {
        if (cardNote == null) {
          throw new Error(
            `CardNoteEntityResolver: unable to resolve entity of type 'CardNote' for id '${cardNoteId}'`,
          );
        }
        return cardNote;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class CardReOpenReasonEntityFetchService extends ClientSyncFetchService<CardReOpenReasonRecord> {
  constructor(
    byIdQuery: FetchCardReOpenReasonByIdGQL,
    byIdsQuery: FetchCardReOpenReasonByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectCardReOpenReasonById,
      selectCardReOpenReasonEntitiesByIds,
      CardReOpenReasonRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class CardReOpenReasonEntityResolver {
  constructor(private readonly _fetchService: CardReOpenReasonEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<CardReOpenReasonRecord> {
    const cardReOpenReasonId: string | undefined = [
      route.params.cardReOpenReasonId,
      route.params.id,
      route.queryParams.cardReOpenReasonId,
    ].find((id) => id != null);
    if (cardReOpenReasonId == null) {
      throw new Error(
        `CardReOpenReasonEntityResolver: Unable to resolve entity of type 'CardReOpenReason'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(cardReOpenReasonId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((cardReOpenReason) => {
          if (cardReOpenReason == null) {
            throw new Error(
              `CardReOpenReasonEntityResolver: unable to resolve entity of type 'CardReOpenReason' for id '${cardReOpenReasonId}'`,
            );
          }
          return cardReOpenReason;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class CardSummaryEntityFetchService extends ClientSyncFetchService<CardSummaryRecord> {
  constructor(
    byIdQuery: FetchCardSummaryByIdGQL,
    byIdsQuery: FetchCardSummaryByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectCardSummaryById,
      selectCardSummaryEntitiesByIds,
      CardSummaryRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class CardSummaryEntityResolver {
  constructor(private readonly _fetchService: CardSummaryEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<CardSummaryRecord> {
    const cardSummaryId: string | undefined = [
      route.params.cardSummaryId,
      route.params.id,
      route.queryParams.cardSummaryId,
    ].find((id) => id != null);
    if (cardSummaryId == null) {
      throw new Error(
        `CardSummaryEntityResolver: Unable to resolve entity of type 'CardSummary'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(cardSummaryId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((cardSummary) => {
        if (cardSummary == null) {
          throw new Error(
            `CardSummaryEntityResolver: unable to resolve entity of type 'CardSummary' for id '${cardSummaryId}'`,
          );
        }
        return cardSummary;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ConfigurationSettingEntityFetchService extends ClientSyncFetchService<ConfigurationSettingRecord> {
  constructor(
    byIdQuery: FetchConfigurationSettingByIdGQL,
    byIdsQuery: FetchConfigurationSettingByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectConfigurationSettingById,
      selectConfigurationSettingEntitiesByIds,
      ConfigurationSettingRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ConfigurationSettingEntityResolver {
  constructor(private readonly _fetchService: ConfigurationSettingEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<ConfigurationSettingRecord> {
    const configurationSettingId: string | undefined = [
      route.params.configurationSettingId,
      route.params.id,
      route.queryParams.configurationSettingId,
    ].find((id) => id != null);
    if (configurationSettingId == null) {
      throw new Error(
        `ConfigurationSettingEntityResolver: Unable to resolve entity of type 'ConfigurationSetting'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(configurationSettingId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((configurationSetting) => {
          if (configurationSetting == null) {
            throw new Error(
              `ConfigurationSettingEntityResolver: unable to resolve entity of type 'ConfigurationSetting' for id '${configurationSettingId}'`,
            );
          }
          return configurationSetting;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class ConversationEntityFetchService extends ClientSyncFetchService<ConversationRecord> {
  constructor(
    byIdQuery: FetchConversationByIdGQL,
    byIdsQuery: FetchConversationByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectConversationById,
      selectConversationEntitiesByIds,
      ConversationRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ConversationEntityResolver {
  constructor(private readonly _fetchService: ConversationEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<ConversationRecord> {
    const conversationId: string | undefined = [
      route.params.conversationId,
      route.params.id,
      route.queryParams.conversationId,
    ].find((id) => id != null);
    if (conversationId == null) {
      throw new Error(
        `ConversationEntityResolver: Unable to resolve entity of type 'Conversation'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(conversationId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((conversation) => {
        if (conversation == null) {
          throw new Error(
            `ConversationEntityResolver: unable to resolve entity of type 'Conversation' for id '${conversationId}'`,
          );
        }
        return conversation;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ConversationParticipantEntityFetchService extends ClientSyncFetchService<ConversationParticipantRecord> {
  constructor(
    byIdQuery: FetchConversationParticipantByIdGQL,
    byIdsQuery: FetchConversationParticipantByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectConversationParticipantById,
      selectConversationParticipantEntitiesByIds,
      ConversationParticipantRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ConversationParticipantEntityResolver {
  constructor(private readonly _fetchService: ConversationParticipantEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<ConversationParticipantRecord> {
    const conversationParticipantId: string | undefined = [
      route.params.conversationParticipantId,
      route.params.id,
      route.queryParams.conversationParticipantId,
    ].find((id) => id != null);
    if (conversationParticipantId == null) {
      throw new Error(
        `ConversationParticipantEntityResolver: Unable to resolve entity of type 'ConversationParticipant'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(conversationParticipantId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((conversationParticipant) => {
          if (conversationParticipant == null) {
            throw new Error(
              `ConversationParticipantEntityResolver: unable to resolve entity of type 'ConversationParticipant' for id '${conversationParticipantId}'`,
            );
          }
          return conversationParticipant;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class DeclineCategoryEntityFetchService extends ClientSyncFetchService<DeclineCategoryRecord> {
  constructor(
    byIdQuery: FetchDeclineCategoryByIdGQL,
    byIdsQuery: FetchDeclineCategoryByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectDeclineCategoryById,
      selectDeclineCategoryEntitiesByIds,
      DeclineCategoryRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class DeclineCategoryEntityResolver {
  constructor(private readonly _fetchService: DeclineCategoryEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<DeclineCategoryRecord> {
    const declineCategoryId: string | undefined = [
      route.params.declineCategoryId,
      route.params.id,
      route.queryParams.declineCategoryId,
    ].find((id) => id != null);
    if (declineCategoryId == null) {
      throw new Error(
        `DeclineCategoryEntityResolver: Unable to resolve entity of type 'DeclineCategory'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(declineCategoryId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((declineCategory) => {
          if (declineCategory == null) {
            throw new Error(
              `DeclineCategoryEntityResolver: unable to resolve entity of type 'DeclineCategory' for id '${declineCategoryId}'`,
            );
          }
          return declineCategory;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class DeclineReasonEntityFetchService extends ClientSyncFetchService<DeclineReasonRecord> {
  constructor(
    byIdQuery: FetchDeclineReasonByIdGQL,
    byIdsQuery: FetchDeclineReasonByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectDeclineReasonById,
      selectDeclineReasonEntitiesByIds,
      DeclineReasonRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class DeclineReasonEntityResolver {
  constructor(private readonly _fetchService: DeclineReasonEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<DeclineReasonRecord> {
    const declineReasonId: string | undefined = [
      route.params.declineReasonId,
      route.params.id,
      route.queryParams.declineReasonId,
    ].find((id) => id != null);
    if (declineReasonId == null) {
      throw new Error(
        `DeclineReasonEntityResolver: Unable to resolve entity of type 'DeclineReason'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(declineReasonId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((declineReason) => {
        if (declineReason == null) {
          throw new Error(
            `DeclineReasonEntityResolver: unable to resolve entity of type 'DeclineReason' for id '${declineReasonId}'`,
          );
        }
        return declineReason;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class DeclineSecondaryReasonEntityFetchService extends ClientSyncFetchService<DeclineSecondaryReasonRecord> {
  constructor(
    byIdQuery: FetchDeclineSecondaryReasonByIdGQL,
    byIdsQuery: FetchDeclineSecondaryReasonByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectDeclineSecondaryReasonById,
      selectDeclineSecondaryReasonEntitiesByIds,
      DeclineSecondaryReasonRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class DeclineSecondaryReasonEntityResolver {
  constructor(private readonly _fetchService: DeclineSecondaryReasonEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<DeclineSecondaryReasonRecord> {
    const declineSecondaryReasonId: string | undefined = [
      route.params.declineSecondaryReasonId,
      route.params.id,
      route.queryParams.declineSecondaryReasonId,
    ].find((id) => id != null);
    if (declineSecondaryReasonId == null) {
      throw new Error(
        `DeclineSecondaryReasonEntityResolver: Unable to resolve entity of type 'DeclineSecondaryReason'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(declineSecondaryReasonId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((declineSecondaryReason) => {
          if (declineSecondaryReason == null) {
            throw new Error(
              `DeclineSecondaryReasonEntityResolver: unable to resolve entity of type 'DeclineSecondaryReason' for id '${declineSecondaryReasonId}'`,
            );
          }
          return declineSecondaryReason;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class DiversionReasonEntityFetchService extends ClientSyncFetchService<DiversionReasonRecord> {
  constructor(
    byIdQuery: FetchDiversionReasonByIdGQL,
    byIdsQuery: FetchDiversionReasonByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectDiversionReasonById,
      selectDiversionReasonEntitiesByIds,
      DiversionReasonRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class DiversionReasonEntityResolver {
  constructor(private readonly _fetchService: DiversionReasonEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<DiversionReasonRecord> {
    const diversionReasonId: string | undefined = [
      route.params.diversionReasonId,
      route.params.id,
      route.queryParams.diversionReasonId,
    ].find((id) => id != null);
    if (diversionReasonId == null) {
      throw new Error(
        `DiversionReasonEntityResolver: Unable to resolve entity of type 'DiversionReason'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(diversionReasonId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((diversionReason) => {
          if (diversionReason == null) {
            throw new Error(
              `DiversionReasonEntityResolver: unable to resolve entity of type 'DiversionReason' for id '${diversionReasonId}'`,
            );
          }
          return diversionReason;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class EscortRequestEntityFetchService extends ClientSyncFetchService<EscortRequestRecord> {
  constructor(
    byIdQuery: FetchEscortRequestByIdGQL,
    byIdsQuery: FetchEscortRequestByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectEscortRequestById,
      selectEscortRequestEntitiesByIds,
      EscortRequestRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class EscortRequestEntityResolver {
  constructor(private readonly _fetchService: EscortRequestEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<EscortRequestRecord> {
    const escortRequestId: string | undefined = [
      route.params.escortRequestId,
      route.params.id,
      route.queryParams.escortRequestId,
    ].find((id) => id != null);
    if (escortRequestId == null) {
      throw new Error(
        `EscortRequestEntityResolver: Unable to resolve entity of type 'EscortRequest'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(escortRequestId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((escortRequest) => {
        if (escortRequest == null) {
          throw new Error(
            `EscortRequestEntityResolver: unable to resolve entity of type 'EscortRequest' for id '${escortRequestId}'`,
          );
        }
        return escortRequest;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class EstimatedDurationEntityFetchService extends ClientSyncFetchService<EstimatedDurationRecord> {
  constructor(
    byIdQuery: FetchEstimatedDurationByIdGQL,
    byIdsQuery: FetchEstimatedDurationByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectEstimatedDurationById,
      selectEstimatedDurationEntitiesByIds,
      EstimatedDurationRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class EstimatedDurationEntityResolver {
  constructor(private readonly _fetchService: EstimatedDurationEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<EstimatedDurationRecord> {
    const estimatedDurationId: string | undefined = [
      route.params.estimatedDurationId,
      route.params.id,
      route.queryParams.estimatedDurationId,
    ].find((id) => id != null);
    if (estimatedDurationId == null) {
      throw new Error(
        `EstimatedDurationEntityResolver: Unable to resolve entity of type 'EstimatedDuration'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(estimatedDurationId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((estimatedDuration) => {
          if (estimatedDuration == null) {
            throw new Error(
              `EstimatedDurationEntityResolver: unable to resolve entity of type 'EstimatedDuration' for id '${estimatedDurationId}'`,
            );
          }
          return estimatedDuration;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class EtaEntityFetchService extends ClientSyncFetchService<EtaRecord> {
  constructor(
    byIdQuery: FetchEtaByIdGQL,
    byIdsQuery: FetchEtaByIdsGQL,

    _store: StoreService,
  ) {
    super(byIdQuery, byIdsQuery, _store, selectEtaById, selectEtaEntitiesByIds, EtaRecord.fromJS);
  }
}

@Injectable({ providedIn: 'root' })
export class EtaEntityResolver {
  constructor(private readonly _fetchService: EtaEntityFetchService) {}

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<EtaRecord> {
    const etaId: string | undefined = [
      route.params.etaId,
      route.params.id,
      route.queryParams.etaId,
    ].find((id) => id != null);
    if (etaId == null) {
      throw new Error(
        `EtaEntityResolver: Unable to resolve entity of type 'Eta'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(etaId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((eta) => {
        if (eta == null) {
          throw new Error(
            `EtaEntityResolver: unable to resolve entity of type 'Eta' for id '${etaId}'`,
          );
        }
        return eta;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ExternalActionEntityFetchService extends ClientSyncFetchService<ExternalActionRecord> {
  constructor(
    byIdQuery: FetchExternalActionByIdGQL,
    byIdsQuery: FetchExternalActionByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectExternalActionById,
      selectExternalActionEntitiesByIds,
      ExternalActionRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ExternalActionEntityResolver {
  constructor(private readonly _fetchService: ExternalActionEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<ExternalActionRecord> {
    const externalActionId: string | undefined = [
      route.params.externalActionId,
      route.params.id,
      route.queryParams.externalActionId,
    ].find((id) => id != null);
    if (externalActionId == null) {
      throw new Error(
        `ExternalActionEntityResolver: Unable to resolve entity of type 'ExternalAction'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(externalActionId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((externalAction) => {
        if (externalAction == null) {
          throw new Error(
            `ExternalActionEntityResolver: unable to resolve entity of type 'ExternalAction' for id '${externalActionId}'`,
          );
        }
        return externalAction;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ExternalActionTypeEntityFetchService extends ClientSyncFetchService<ExternalActionTypeRecord> {
  constructor(
    byIdQuery: FetchExternalActionTypeByIdGQL,
    byIdsQuery: FetchExternalActionTypeByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectExternalActionTypeById,
      selectExternalActionTypeEntitiesByIds,
      ExternalActionTypeRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ExternalActionTypeEntityResolver {
  constructor(private readonly _fetchService: ExternalActionTypeEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<ExternalActionTypeRecord> {
    const externalActionTypeId: string | undefined = [
      route.params.externalActionTypeId,
      route.params.id,
      route.queryParams.externalActionTypeId,
    ].find((id) => id != null);
    if (externalActionTypeId == null) {
      throw new Error(
        `ExternalActionTypeEntityResolver: Unable to resolve entity of type 'ExternalActionType'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(externalActionTypeId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((externalActionType) => {
          if (externalActionType == null) {
            throw new Error(
              `ExternalActionTypeEntityResolver: unable to resolve entity of type 'ExternalActionType' for id '${externalActionTypeId}'`,
            );
          }
          return externalActionType;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class ExternalSystemUnitEntityFetchService extends ClientSyncFetchService<ExternalSystemUnitRecord> {
  constructor(
    byIdQuery: FetchExternalSystemUnitByIdGQL,
    byIdsQuery: FetchExternalSystemUnitByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectExternalSystemUnitById,
      selectExternalSystemUnitEntitiesByIds,
      ExternalSystemUnitRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ExternalSystemUnitEntityResolver {
  constructor(private readonly _fetchService: ExternalSystemUnitEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<ExternalSystemUnitRecord> {
    const externalSystemUnitId: string | undefined = [
      route.params.externalSystemUnitId,
      route.params.id,
      route.queryParams.externalSystemUnitId,
    ].find((id) => id != null);
    if (externalSystemUnitId == null) {
      throw new Error(
        `ExternalSystemUnitEntityResolver: Unable to resolve entity of type 'ExternalSystemUnit'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(externalSystemUnitId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((externalSystemUnit) => {
          if (externalSystemUnit == null) {
            throw new Error(
              `ExternalSystemUnitEntityResolver: unable to resolve entity of type 'ExternalSystemUnit' for id '${externalSystemUnitId}'`,
            );
          }
          return externalSystemUnit;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class FacilityNonAcceptanceReasonEntityFetchService extends ClientSyncFetchService<FacilityNonAcceptanceReasonRecord> {
  constructor(
    byIdQuery: FetchFacilityNonAcceptanceReasonByIdGQL,
    byIdsQuery: FetchFacilityNonAcceptanceReasonByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectFacilityNonAcceptanceReasonById,
      selectFacilityNonAcceptanceReasonEntitiesByIds,
      FacilityNonAcceptanceReasonRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class FacilityNonAcceptanceReasonEntityResolver {
  constructor(private readonly _fetchService: FacilityNonAcceptanceReasonEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<FacilityNonAcceptanceReasonRecord> {
    const facilityNonAcceptanceReasonId: string | undefined = [
      route.params.facilityNonAcceptanceReasonId,
      route.params.id,
      route.queryParams.facilityNonAcceptanceReasonId,
    ].find((id) => id != null);
    if (facilityNonAcceptanceReasonId == null) {
      throw new Error(
        `FacilityNonAcceptanceReasonEntityResolver: Unable to resolve entity of type 'FacilityNonAcceptanceReason'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(facilityNonAcceptanceReasonId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((facilityNonAcceptanceReason) => {
          if (facilityNonAcceptanceReason == null) {
            throw new Error(
              `FacilityNonAcceptanceReasonEntityResolver: unable to resolve entity of type 'FacilityNonAcceptanceReason' for id '${facilityNonAcceptanceReasonId}'`,
            );
          }
          return facilityNonAcceptanceReason;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class FirewallRuleEntityFetchService extends ClientSyncFetchService<FirewallRuleRecord> {
  constructor(
    byIdQuery: FetchFirewallRuleByIdGQL,
    byIdsQuery: FetchFirewallRuleByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectFirewallRuleById,
      selectFirewallRuleEntitiesByIds,
      FirewallRuleRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class FirewallRuleEntityResolver {
  constructor(private readonly _fetchService: FirewallRuleEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<FirewallRuleRecord> {
    const firewallRuleId: string | undefined = [
      route.params.firewallRuleId,
      route.params.id,
      route.queryParams.firewallRuleId,
    ].find((id) => id != null);
    if (firewallRuleId == null) {
      throw new Error(
        `FirewallRuleEntityResolver: Unable to resolve entity of type 'FirewallRule'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(firewallRuleId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((firewallRule) => {
        if (firewallRule == null) {
          throw new Error(
            `FirewallRuleEntityResolver: unable to resolve entity of type 'FirewallRule' for id '${firewallRuleId}'`,
          );
        }
        return firewallRule;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class FlightFollowingReportEntityFetchService extends ClientSyncFetchService<FlightFollowingReportRecord> {
  constructor(
    byIdQuery: FetchFlightFollowingReportByIdGQL,
    byIdsQuery: FetchFlightFollowingReportByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectFlightFollowingReportById,
      selectFlightFollowingReportEntitiesByIds,
      FlightFollowingReportRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class FlightFollowingReportEntityResolver {
  constructor(private readonly _fetchService: FlightFollowingReportEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<FlightFollowingReportRecord> {
    const flightFollowingReportId: string | undefined = [
      route.params.flightFollowingReportId,
      route.params.id,
      route.queryParams.flightFollowingReportId,
    ].find((id) => id != null);
    if (flightFollowingReportId == null) {
      throw new Error(
        `FlightFollowingReportEntityResolver: Unable to resolve entity of type 'FlightFollowingReport'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(flightFollowingReportId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((flightFollowingReport) => {
          if (flightFollowingReport == null) {
            throw new Error(
              `FlightFollowingReportEntityResolver: unable to resolve entity of type 'FlightFollowingReport' for id '${flightFollowingReportId}'`,
            );
          }
          return flightFollowingReport;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class LandingZoneOutOfServiceReasonEntityFetchService extends ClientSyncFetchService<LandingZoneOutOfServiceReasonRecord> {
  constructor(
    byIdQuery: FetchLandingZoneOutOfServiceReasonByIdGQL,
    byIdsQuery: FetchLandingZoneOutOfServiceReasonByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectLandingZoneOutOfServiceReasonById,
      selectLandingZoneOutOfServiceReasonEntitiesByIds,
      LandingZoneOutOfServiceReasonRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class LandingZoneOutOfServiceReasonEntityResolver {
  constructor(private readonly _fetchService: LandingZoneOutOfServiceReasonEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<LandingZoneOutOfServiceReasonRecord> {
    const landingZoneOutOfServiceReasonId: string | undefined = [
      route.params.landingZoneOutOfServiceReasonId,
      route.params.id,
      route.queryParams.landingZoneOutOfServiceReasonId,
    ].find((id) => id != null);
    if (landingZoneOutOfServiceReasonId == null) {
      throw new Error(
        `LandingZoneOutOfServiceReasonEntityResolver: Unable to resolve entity of type 'LandingZoneOutOfServiceReason'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(landingZoneOutOfServiceReasonId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((landingZoneOutOfServiceReason) => {
          if (landingZoneOutOfServiceReason == null) {
            throw new Error(
              `LandingZoneOutOfServiceReasonEntityResolver: unable to resolve entity of type 'LandingZoneOutOfServiceReason' for id '${landingZoneOutOfServiceReasonId}'`,
            );
          }
          return landingZoneOutOfServiceReason;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class LocationHazardAttachmentEntityFetchService extends ClientSyncFetchService<LocationHazardAttachmentRecord> {
  constructor(
    byIdQuery: FetchLocationHazardAttachmentByIdGQL,
    byIdsQuery: FetchLocationHazardAttachmentByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectLocationHazardAttachmentById,
      selectLocationHazardAttachmentEntitiesByIds,
      LocationHazardAttachmentRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class LocationHazardAttachmentEntityResolver {
  constructor(private readonly _fetchService: LocationHazardAttachmentEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<LocationHazardAttachmentRecord> {
    const locationHazardAttachmentId: string | undefined = [
      route.params.locationHazardAttachmentId,
      route.params.id,
      route.queryParams.locationHazardAttachmentId,
    ].find((id) => id != null);
    if (locationHazardAttachmentId == null) {
      throw new Error(
        `LocationHazardAttachmentEntityResolver: Unable to resolve entity of type 'LocationHazardAttachment'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(locationHazardAttachmentId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((locationHazardAttachment) => {
          if (locationHazardAttachment == null) {
            throw new Error(
              `LocationHazardAttachmentEntityResolver: unable to resolve entity of type 'LocationHazardAttachment' for id '${locationHazardAttachmentId}'`,
            );
          }
          return locationHazardAttachment;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class LocationHazardEntityFetchService extends ClientSyncFetchService<LocationHazardRecord> {
  constructor(
    byIdQuery: FetchLocationHazardByIdGQL,
    byIdsQuery: FetchLocationHazardByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectLocationHazardById,
      selectLocationHazardEntitiesByIds,
      LocationHazardRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class LocationHazardEntityResolver {
  constructor(private readonly _fetchService: LocationHazardEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<LocationHazardRecord> {
    const locationHazardId: string | undefined = [
      route.params.locationHazardId,
      route.params.id,
      route.queryParams.locationHazardId,
    ].find((id) => id != null);
    if (locationHazardId == null) {
      throw new Error(
        `LocationHazardEntityResolver: Unable to resolve entity of type 'LocationHazard'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(locationHazardId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((locationHazard) => {
        if (locationHazard == null) {
          throw new Error(
            `LocationHazardEntityResolver: unable to resolve entity of type 'LocationHazard' for id '${locationHazardId}'`,
          );
        }
        return locationHazard;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ManifestEntryEntityFetchService extends ClientSyncFetchService<ManifestEntryRecord> {
  constructor(
    byIdQuery: FetchManifestEntryByIdGQL,
    byIdsQuery: FetchManifestEntryByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectManifestEntryById,
      selectManifestEntryEntitiesByIds,
      ManifestEntryRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ManifestEntryEntityResolver {
  constructor(private readonly _fetchService: ManifestEntryEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<ManifestEntryRecord> {
    const manifestEntryId: string | undefined = [
      route.params.manifestEntryId,
      route.params.id,
      route.queryParams.manifestEntryId,
    ].find((id) => id != null);
    if (manifestEntryId == null) {
      throw new Error(
        `ManifestEntryEntityResolver: Unable to resolve entity of type 'ManifestEntry'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(manifestEntryId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((manifestEntry) => {
        if (manifestEntry == null) {
          throw new Error(
            `ManifestEntryEntityResolver: unable to resolve entity of type 'ManifestEntry' for id '${manifestEntryId}'`,
          );
        }
        return manifestEntry;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class MedicalControlContactLogEntryEntityFetchService extends ClientSyncFetchService<MedicalControlContactLogEntryRecord> {
  constructor(
    byIdQuery: FetchMedicalControlContactLogEntryByIdGQL,
    byIdsQuery: FetchMedicalControlContactLogEntryByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectMedicalControlContactLogEntryById,
      selectMedicalControlContactLogEntryEntitiesByIds,
      MedicalControlContactLogEntryRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class MedicalControlContactLogEntryEntityResolver {
  constructor(private readonly _fetchService: MedicalControlContactLogEntryEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<MedicalControlContactLogEntryRecord> {
    const medicalControlContactLogEntryId: string | undefined = [
      route.params.medicalControlContactLogEntryId,
      route.params.id,
      route.queryParams.medicalControlContactLogEntryId,
    ].find((id) => id != null);
    if (medicalControlContactLogEntryId == null) {
      throw new Error(
        `MedicalControlContactLogEntryEntityResolver: Unable to resolve entity of type 'MedicalControlContactLogEntry'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(medicalControlContactLogEntryId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((medicalControlContactLogEntry) => {
          if (medicalControlContactLogEntry == null) {
            throw new Error(
              `MedicalControlContactLogEntryEntityResolver: unable to resolve entity of type 'MedicalControlContactLogEntry' for id '${medicalControlContactLogEntryId}'`,
            );
          }
          return medicalControlContactLogEntry;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class MessageStatusUpdateEntityFetchService extends ClientSyncFetchService<MessageStatusUpdateRecord> {
  constructor(
    byIdQuery: FetchMessageStatusUpdateByIdGQL,
    byIdsQuery: FetchMessageStatusUpdateByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectMessageStatusUpdateById,
      selectMessageStatusUpdateEntitiesByIds,
      MessageStatusUpdateRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class MessageStatusUpdateEntityResolver {
  constructor(private readonly _fetchService: MessageStatusUpdateEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<MessageStatusUpdateRecord> {
    const messageStatusUpdateId: string | undefined = [
      route.params.messageStatusUpdateId,
      route.params.id,
      route.queryParams.messageStatusUpdateId,
    ].find((id) => id != null);
    if (messageStatusUpdateId == null) {
      throw new Error(
        `MessageStatusUpdateEntityResolver: Unable to resolve entity of type 'MessageStatusUpdate'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(messageStatusUpdateId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((messageStatusUpdate) => {
          if (messageStatusUpdate == null) {
            throw new Error(
              `MessageStatusUpdateEntityResolver: unable to resolve entity of type 'MessageStatusUpdate' for id '${messageStatusUpdateId}'`,
            );
          }
          return messageStatusUpdate;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class NewAgencyLocationRequestEntityFetchService extends ClientSyncFetchService<NewAgencyLocationRequestRecord> {
  constructor(
    byIdQuery: FetchNewAgencyLocationRequestByIdGQL,
    byIdsQuery: FetchNewAgencyLocationRequestByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectNewAgencyLocationRequestById,
      selectNewAgencyLocationRequestEntitiesByIds,
      NewAgencyLocationRequestRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class NewAgencyLocationRequestEntityResolver {
  constructor(private readonly _fetchService: NewAgencyLocationRequestEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<NewAgencyLocationRequestRecord> {
    const newAgencyLocationRequestId: string | undefined = [
      route.params.newAgencyLocationRequestId,
      route.params.id,
      route.queryParams.newAgencyLocationRequestId,
    ].find((id) => id != null);
    if (newAgencyLocationRequestId == null) {
      throw new Error(
        `NewAgencyLocationRequestEntityResolver: Unable to resolve entity of type 'NewAgencyLocationRequest'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(newAgencyLocationRequestId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((newAgencyLocationRequest) => {
          if (newAgencyLocationRequest == null) {
            throw new Error(
              `NewAgencyLocationRequestEntityResolver: unable to resolve entity of type 'NewAgencyLocationRequest' for id '${newAgencyLocationRequestId}'`,
            );
          }
          return newAgencyLocationRequest;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class NextDueTypeEntityFetchService extends ClientSyncFetchService<NextDueTypeRecord> {
  constructor(
    byIdQuery: FetchNextDueTypeByIdGQL,
    byIdsQuery: FetchNextDueTypeByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectNextDueTypeById,
      selectNextDueTypeEntitiesByIds,
      NextDueTypeRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class NextDueTypeEntityResolver {
  constructor(private readonly _fetchService: NextDueTypeEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<NextDueTypeRecord> {
    const nextDueTypeId: string | undefined = [
      route.params.nextDueTypeId,
      route.params.id,
      route.queryParams.nextDueTypeId,
    ].find((id) => id != null);
    if (nextDueTypeId == null) {
      throw new Error(
        `NextDueTypeEntityResolver: Unable to resolve entity of type 'NextDueType'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(nextDueTypeId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((nextDueType) => {
        if (nextDueType == null) {
          throw new Error(
            `NextDueTypeEntityResolver: unable to resolve entity of type 'NextDueType' for id '${nextDueTypeId}'`,
          );
        }
        return nextDueType;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class NonReferralReasonEntityFetchService extends ClientSyncFetchService<NonReferralReasonRecord> {
  constructor(
    byIdQuery: FetchNonReferralReasonByIdGQL,
    byIdsQuery: FetchNonReferralReasonByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectNonReferralReasonById,
      selectNonReferralReasonEntitiesByIds,
      NonReferralReasonRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class NonReferralReasonEntityResolver {
  constructor(private readonly _fetchService: NonReferralReasonEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<NonReferralReasonRecord> {
    const nonReferralReasonId: string | undefined = [
      route.params.nonReferralReasonId,
      route.params.id,
      route.queryParams.nonReferralReasonId,
    ].find((id) => id != null);
    if (nonReferralReasonId == null) {
      throw new Error(
        `NonReferralReasonEntityResolver: Unable to resolve entity of type 'NonReferralReason'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(nonReferralReasonId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((nonReferralReason) => {
          if (nonReferralReason == null) {
            throw new Error(
              `NonReferralReasonEntityResolver: unable to resolve entity of type 'NonReferralReason' for id '${nonReferralReasonId}'`,
            );
          }
          return nonReferralReason;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class NotificationEntityFetchService extends ClientSyncFetchService<NotificationRecord> {
  constructor(
    byIdQuery: FetchNotificationByIdGQL,
    byIdsQuery: FetchNotificationByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectNotificationById,
      selectNotificationEntitiesByIds,
      NotificationRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class NotificationEntityResolver {
  constructor(private readonly _fetchService: NotificationEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<NotificationRecord> {
    const notificationId: string | undefined = [
      route.params.notificationId,
      route.params.id,
      route.queryParams.notificationId,
    ].find((id) => id != null);
    if (notificationId == null) {
      throw new Error(
        `NotificationEntityResolver: Unable to resolve entity of type 'Notification'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(notificationId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((notification) => {
        if (notification == null) {
          throw new Error(
            `NotificationEntityResolver: unable to resolve entity of type 'Notification' for id '${notificationId}'`,
          );
        }
        return notification;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class NotificationGroupEntityFetchService extends ClientSyncFetchService<NotificationGroupRecord> {
  constructor(
    byIdQuery: FetchNotificationGroupByIdGQL,
    byIdsQuery: FetchNotificationGroupByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectNotificationGroupById,
      selectNotificationGroupEntitiesByIds,
      NotificationGroupRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class NotificationGroupEntityResolver {
  constructor(private readonly _fetchService: NotificationGroupEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<NotificationGroupRecord> {
    const notificationGroupId: string | undefined = [
      route.params.notificationGroupId,
      route.params.id,
      route.queryParams.notificationGroupId,
    ].find((id) => id != null);
    if (notificationGroupId == null) {
      throw new Error(
        `NotificationGroupEntityResolver: Unable to resolve entity of type 'NotificationGroup'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(notificationGroupId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((notificationGroup) => {
          if (notificationGroup == null) {
            throw new Error(
              `NotificationGroupEntityResolver: unable to resolve entity of type 'NotificationGroup' for id '${notificationGroupId}'`,
            );
          }
          return notificationGroup;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class NotificationGroupMemberEntityFetchService extends ClientSyncFetchService<NotificationGroupMemberRecord> {
  constructor(
    byIdQuery: FetchNotificationGroupMemberByIdGQL,
    byIdsQuery: FetchNotificationGroupMemberByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectNotificationGroupMemberById,
      selectNotificationGroupMemberEntitiesByIds,
      NotificationGroupMemberRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class NotificationGroupMemberEntityResolver {
  constructor(private readonly _fetchService: NotificationGroupMemberEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<NotificationGroupMemberRecord> {
    const notificationGroupMemberId: string | undefined = [
      route.params.notificationGroupMemberId,
      route.params.id,
      route.queryParams.notificationGroupMemberId,
    ].find((id) => id != null);
    if (notificationGroupMemberId == null) {
      throw new Error(
        `NotificationGroupMemberEntityResolver: Unable to resolve entity of type 'NotificationGroupMember'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(notificationGroupMemberId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((notificationGroupMember) => {
          if (notificationGroupMember == null) {
            throw new Error(
              `NotificationGroupMemberEntityResolver: unable to resolve entity of type 'NotificationGroupMember' for id '${notificationGroupMemberId}'`,
            );
          }
          return notificationGroupMember;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class NotificationRecipientEntityFetchService extends ClientSyncFetchService<NotificationRecipientRecord> {
  constructor(
    byIdQuery: FetchNotificationRecipientByIdGQL,
    byIdsQuery: FetchNotificationRecipientByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectNotificationRecipientById,
      selectNotificationRecipientEntitiesByIds,
      NotificationRecipientRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class NotificationRecipientEntityResolver {
  constructor(private readonly _fetchService: NotificationRecipientEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<NotificationRecipientRecord> {
    const notificationRecipientId: string | undefined = [
      route.params.notificationRecipientId,
      route.params.id,
      route.queryParams.notificationRecipientId,
    ].find((id) => id != null);
    if (notificationRecipientId == null) {
      throw new Error(
        `NotificationRecipientEntityResolver: Unable to resolve entity of type 'NotificationRecipient'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(notificationRecipientId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((notificationRecipient) => {
          if (notificationRecipient == null) {
            throw new Error(
              `NotificationRecipientEntityResolver: unable to resolve entity of type 'NotificationRecipient' for id '${notificationRecipientId}'`,
            );
          }
          return notificationRecipient;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class NotificationSubscriptionEntityFetchService extends ClientSyncFetchService<NotificationSubscriptionRecord> {
  constructor(
    byIdQuery: FetchNotificationSubscriptionByIdGQL,
    byIdsQuery: FetchNotificationSubscriptionByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectNotificationSubscriptionById,
      selectNotificationSubscriptionEntitiesByIds,
      NotificationSubscriptionRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class NotificationSubscriptionEntityResolver {
  constructor(private readonly _fetchService: NotificationSubscriptionEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<NotificationSubscriptionRecord> {
    const notificationSubscriptionId: string | undefined = [
      route.params.notificationSubscriptionId,
      route.params.id,
      route.queryParams.notificationSubscriptionId,
    ].find((id) => id != null);
    if (notificationSubscriptionId == null) {
      throw new Error(
        `NotificationSubscriptionEntityResolver: Unable to resolve entity of type 'NotificationSubscription'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(notificationSubscriptionId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((notificationSubscription) => {
          if (notificationSubscription == null) {
            throw new Error(
              `NotificationSubscriptionEntityResolver: unable to resolve entity of type 'NotificationSubscription' for id '${notificationSubscriptionId}'`,
            );
          }
          return notificationSubscription;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class NotificationTemplateEntityFetchService extends ClientSyncFetchService<NotificationTemplateRecord> {
  constructor(
    byIdQuery: FetchNotificationTemplateByIdGQL,
    byIdsQuery: FetchNotificationTemplateByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectNotificationTemplateById,
      selectNotificationTemplateEntitiesByIds,
      NotificationTemplateRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class NotificationTemplateEntityResolver {
  constructor(private readonly _fetchService: NotificationTemplateEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<NotificationTemplateRecord> {
    const notificationTemplateId: string | undefined = [
      route.params.notificationTemplateId,
      route.params.id,
      route.queryParams.notificationTemplateId,
    ].find((id) => id != null);
    if (notificationTemplateId == null) {
      throw new Error(
        `NotificationTemplateEntityResolver: Unable to resolve entity of type 'NotificationTemplate'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(notificationTemplateId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((notificationTemplate) => {
          if (notificationTemplate == null) {
            throw new Error(
              `NotificationTemplateEntityResolver: unable to resolve entity of type 'NotificationTemplate' for id '${notificationTemplateId}'`,
            );
          }
          return notificationTemplate;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class OemActivityEntityFetchService extends ClientSyncFetchService<OemActivityRecord> {
  constructor(
    byIdQuery: FetchOemActivityByIdGQL,
    byIdsQuery: FetchOemActivityByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectOemActivityById,
      selectOemActivityEntitiesByIds,
      OemActivityRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class OemActivityEntityResolver {
  constructor(private readonly _fetchService: OemActivityEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<OemActivityRecord> {
    const oemActivityId: string | undefined = [
      route.params.oemActivityId,
      route.params.id,
      route.queryParams.oemActivityId,
    ].find((id) => id != null);
    if (oemActivityId == null) {
      throw new Error(
        `OemActivityEntityResolver: Unable to resolve entity of type 'OemActivity'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(oemActivityId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((oemActivity) => {
        if (oemActivity == null) {
          throw new Error(
            `OemActivityEntityResolver: unable to resolve entity of type 'OemActivity' for id '${oemActivityId}'`,
          );
        }
        return oemActivity;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class OemAssetEntityFetchService extends ClientSyncFetchService<OemAssetRecord> {
  constructor(
    byIdQuery: FetchOemAssetByIdGQL,
    byIdsQuery: FetchOemAssetByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectOemAssetById,
      selectOemAssetEntitiesByIds,
      OemAssetRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class OemAssetEntityResolver {
  constructor(private readonly _fetchService: OemAssetEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<OemAssetRecord> {
    const oemAssetId: string | undefined = [
      route.params.oemAssetId,
      route.params.id,
      route.queryParams.oemAssetId,
    ].find((id) => id != null);
    if (oemAssetId == null) {
      throw new Error(
        `OemAssetEntityResolver: Unable to resolve entity of type 'OemAsset'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(oemAssetId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((oemAsset) => {
        if (oemAsset == null) {
          throw new Error(
            `OemAssetEntityResolver: unable to resolve entity of type 'OemAsset' for id '${oemAssetId}'`,
          );
        }
        return oemAsset;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class OemPlanChangeRequestEntityFetchService extends ClientSyncFetchService<OemPlanChangeRequestRecord> {
  constructor(
    byIdQuery: FetchOemPlanChangeRequestByIdGQL,
    byIdsQuery: FetchOemPlanChangeRequestByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectOemPlanChangeRequestById,
      selectOemPlanChangeRequestEntitiesByIds,
      OemPlanChangeRequestRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class OemPlanChangeRequestEntityResolver {
  constructor(private readonly _fetchService: OemPlanChangeRequestEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<OemPlanChangeRequestRecord> {
    const oemPlanChangeRequestId: string | undefined = [
      route.params.oemPlanChangeRequestId,
      route.params.id,
      route.queryParams.oemPlanChangeRequestId,
    ].find((id) => id != null);
    if (oemPlanChangeRequestId == null) {
      throw new Error(
        `OemPlanChangeRequestEntityResolver: Unable to resolve entity of type 'OemPlanChangeRequest'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(oemPlanChangeRequestId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((oemPlanChangeRequest) => {
          if (oemPlanChangeRequest == null) {
            throw new Error(
              `OemPlanChangeRequestEntityResolver: unable to resolve entity of type 'OemPlanChangeRequest' for id '${oemPlanChangeRequestId}'`,
            );
          }
          return oemPlanChangeRequest;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class OemPlanEntityFetchService extends ClientSyncFetchService<OemPlanRecord> {
  constructor(
    byIdQuery: FetchOemPlanByIdGQL,
    byIdsQuery: FetchOemPlanByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectOemPlanById,
      selectOemPlanEntitiesByIds,
      OemPlanRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class OemPlanEntityResolver {
  constructor(private readonly _fetchService: OemPlanEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<OemPlanRecord> {
    const oemPlanId: string | undefined = [
      route.params.oemPlanId,
      route.params.id,
      route.queryParams.oemPlanId,
    ].find((id) => id != null);
    if (oemPlanId == null) {
      throw new Error(
        `OemPlanEntityResolver: Unable to resolve entity of type 'OemPlan'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(oemPlanId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((oemPlan) => {
        if (oemPlan == null) {
          throw new Error(
            `OemPlanEntityResolver: unable to resolve entity of type 'OemPlan' for id '${oemPlanId}'`,
          );
        }
        return oemPlan;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class OfferAlgorithmEntityFetchService extends ClientSyncFetchService<OfferAlgorithmRecord> {
  constructor(
    byIdQuery: FetchOfferAlgorithmByIdGQL,
    byIdsQuery: FetchOfferAlgorithmByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectOfferAlgorithmById,
      selectOfferAlgorithmEntitiesByIds,
      OfferAlgorithmRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class OfferAlgorithmEntityResolver {
  constructor(private readonly _fetchService: OfferAlgorithmEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<OfferAlgorithmRecord> {
    const offerAlgorithmId: string | undefined = [
      route.params.offerAlgorithmId,
      route.params.id,
      route.queryParams.offerAlgorithmId,
    ].find((id) => id != null);
    if (offerAlgorithmId == null) {
      throw new Error(
        `OfferAlgorithmEntityResolver: Unable to resolve entity of type 'OfferAlgorithm'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(offerAlgorithmId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((offerAlgorithm) => {
        if (offerAlgorithm == null) {
          throw new Error(
            `OfferAlgorithmEntityResolver: unable to resolve entity of type 'OfferAlgorithm' for id '${offerAlgorithmId}'`,
          );
        }
        return offerAlgorithm;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class OperationEntityFetchService extends ClientSyncFetchService<OperationRecord> {
  constructor(
    byIdQuery: FetchOperationByIdGQL,
    byIdsQuery: FetchOperationByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectOperationById,
      selectOperationEntitiesByIds,
      OperationRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class OperationEntityResolver {
  constructor(private readonly _fetchService: OperationEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<OperationRecord> {
    const operationId: string | undefined = [
      route.params.operationId,
      route.params.id,
      route.queryParams.operationId,
    ].find((id) => id != null);
    if (operationId == null) {
      throw new Error(
        `OperationEntityResolver: Unable to resolve entity of type 'Operation'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(operationId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((operation) => {
        if (operation == null) {
          throw new Error(
            `OperationEntityResolver: unable to resolve entity of type 'Operation' for id '${operationId}'`,
          );
        }
        return operation;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class OutOfServiceEventEntityFetchService extends ClientSyncFetchService<OutOfServiceEventRecord> {
  constructor(
    byIdQuery: FetchOutOfServiceEventByIdGQL,
    byIdsQuery: FetchOutOfServiceEventByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectOutOfServiceEventById,
      selectOutOfServiceEventEntitiesByIds,
      OutOfServiceEventRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class OutOfServiceEventEntityResolver {
  constructor(private readonly _fetchService: OutOfServiceEventEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<OutOfServiceEventRecord> {
    const outOfServiceEventId: string | undefined = [
      route.params.outOfServiceEventId,
      route.params.id,
      route.queryParams.outOfServiceEventId,
    ].find((id) => id != null);
    if (outOfServiceEventId == null) {
      throw new Error(
        `OutOfServiceEventEntityResolver: Unable to resolve entity of type 'OutOfServiceEvent'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(outOfServiceEventId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((outOfServiceEvent) => {
          if (outOfServiceEvent == null) {
            throw new Error(
              `OutOfServiceEventEntityResolver: unable to resolve entity of type 'OutOfServiceEvent' for id '${outOfServiceEventId}'`,
            );
          }
          return outOfServiceEvent;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class OutOfServiceEventNoteEntityFetchService extends ClientSyncFetchService<OutOfServiceEventNoteRecord> {
  constructor(
    byIdQuery: FetchOutOfServiceEventNoteByIdGQL,
    byIdsQuery: FetchOutOfServiceEventNoteByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectOutOfServiceEventNoteById,
      selectOutOfServiceEventNoteEntitiesByIds,
      OutOfServiceEventNoteRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class OutOfServiceEventNoteEntityResolver {
  constructor(private readonly _fetchService: OutOfServiceEventNoteEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<OutOfServiceEventNoteRecord> {
    const outOfServiceEventNoteId: string | undefined = [
      route.params.outOfServiceEventNoteId,
      route.params.id,
      route.queryParams.outOfServiceEventNoteId,
    ].find((id) => id != null);
    if (outOfServiceEventNoteId == null) {
      throw new Error(
        `OutOfServiceEventNoteEntityResolver: Unable to resolve entity of type 'OutOfServiceEventNote'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(outOfServiceEventNoteId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((outOfServiceEventNote) => {
          if (outOfServiceEventNote == null) {
            throw new Error(
              `OutOfServiceEventNoteEntityResolver: unable to resolve entity of type 'OutOfServiceEventNote' for id '${outOfServiceEventNoteId}'`,
            );
          }
          return outOfServiceEventNote;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class OutOfServiceReasonEntityFetchService extends ClientSyncFetchService<OutOfServiceReasonRecord> {
  constructor(
    byIdQuery: FetchOutOfServiceReasonByIdGQL,
    byIdsQuery: FetchOutOfServiceReasonByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectOutOfServiceReasonById,
      selectOutOfServiceReasonEntitiesByIds,
      OutOfServiceReasonRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class OutOfServiceReasonEntityResolver {
  constructor(private readonly _fetchService: OutOfServiceReasonEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<OutOfServiceReasonRecord> {
    const outOfServiceReasonId: string | undefined = [
      route.params.outOfServiceReasonId,
      route.params.id,
      route.queryParams.outOfServiceReasonId,
    ].find((id) => id != null);
    if (outOfServiceReasonId == null) {
      throw new Error(
        `OutOfServiceReasonEntityResolver: Unable to resolve entity of type 'OutOfServiceReason'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(outOfServiceReasonId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((outOfServiceReason) => {
          if (outOfServiceReason == null) {
            throw new Error(
              `OutOfServiceReasonEntityResolver: unable to resolve entity of type 'OutOfServiceReason' for id '${outOfServiceReasonId}'`,
            );
          }
          return outOfServiceReason;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class OutOfServiceSecondaryReasonEntityFetchService extends ClientSyncFetchService<OutOfServiceSecondaryReasonRecord> {
  constructor(
    byIdQuery: FetchOutOfServiceSecondaryReasonByIdGQL,
    byIdsQuery: FetchOutOfServiceSecondaryReasonByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectOutOfServiceSecondaryReasonById,
      selectOutOfServiceSecondaryReasonEntitiesByIds,
      OutOfServiceSecondaryReasonRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class OutOfServiceSecondaryReasonEntityResolver {
  constructor(private readonly _fetchService: OutOfServiceSecondaryReasonEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<OutOfServiceSecondaryReasonRecord> {
    const outOfServiceSecondaryReasonId: string | undefined = [
      route.params.outOfServiceSecondaryReasonId,
      route.params.id,
      route.queryParams.outOfServiceSecondaryReasonId,
    ].find((id) => id != null);
    if (outOfServiceSecondaryReasonId == null) {
      throw new Error(
        `OutOfServiceSecondaryReasonEntityResolver: Unable to resolve entity of type 'OutOfServiceSecondaryReason'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(outOfServiceSecondaryReasonId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((outOfServiceSecondaryReason) => {
          if (outOfServiceSecondaryReason == null) {
            throw new Error(
              `OutOfServiceSecondaryReasonEntityResolver: unable to resolve entity of type 'OutOfServiceSecondaryReason' for id '${outOfServiceSecondaryReasonId}'`,
            );
          }
          return outOfServiceSecondaryReason;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class OutOfServiceTicketEntityFetchService extends ClientSyncFetchService<OutOfServiceTicketRecord> {
  constructor(
    byIdQuery: FetchOutOfServiceTicketByIdGQL,
    byIdsQuery: FetchOutOfServiceTicketByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectOutOfServiceTicketById,
      selectOutOfServiceTicketEntitiesByIds,
      OutOfServiceTicketRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class OutOfServiceTicketEntityResolver {
  constructor(private readonly _fetchService: OutOfServiceTicketEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<OutOfServiceTicketRecord> {
    const outOfServiceTicketId: string | undefined = [
      route.params.outOfServiceTicketId,
      route.params.id,
      route.queryParams.outOfServiceTicketId,
    ].find((id) => id != null);
    if (outOfServiceTicketId == null) {
      throw new Error(
        `OutOfServiceTicketEntityResolver: Unable to resolve entity of type 'OutOfServiceTicket'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(outOfServiceTicketId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((outOfServiceTicket) => {
          if (outOfServiceTicket == null) {
            throw new Error(
              `OutOfServiceTicketEntityResolver: unable to resolve entity of type 'OutOfServiceTicket' for id '${outOfServiceTicketId}'`,
            );
          }
          return outOfServiceTicket;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class PaipEventEntityFetchService extends ClientSyncFetchService<PaipEventRecord> {
  constructor(
    byIdQuery: FetchPaipEventByIdGQL,
    byIdsQuery: FetchPaipEventByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectPaipEventById,
      selectPaipEventEntitiesByIds,
      PaipEventRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class PaipEventEntityResolver {
  constructor(private readonly _fetchService: PaipEventEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<PaipEventRecord> {
    const paipEventId: string | undefined = [
      route.params.paipEventId,
      route.params.id,
      route.queryParams.paipEventId,
    ].find((id) => id != null);
    if (paipEventId == null) {
      throw new Error(
        `PaipEventEntityResolver: Unable to resolve entity of type 'PaipEvent'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(paipEventId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((paipEvent) => {
        if (paipEvent == null) {
          throw new Error(
            `PaipEventEntityResolver: unable to resolve entity of type 'PaipEvent' for id '${paipEventId}'`,
          );
        }
        return paipEvent;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class PaipReasonEntityFetchService extends ClientSyncFetchService<PaipReasonRecord> {
  constructor(
    byIdQuery: FetchPaipReasonByIdGQL,
    byIdsQuery: FetchPaipReasonByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectPaipReasonById,
      selectPaipReasonEntitiesByIds,
      PaipReasonRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class PaipReasonEntityResolver {
  constructor(private readonly _fetchService: PaipReasonEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<PaipReasonRecord> {
    const paipReasonId: string | undefined = [
      route.params.paipReasonId,
      route.params.id,
      route.queryParams.paipReasonId,
    ].find((id) => id != null);
    if (paipReasonId == null) {
      throw new Error(
        `PaipReasonEntityResolver: Unable to resolve entity of type 'PaipReason'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(paipReasonId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((paipReason) => {
        if (paipReason == null) {
          throw new Error(
            `PaipReasonEntityResolver: unable to resolve entity of type 'PaipReason' for id '${paipReasonId}'`,
          );
        }
        return paipReason;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class PassdownLogAcknowledgementEntityFetchService extends ClientSyncFetchService<PassdownLogAcknowledgementRecord> {
  constructor(
    byIdQuery: FetchPassdownLogAcknowledgementByIdGQL,
    byIdsQuery: FetchPassdownLogAcknowledgementByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectPassdownLogAcknowledgementById,
      selectPassdownLogAcknowledgementEntitiesByIds,
      PassdownLogAcknowledgementRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class PassdownLogAcknowledgementEntityResolver {
  constructor(private readonly _fetchService: PassdownLogAcknowledgementEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<PassdownLogAcknowledgementRecord> {
    const passdownLogAcknowledgementId: string | undefined = [
      route.params.passdownLogAcknowledgementId,
      route.params.id,
      route.queryParams.passdownLogAcknowledgementId,
    ].find((id) => id != null);
    if (passdownLogAcknowledgementId == null) {
      throw new Error(
        `PassdownLogAcknowledgementEntityResolver: Unable to resolve entity of type 'PassdownLogAcknowledgement'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(passdownLogAcknowledgementId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((passdownLogAcknowledgement) => {
          if (passdownLogAcknowledgement == null) {
            throw new Error(
              `PassdownLogAcknowledgementEntityResolver: unable to resolve entity of type 'PassdownLogAcknowledgement' for id '${passdownLogAcknowledgementId}'`,
            );
          }
          return passdownLogAcknowledgement;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class PassdownLogArchivedLogEntityFetchService extends ClientSyncFetchService<PassdownLogArchivedLogRecord> {
  constructor(
    byIdQuery: FetchPassdownLogArchivedLogByIdGQL,
    byIdsQuery: FetchPassdownLogArchivedLogByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectPassdownLogArchivedLogById,
      selectPassdownLogArchivedLogEntitiesByIds,
      PassdownLogArchivedLogRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class PassdownLogArchivedLogEntityResolver {
  constructor(private readonly _fetchService: PassdownLogArchivedLogEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<PassdownLogArchivedLogRecord> {
    const passdownLogArchivedLogId: string | undefined = [
      route.params.passdownLogArchivedLogId,
      route.params.id,
      route.queryParams.passdownLogArchivedLogId,
    ].find((id) => id != null);
    if (passdownLogArchivedLogId == null) {
      throw new Error(
        `PassdownLogArchivedLogEntityResolver: Unable to resolve entity of type 'PassdownLogArchivedLog'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(passdownLogArchivedLogId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((passdownLogArchivedLog) => {
          if (passdownLogArchivedLog == null) {
            throw new Error(
              `PassdownLogArchivedLogEntityResolver: unable to resolve entity of type 'PassdownLogArchivedLog' for id '${passdownLogArchivedLogId}'`,
            );
          }
          return passdownLogArchivedLog;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class PassdownLogEntityFetchService extends ClientSyncFetchService<PassdownLogRecord> {
  constructor(
    byIdQuery: FetchPassdownLogByIdGQL,
    byIdsQuery: FetchPassdownLogByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectPassdownLogById,
      selectPassdownLogEntitiesByIds,
      PassdownLogRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class PassdownLogEntityResolver {
  constructor(private readonly _fetchService: PassdownLogEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<PassdownLogRecord> {
    const passdownLogId: string | undefined = [
      route.params.passdownLogId,
      route.params.id,
      route.queryParams.passdownLogId,
    ].find((id) => id != null);
    if (passdownLogId == null) {
      throw new Error(
        `PassdownLogEntityResolver: Unable to resolve entity of type 'PassdownLog'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(passdownLogId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((passdownLog) => {
        if (passdownLog == null) {
          throw new Error(
            `PassdownLogEntityResolver: unable to resolve entity of type 'PassdownLog' for id '${passdownLogId}'`,
          );
        }
        return passdownLog;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class PatientEntityFetchService extends ClientSyncFetchService<PatientRecord> {
  constructor(
    byIdQuery: FetchPatientByIdGQL,
    byIdsQuery: FetchPatientByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectPatientById,
      selectPatientEntitiesByIds,
      PatientRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class PatientEntityResolver {
  constructor(private readonly _fetchService: PatientEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<PatientRecord> {
    const patientId: string | undefined = [
      route.params.patientId,
      route.params.id,
      route.queryParams.patientId,
    ].find((id) => id != null);
    if (patientId == null) {
      throw new Error(
        `PatientEntityResolver: Unable to resolve entity of type 'Patient'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(patientId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((patient) => {
        if (patient == null) {
          throw new Error(
            `PatientEntityResolver: unable to resolve entity of type 'Patient' for id '${patientId}'`,
          );
        }
        return patient;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class PositionReportAlertEntityFetchService extends ClientSyncFetchService<PositionReportAlertRecord> {
  constructor(
    byIdQuery: FetchPositionReportAlertByIdGQL,
    byIdsQuery: FetchPositionReportAlertByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectPositionReportAlertById,
      selectPositionReportAlertEntitiesByIds,
      PositionReportAlertRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class PositionReportAlertEntityResolver {
  constructor(private readonly _fetchService: PositionReportAlertEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<PositionReportAlertRecord> {
    const positionReportAlertId: string | undefined = [
      route.params.positionReportAlertId,
      route.params.id,
      route.queryParams.positionReportAlertId,
    ].find((id) => id != null);
    if (positionReportAlertId == null) {
      throw new Error(
        `PositionReportAlertEntityResolver: Unable to resolve entity of type 'PositionReportAlert'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(positionReportAlertId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((positionReportAlert) => {
          if (positionReportAlert == null) {
            throw new Error(
              `PositionReportAlertEntityResolver: unable to resolve entity of type 'PositionReportAlert' for id '${positionReportAlertId}'`,
            );
          }
          return positionReportAlert;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class PositionReportArchiveEntityFetchService extends ClientSyncFetchService<PositionReportArchiveRecord> {
  constructor(
    byIdQuery: FetchPositionReportArchiveByIdGQL,
    byIdsQuery: FetchPositionReportArchiveByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectPositionReportArchiveById,
      selectPositionReportArchiveEntitiesByIds,
      PositionReportArchiveRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class PositionReportArchiveEntityResolver {
  constructor(private readonly _fetchService: PositionReportArchiveEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<PositionReportArchiveRecord> {
    const positionReportArchiveId: string | undefined = [
      route.params.positionReportArchiveId,
      route.params.id,
      route.queryParams.positionReportArchiveId,
    ].find((id) => id != null);
    if (positionReportArchiveId == null) {
      throw new Error(
        `PositionReportArchiveEntityResolver: Unable to resolve entity of type 'PositionReportArchive'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(positionReportArchiveId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((positionReportArchive) => {
          if (positionReportArchive == null) {
            throw new Error(
              `PositionReportArchiveEntityResolver: unable to resolve entity of type 'PositionReportArchive' for id '${positionReportArchiveId}'`,
            );
          }
          return positionReportArchive;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class PositionReportEntityFetchService extends ClientSyncFetchService<PositionReportRecord> {
  constructor(
    byIdQuery: FetchPositionReportByIdGQL,
    byIdsQuery: FetchPositionReportByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectPositionReportById,
      selectPositionReportEntitiesByIds,
      PositionReportRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class PositionReportEntityResolver {
  constructor(private readonly _fetchService: PositionReportEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<PositionReportRecord> {
    const positionReportId: string | undefined = [
      route.params.positionReportId,
      route.params.id,
      route.queryParams.positionReportId,
    ].find((id) => id != null);
    if (positionReportId == null) {
      throw new Error(
        `PositionReportEntityResolver: Unable to resolve entity of type 'PositionReport'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(positionReportId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((positionReport) => {
        if (positionReport == null) {
          throw new Error(
            `PositionReportEntityResolver: unable to resolve entity of type 'PositionReport' for id '${positionReportId}'`,
          );
        }
        return positionReport;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class QuestionChoiceEntityFetchService extends ClientSyncFetchService<QuestionChoiceRecord> {
  constructor(
    byIdQuery: FetchQuestionChoiceByIdGQL,
    byIdsQuery: FetchQuestionChoiceByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectQuestionChoiceById,
      selectQuestionChoiceEntitiesByIds,
      QuestionChoiceRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class QuestionChoiceEntityResolver {
  constructor(private readonly _fetchService: QuestionChoiceEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<QuestionChoiceRecord> {
    const questionChoiceId: string | undefined = [
      route.params.questionChoiceId,
      route.params.id,
      route.queryParams.questionChoiceId,
    ].find((id) => id != null);
    if (questionChoiceId == null) {
      throw new Error(
        `QuestionChoiceEntityResolver: Unable to resolve entity of type 'QuestionChoice'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(questionChoiceId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((questionChoice) => {
        if (questionChoice == null) {
          throw new Error(
            `QuestionChoiceEntityResolver: unable to resolve entity of type 'QuestionChoice' for id '${questionChoiceId}'`,
          );
        }
        return questionChoice;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class QuestionEntityFetchService extends ClientSyncFetchService<QuestionRecord> {
  constructor(
    byIdQuery: FetchQuestionByIdGQL,
    byIdsQuery: FetchQuestionByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectQuestionById,
      selectQuestionEntitiesByIds,
      QuestionRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class QuestionEntityResolver {
  constructor(private readonly _fetchService: QuestionEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<QuestionRecord> {
    const questionId: string | undefined = [
      route.params.questionId,
      route.params.id,
      route.queryParams.questionId,
    ].find((id) => id != null);
    if (questionId == null) {
      throw new Error(
        `QuestionEntityResolver: Unable to resolve entity of type 'Question'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(questionId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((question) => {
        if (question == null) {
          throw new Error(
            `QuestionEntityResolver: unable to resolve entity of type 'Question' for id '${questionId}'`,
          );
        }
        return question;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class QuestionnaireEntityFetchService extends ClientSyncFetchService<QuestionnaireRecord> {
  constructor(
    byIdQuery: FetchQuestionnaireByIdGQL,
    byIdsQuery: FetchQuestionnaireByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectQuestionnaireById,
      selectQuestionnaireEntitiesByIds,
      QuestionnaireRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class QuestionnaireEntityResolver {
  constructor(private readonly _fetchService: QuestionnaireEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<QuestionnaireRecord> {
    const questionnaireId: string | undefined = [
      route.params.questionnaireId,
      route.params.id,
      route.queryParams.questionnaireId,
    ].find((id) => id != null);
    if (questionnaireId == null) {
      throw new Error(
        `QuestionnaireEntityResolver: Unable to resolve entity of type 'Questionnaire'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(questionnaireId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((questionnaire) => {
        if (questionnaire == null) {
          throw new Error(
            `QuestionnaireEntityResolver: unable to resolve entity of type 'Questionnaire' for id '${questionnaireId}'`,
          );
        }
        return questionnaire;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class QuestionnaireQuestionResponseEntityFetchService extends ClientSyncFetchService<QuestionnaireQuestionResponseRecord> {
  constructor(
    byIdQuery: FetchQuestionnaireQuestionResponseByIdGQL,
    byIdsQuery: FetchQuestionnaireQuestionResponseByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectQuestionnaireQuestionResponseById,
      selectQuestionnaireQuestionResponseEntitiesByIds,
      QuestionnaireQuestionResponseRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class QuestionnaireQuestionResponseEntityResolver {
  constructor(private readonly _fetchService: QuestionnaireQuestionResponseEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<QuestionnaireQuestionResponseRecord> {
    const questionnaireQuestionResponseId: string | undefined = [
      route.params.questionnaireQuestionResponseId,
      route.params.id,
      route.queryParams.questionnaireQuestionResponseId,
    ].find((id) => id != null);
    if (questionnaireQuestionResponseId == null) {
      throw new Error(
        `QuestionnaireQuestionResponseEntityResolver: Unable to resolve entity of type 'QuestionnaireQuestionResponse'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(questionnaireQuestionResponseId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((questionnaireQuestionResponse) => {
          if (questionnaireQuestionResponse == null) {
            throw new Error(
              `QuestionnaireQuestionResponseEntityResolver: unable to resolve entity of type 'QuestionnaireQuestionResponse' for id '${questionnaireQuestionResponseId}'`,
            );
          }
          return questionnaireQuestionResponse;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class QuestionnaireQuestionResponseNoteEntityFetchService extends ClientSyncFetchService<QuestionnaireQuestionResponseNoteRecord> {
  constructor(
    byIdQuery: FetchQuestionnaireQuestionResponseNoteByIdGQL,
    byIdsQuery: FetchQuestionnaireQuestionResponseNoteByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectQuestionnaireQuestionResponseNoteById,
      selectQuestionnaireQuestionResponseNoteEntitiesByIds,
      QuestionnaireQuestionResponseNoteRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class QuestionnaireQuestionResponseNoteEntityResolver {
  constructor(
    private readonly _fetchService: QuestionnaireQuestionResponseNoteEntityFetchService,
  ) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<QuestionnaireQuestionResponseNoteRecord> {
    const questionnaireQuestionResponseNoteId: string | undefined = [
      route.params.questionnaireQuestionResponseNoteId,
      route.params.id,
      route.queryParams.questionnaireQuestionResponseNoteId,
    ].find((id) => id != null);
    if (questionnaireQuestionResponseNoteId == null) {
      throw new Error(
        `QuestionnaireQuestionResponseNoteEntityResolver: Unable to resolve entity of type 'QuestionnaireQuestionResponseNote'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(questionnaireQuestionResponseNoteId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((questionnaireQuestionResponseNote) => {
          if (questionnaireQuestionResponseNote == null) {
            throw new Error(
              `QuestionnaireQuestionResponseNoteEntityResolver: unable to resolve entity of type 'QuestionnaireQuestionResponseNote' for id '${questionnaireQuestionResponseNoteId}'`,
            );
          }
          return questionnaireQuestionResponseNote;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class QuestionnaireResponseEntityFetchService extends ClientSyncFetchService<QuestionnaireResponseRecord> {
  constructor(
    byIdQuery: FetchQuestionnaireResponseByIdGQL,
    byIdsQuery: FetchQuestionnaireResponseByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectQuestionnaireResponseById,
      selectQuestionnaireResponseEntitiesByIds,
      QuestionnaireResponseRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class QuestionnaireResponseEntityResolver {
  constructor(private readonly _fetchService: QuestionnaireResponseEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<QuestionnaireResponseRecord> {
    const questionnaireResponseId: string | undefined = [
      route.params.questionnaireResponseId,
      route.params.id,
      route.queryParams.questionnaireResponseId,
    ].find((id) => id != null);
    if (questionnaireResponseId == null) {
      throw new Error(
        `QuestionnaireResponseEntityResolver: Unable to resolve entity of type 'QuestionnaireResponse'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(questionnaireResponseId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((questionnaireResponse) => {
          if (questionnaireResponse == null) {
            throw new Error(
              `QuestionnaireResponseEntityResolver: unable to resolve entity of type 'QuestionnaireResponse' for id '${questionnaireResponseId}'`,
            );
          }
          return questionnaireResponse;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class QuestionnaireSectionEntityFetchService extends ClientSyncFetchService<QuestionnaireSectionRecord> {
  constructor(
    byIdQuery: FetchQuestionnaireSectionByIdGQL,
    byIdsQuery: FetchQuestionnaireSectionByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectQuestionnaireSectionById,
      selectQuestionnaireSectionEntitiesByIds,
      QuestionnaireSectionRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class QuestionnaireSectionEntityResolver {
  constructor(private readonly _fetchService: QuestionnaireSectionEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<QuestionnaireSectionRecord> {
    const questionnaireSectionId: string | undefined = [
      route.params.questionnaireSectionId,
      route.params.id,
      route.queryParams.questionnaireSectionId,
    ].find((id) => id != null);
    if (questionnaireSectionId == null) {
      throw new Error(
        `QuestionnaireSectionEntityResolver: Unable to resolve entity of type 'QuestionnaireSection'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(questionnaireSectionId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((questionnaireSection) => {
          if (questionnaireSection == null) {
            throw new Error(
              `QuestionnaireSectionEntityResolver: unable to resolve entity of type 'QuestionnaireSection' for id '${questionnaireSectionId}'`,
            );
          }
          return questionnaireSection;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class QuestionnaireSectionQuestionEntityFetchService extends ClientSyncFetchService<QuestionnaireSectionQuestionRecord> {
  constructor(
    byIdQuery: FetchQuestionnaireSectionQuestionByIdGQL,
    byIdsQuery: FetchQuestionnaireSectionQuestionByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectQuestionnaireSectionQuestionById,
      selectQuestionnaireSectionQuestionEntitiesByIds,
      QuestionnaireSectionQuestionRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class QuestionnaireSectionQuestionEntityResolver {
  constructor(private readonly _fetchService: QuestionnaireSectionQuestionEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<QuestionnaireSectionQuestionRecord> {
    const questionnaireSectionQuestionId: string | undefined = [
      route.params.questionnaireSectionQuestionId,
      route.params.id,
      route.queryParams.questionnaireSectionQuestionId,
    ].find((id) => id != null);
    if (questionnaireSectionQuestionId == null) {
      throw new Error(
        `QuestionnaireSectionQuestionEntityResolver: Unable to resolve entity of type 'QuestionnaireSectionQuestion'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(questionnaireSectionQuestionId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((questionnaireSectionQuestion) => {
          if (questionnaireSectionQuestion == null) {
            throw new Error(
              `QuestionnaireSectionQuestionEntityResolver: unable to resolve entity of type 'QuestionnaireSectionQuestion' for id '${questionnaireSectionQuestionId}'`,
            );
          }
          return questionnaireSectionQuestion;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class ReceivingFacilityRequestEntityFetchService extends ClientSyncFetchService<ReceivingFacilityRequestRecord> {
  constructor(
    byIdQuery: FetchReceivingFacilityRequestByIdGQL,
    byIdsQuery: FetchReceivingFacilityRequestByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectReceivingFacilityRequestById,
      selectReceivingFacilityRequestEntitiesByIds,
      ReceivingFacilityRequestRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ReceivingFacilityRequestEntityResolver {
  constructor(private readonly _fetchService: ReceivingFacilityRequestEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<ReceivingFacilityRequestRecord> {
    const receivingFacilityRequestId: string | undefined = [
      route.params.receivingFacilityRequestId,
      route.params.id,
      route.queryParams.receivingFacilityRequestId,
    ].find((id) => id != null);
    if (receivingFacilityRequestId == null) {
      throw new Error(
        `ReceivingFacilityRequestEntityResolver: Unable to resolve entity of type 'ReceivingFacilityRequest'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(receivingFacilityRequestId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((receivingFacilityRequest) => {
          if (receivingFacilityRequest == null) {
            throw new Error(
              `ReceivingFacilityRequestEntityResolver: unable to resolve entity of type 'ReceivingFacilityRequest' for id '${receivingFacilityRequestId}'`,
            );
          }
          return receivingFacilityRequest;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class RendezvousRequestEntityFetchService extends ClientSyncFetchService<RendezvousRequestRecord> {
  constructor(
    byIdQuery: FetchRendezvousRequestByIdGQL,
    byIdsQuery: FetchRendezvousRequestByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectRendezvousRequestById,
      selectRendezvousRequestEntitiesByIds,
      RendezvousRequestRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class RendezvousRequestEntityResolver {
  constructor(private readonly _fetchService: RendezvousRequestEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<RendezvousRequestRecord> {
    const rendezvousRequestId: string | undefined = [
      route.params.rendezvousRequestId,
      route.params.id,
      route.queryParams.rendezvousRequestId,
    ].find((id) => id != null);
    if (rendezvousRequestId == null) {
      throw new Error(
        `RendezvousRequestEntityResolver: Unable to resolve entity of type 'RendezvousRequest'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(rendezvousRequestId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((rendezvousRequest) => {
          if (rendezvousRequest == null) {
            throw new Error(
              `RendezvousRequestEntityResolver: unable to resolve entity of type 'RendezvousRequest' for id '${rendezvousRequestId}'`,
            );
          }
          return rendezvousRequest;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class RequestEntityFetchService extends ClientSyncFetchService<RequestRecord> {
  constructor(
    byIdQuery: FetchRequestByIdGQL,
    byIdsQuery: FetchRequestByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectRequestById,
      selectRequestEntitiesByIds,
      RequestRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class RequestEntityResolver {
  constructor(private readonly _fetchService: RequestEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<RequestRecord> {
    const requestId: string | undefined = [
      route.params.requestId,
      route.params.id,
      route.queryParams.requestId,
    ].find((id) => id != null);
    if (requestId == null) {
      throw new Error(
        `RequestEntityResolver: Unable to resolve entity of type 'Request'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(requestId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((request) => {
        if (request == null) {
          throw new Error(
            `RequestEntityResolver: unable to resolve entity of type 'Request' for id '${requestId}'`,
          );
        }
        return request;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class RequesterEntityFetchService extends ClientSyncFetchService<RequesterRecord> {
  constructor(
    byIdQuery: FetchRequesterByIdGQL,
    byIdsQuery: FetchRequesterByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectRequesterById,
      selectRequesterEntitiesByIds,
      RequesterRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class RequesterEntityResolver {
  constructor(private readonly _fetchService: RequesterEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<RequesterRecord> {
    const requesterId: string | undefined = [
      route.params.requesterId,
      route.params.id,
      route.queryParams.requesterId,
    ].find((id) => id != null);
    if (requesterId == null) {
      throw new Error(
        `RequesterEntityResolver: Unable to resolve entity of type 'Requester'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(requesterId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((requester) => {
        if (requester == null) {
          throw new Error(
            `RequesterEntityResolver: unable to resolve entity of type 'Requester' for id '${requesterId}'`,
          );
        }
        return requester;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class RequesterReferralReasonEntityFetchService extends ClientSyncFetchService<RequesterReferralReasonRecord> {
  constructor(
    byIdQuery: FetchRequesterReferralReasonByIdGQL,
    byIdsQuery: FetchRequesterReferralReasonByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectRequesterReferralReasonById,
      selectRequesterReferralReasonEntitiesByIds,
      RequesterReferralReasonRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class RequesterReferralReasonEntityResolver {
  constructor(private readonly _fetchService: RequesterReferralReasonEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<RequesterReferralReasonRecord> {
    const requesterReferralReasonId: string | undefined = [
      route.params.requesterReferralReasonId,
      route.params.id,
      route.queryParams.requesterReferralReasonId,
    ].find((id) => id != null);
    if (requesterReferralReasonId == null) {
      throw new Error(
        `RequesterReferralReasonEntityResolver: Unable to resolve entity of type 'RequesterReferralReason'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(requesterReferralReasonId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((requesterReferralReason) => {
          if (requesterReferralReason == null) {
            throw new Error(
              `RequesterReferralReasonEntityResolver: unable to resolve entity of type 'RequesterReferralReason' for id '${requesterReferralReasonId}'`,
            );
          }
          return requesterReferralReason;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class RequesterRoleEntityFetchService extends ClientSyncFetchService<RequesterRoleRecord> {
  constructor(
    byIdQuery: FetchRequesterRoleByIdGQL,
    byIdsQuery: FetchRequesterRoleByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectRequesterRoleById,
      selectRequesterRoleEntitiesByIds,
      RequesterRoleRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class RequesterRoleEntityResolver {
  constructor(private readonly _fetchService: RequesterRoleEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<RequesterRoleRecord> {
    const requesterRoleId: string | undefined = [
      route.params.requesterRoleId,
      route.params.id,
      route.queryParams.requesterRoleId,
    ].find((id) => id != null);
    if (requesterRoleId == null) {
      throw new Error(
        `RequesterRoleEntityResolver: Unable to resolve entity of type 'RequesterRole'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(requesterRoleId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((requesterRole) => {
        if (requesterRole == null) {
          throw new Error(
            `RequesterRoleEntityResolver: unable to resolve entity of type 'RequesterRole' for id '${requesterRoleId}'`,
          );
        }
        return requesterRole;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class RequestLocationEntityFetchService extends ClientSyncFetchService<RequestLocationRecord> {
  constructor(
    byIdQuery: FetchRequestLocationByIdGQL,
    byIdsQuery: FetchRequestLocationByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectRequestLocationById,
      selectRequestLocationEntitiesByIds,
      RequestLocationRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class RequestLocationEntityResolver {
  constructor(private readonly _fetchService: RequestLocationEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<RequestLocationRecord> {
    const requestLocationId: string | undefined = [
      route.params.requestLocationId,
      route.params.id,
      route.queryParams.requestLocationId,
    ].find((id) => id != null);
    if (requestLocationId == null) {
      throw new Error(
        `RequestLocationEntityResolver: Unable to resolve entity of type 'RequestLocation'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(requestLocationId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((requestLocation) => {
          if (requestLocation == null) {
            throw new Error(
              `RequestLocationEntityResolver: unable to resolve entity of type 'RequestLocation' for id '${requestLocationId}'`,
            );
          }
          return requestLocation;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class RequestPatientEntityFetchService extends ClientSyncFetchService<RequestPatientRecord> {
  constructor(
    byIdQuery: FetchRequestPatientByIdGQL,
    byIdsQuery: FetchRequestPatientByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectRequestPatientById,
      selectRequestPatientEntitiesByIds,
      RequestPatientRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class RequestPatientEntityResolver {
  constructor(private readonly _fetchService: RequestPatientEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<RequestPatientRecord> {
    const requestPatientId: string | undefined = [
      route.params.requestPatientId,
      route.params.id,
      route.queryParams.requestPatientId,
    ].find((id) => id != null);
    if (requestPatientId == null) {
      throw new Error(
        `RequestPatientEntityResolver: Unable to resolve entity of type 'RequestPatient'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(requestPatientId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((requestPatient) => {
        if (requestPatient == null) {
          throw new Error(
            `RequestPatientEntityResolver: unable to resolve entity of type 'RequestPatient' for id '${requestPatientId}'`,
          );
        }
        return requestPatient;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class SystemTimerEntityFetchService extends ClientSyncFetchService<SystemTimerRecord> {
  constructor(
    byIdQuery: FetchSystemTimerByIdGQL,
    byIdsQuery: FetchSystemTimerByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectSystemTimerById,
      selectSystemTimerEntitiesByIds,
      SystemTimerRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class SystemTimerEntityResolver {
  constructor(private readonly _fetchService: SystemTimerEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<SystemTimerRecord> {
    const systemTimerId: string | undefined = [
      route.params.systemTimerId,
      route.params.id,
      route.queryParams.systemTimerId,
    ].find((id) => id != null);
    if (systemTimerId == null) {
      throw new Error(
        `SystemTimerEntityResolver: Unable to resolve entity of type 'SystemTimer'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(systemTimerId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((systemTimer) => {
        if (systemTimer == null) {
          throw new Error(
            `SystemTimerEntityResolver: unable to resolve entity of type 'SystemTimer' for id '${systemTimerId}'`,
          );
        }
        return systemTimer;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TimelineEntityFetchService extends ClientSyncFetchService<TimelineRecord> {
  constructor(
    byIdQuery: FetchTimelineByIdGQL,
    byIdsQuery: FetchTimelineByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectTimelineById,
      selectTimelineEntitiesByIds,
      TimelineRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TimelineEntityResolver {
  constructor(private readonly _fetchService: TimelineEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<TimelineRecord> {
    const timelineId: string | undefined = [
      route.params.timelineId,
      route.params.id,
      route.queryParams.timelineId,
    ].find((id) => id != null);
    if (timelineId == null) {
      throw new Error(
        `TimelineEntityResolver: Unable to resolve entity of type 'Timeline'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(timelineId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((timeline) => {
        if (timeline == null) {
          throw new Error(
            `TimelineEntityResolver: unable to resolve entity of type 'Timeline' for id '${timelineId}'`,
          );
        }
        return timeline;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TimelineItemEntityFetchService extends ClientSyncFetchService<TimelineItemRecord> {
  constructor(
    byIdQuery: FetchTimelineItemByIdGQL,
    byIdsQuery: FetchTimelineItemByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectTimelineItemById,
      selectTimelineItemEntitiesByIds,
      TimelineItemRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TimelineItemEntityResolver {
  constructor(private readonly _fetchService: TimelineItemEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<TimelineItemRecord> {
    const timelineItemId: string | undefined = [
      route.params.timelineItemId,
      route.params.id,
      route.queryParams.timelineItemId,
    ].find((id) => id != null);
    if (timelineItemId == null) {
      throw new Error(
        `TimelineItemEntityResolver: Unable to resolve entity of type 'TimelineItem'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(timelineItemId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((timelineItem) => {
        if (timelineItem == null) {
          throw new Error(
            `TimelineItemEntityResolver: unable to resolve entity of type 'TimelineItem' for id '${timelineItemId}'`,
          );
        }
        return timelineItem;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TimestampEntityFetchService extends ClientSyncFetchService<TimestampRecord> {
  constructor(
    byIdQuery: FetchTimestampByIdGQL,
    byIdsQuery: FetchTimestampByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectTimestampById,
      selectTimestampEntitiesByIds,
      TimestampRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TimestampEntityResolver {
  constructor(private readonly _fetchService: TimestampEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<TimestampRecord> {
    const timestampId: string | undefined = [
      route.params.timestampId,
      route.params.id,
      route.queryParams.timestampId,
    ].find((id) => id != null);
    if (timestampId == null) {
      throw new Error(
        `TimestampEntityResolver: Unable to resolve entity of type 'Timestamp'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(timestampId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((timestamp) => {
        if (timestamp == null) {
          throw new Error(
            `TimestampEntityResolver: unable to resolve entity of type 'Timestamp' for id '${timestampId}'`,
          );
        }
        return timestamp;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TimestampTypeEntityFetchService extends ClientSyncFetchService<TimestampTypeRecord> {
  constructor(
    byIdQuery: FetchTimestampTypeByIdGQL,
    byIdsQuery: FetchTimestampTypeByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectTimestampTypeById,
      selectTimestampTypeEntitiesByIds,
      TimestampTypeRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TimestampTypeEntityResolver {
  constructor(private readonly _fetchService: TimestampTypeEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<TimestampTypeRecord> {
    const timestampTypeId: string | undefined = [
      route.params.timestampTypeId,
      route.params.id,
      route.queryParams.timestampTypeId,
    ].find((id) => id != null);
    if (timestampTypeId == null) {
      throw new Error(
        `TimestampTypeEntityResolver: Unable to resolve entity of type 'TimestampType'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(timestampTypeId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((timestampType) => {
        if (timestampType == null) {
          throw new Error(
            `TimestampTypeEntityResolver: unable to resolve entity of type 'TimestampType' for id '${timestampTypeId}'`,
          );
        }
        return timestampType;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TrackedMessageEntityFetchService extends ClientSyncFetchService<TrackedMessageRecord> {
  constructor(
    byIdQuery: FetchTrackedMessageByIdGQL,
    byIdsQuery: FetchTrackedMessageByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectTrackedMessageById,
      selectTrackedMessageEntitiesByIds,
      TrackedMessageRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TrackedMessageEntityResolver {
  constructor(private readonly _fetchService: TrackedMessageEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<TrackedMessageRecord> {
    const trackedMessageId: string | undefined = [
      route.params.trackedMessageId,
      route.params.id,
      route.queryParams.trackedMessageId,
    ].find((id) => id != null);
    if (trackedMessageId == null) {
      throw new Error(
        `TrackedMessageEntityResolver: Unable to resolve entity of type 'TrackedMessage'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(trackedMessageId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((trackedMessage) => {
        if (trackedMessage == null) {
          throw new Error(
            `TrackedMessageEntityResolver: unable to resolve entity of type 'TrackedMessage' for id '${trackedMessageId}'`,
          );
        }
        return trackedMessage;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TransferReasonEntityFetchService extends ClientSyncFetchService<TransferReasonRecord> {
  constructor(
    byIdQuery: FetchTransferReasonByIdGQL,
    byIdsQuery: FetchTransferReasonByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectTransferReasonById,
      selectTransferReasonEntitiesByIds,
      TransferReasonRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TransferReasonEntityResolver {
  constructor(private readonly _fetchService: TransferReasonEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<TransferReasonRecord> {
    const transferReasonId: string | undefined = [
      route.params.transferReasonId,
      route.params.id,
      route.queryParams.transferReasonId,
    ].find((id) => id != null);
    if (transferReasonId == null) {
      throw new Error(
        `TransferReasonEntityResolver: Unable to resolve entity of type 'TransferReason'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(transferReasonId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((transferReason) => {
        if (transferReason == null) {
          throw new Error(
            `TransferReasonEntityResolver: unable to resolve entity of type 'TransferReason' for id '${transferReasonId}'`,
          );
        }
        return transferReason;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TransportOfferEntityFetchService extends ClientSyncFetchService<TransportOfferRecord> {
  constructor(
    byIdQuery: FetchTransportOfferByIdGQL,
    byIdsQuery: FetchTransportOfferByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectTransportOfferById,
      selectTransportOfferEntitiesByIds,
      TransportOfferRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TransportOfferEntityResolver {
  constructor(private readonly _fetchService: TransportOfferEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<TransportOfferRecord> {
    const transportOfferId: string | undefined = [
      route.params.transportOfferId,
      route.params.id,
      route.queryParams.transportOfferId,
    ].find((id) => id != null);
    if (transportOfferId == null) {
      throw new Error(
        `TransportOfferEntityResolver: Unable to resolve entity of type 'TransportOffer'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(transportOfferId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((transportOffer) => {
        if (transportOffer == null) {
          throw new Error(
            `TransportOfferEntityResolver: unable to resolve entity of type 'TransportOffer' for id '${transportOfferId}'`,
          );
        }
        return transportOffer;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TransportOfferOptionEntityFetchService extends ClientSyncFetchService<TransportOfferOptionRecord> {
  constructor(
    byIdQuery: FetchTransportOfferOptionByIdGQL,
    byIdsQuery: FetchTransportOfferOptionByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectTransportOfferOptionById,
      selectTransportOfferOptionEntitiesByIds,
      TransportOfferOptionRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TransportOfferOptionEntityResolver {
  constructor(private readonly _fetchService: TransportOfferOptionEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<TransportOfferOptionRecord> {
    const transportOfferOptionId: string | undefined = [
      route.params.transportOfferOptionId,
      route.params.id,
      route.queryParams.transportOfferOptionId,
    ].find((id) => id != null);
    if (transportOfferOptionId == null) {
      throw new Error(
        `TransportOfferOptionEntityResolver: Unable to resolve entity of type 'TransportOfferOption'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(transportOfferOptionId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((transportOfferOption) => {
          if (transportOfferOption == null) {
            throw new Error(
              `TransportOfferOptionEntityResolver: unable to resolve entity of type 'TransportOfferOption' for id '${transportOfferOptionId}'`,
            );
          }
          return transportOfferOption;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class TransportReasonEntityFetchService extends ClientSyncFetchService<TransportReasonRecord> {
  constructor(
    byIdQuery: FetchTransportReasonByIdGQL,
    byIdsQuery: FetchTransportReasonByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectTransportReasonById,
      selectTransportReasonEntitiesByIds,
      TransportReasonRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TransportReasonEntityResolver {
  constructor(private readonly _fetchService: TransportReasonEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<TransportReasonRecord> {
    const transportReasonId: string | undefined = [
      route.params.transportReasonId,
      route.params.id,
      route.queryParams.transportReasonId,
    ].find((id) => id != null);
    if (transportReasonId == null) {
      throw new Error(
        `TransportReasonEntityResolver: Unable to resolve entity of type 'TransportReason'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(transportReasonId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((transportReason) => {
          if (transportReason == null) {
            throw new Error(
              `TransportReasonEntityResolver: unable to resolve entity of type 'TransportReason' for id '${transportReasonId}'`,
            );
          }
          return transportReason;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class TripEntityFetchService extends ClientSyncFetchService<TripRecord> {
  constructor(
    byIdQuery: FetchTripByIdGQL,
    byIdsQuery: FetchTripByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectTripById,
      selectTripEntitiesByIds,
      TripRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TripEntityResolver {
  constructor(private readonly _fetchService: TripEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<TripRecord> {
    const tripId: string | undefined = [
      route.params.tripId,
      route.params.id,
      route.queryParams.tripId,
    ].find((id) => id != null);
    if (tripId == null) {
      throw new Error(
        `TripEntityResolver: Unable to resolve entity of type 'Trip'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(tripId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((trip) => {
        if (trip == null) {
          throw new Error(
            `TripEntityResolver: unable to resolve entity of type 'Trip' for id '${tripId}'`,
          );
        }
        return trip;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TripLegEntityFetchService extends ClientSyncFetchService<TripLegRecord> {
  constructor(
    byIdQuery: FetchTripLegByIdGQL,
    byIdsQuery: FetchTripLegByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectTripLegById,
      selectTripLegEntitiesByIds,
      TripLegRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TripLegEntityResolver {
  constructor(private readonly _fetchService: TripLegEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<TripLegRecord> {
    const tripLegId: string | undefined = [
      route.params.tripLegId,
      route.params.id,
      route.queryParams.tripLegId,
    ].find((id) => id != null);
    if (tripLegId == null) {
      throw new Error(
        `TripLegEntityResolver: Unable to resolve entity of type 'TripLeg'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(tripLegId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((tripLeg) => {
        if (tripLeg == null) {
          throw new Error(
            `TripLegEntityResolver: unable to resolve entity of type 'TripLeg' for id '${tripLegId}'`,
          );
        }
        return tripLeg;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TripPassengerEntityFetchService extends ClientSyncFetchService<TripPassengerRecord> {
  constructor(
    byIdQuery: FetchTripPassengerByIdGQL,
    byIdsQuery: FetchTripPassengerByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectTripPassengerById,
      selectTripPassengerEntitiesByIds,
      TripPassengerRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TripPassengerEntityResolver {
  constructor(private readonly _fetchService: TripPassengerEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<TripPassengerRecord> {
    const tripPassengerId: string | undefined = [
      route.params.tripPassengerId,
      route.params.id,
      route.queryParams.tripPassengerId,
    ].find((id) => id != null);
    if (tripPassengerId == null) {
      throw new Error(
        `TripPassengerEntityResolver: Unable to resolve entity of type 'TripPassenger'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(tripPassengerId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((tripPassenger) => {
        if (tripPassenger == null) {
          throw new Error(
            `TripPassengerEntityResolver: unable to resolve entity of type 'TripPassenger' for id '${tripPassengerId}'`,
          );
        }
        return tripPassenger;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class UnitActivationRuleEntityFetchService extends ClientSyncFetchService<UnitActivationRuleRecord> {
  constructor(
    byIdQuery: FetchUnitActivationRuleByIdGQL,
    byIdsQuery: FetchUnitActivationRuleByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectUnitActivationRuleById,
      selectUnitActivationRuleEntitiesByIds,
      UnitActivationRuleRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class UnitActivationRuleEntityResolver {
  constructor(private readonly _fetchService: UnitActivationRuleEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<UnitActivationRuleRecord> {
    const unitActivationRuleId: string | undefined = [
      route.params.unitActivationRuleId,
      route.params.id,
      route.queryParams.unitActivationRuleId,
    ].find((id) => id != null);
    if (unitActivationRuleId == null) {
      throw new Error(
        `UnitActivationRuleEntityResolver: Unable to resolve entity of type 'UnitActivationRule'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(unitActivationRuleId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((unitActivationRule) => {
          if (unitActivationRule == null) {
            throw new Error(
              `UnitActivationRuleEntityResolver: unable to resolve entity of type 'UnitActivationRule' for id '${unitActivationRuleId}'`,
            );
          }
          return unitActivationRule;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class UnitEMSystemMappingEntityFetchService extends ClientSyncFetchService<UnitEMSystemMappingRecord> {
  constructor(
    byIdQuery: FetchUnitEMSystemMappingByIdGQL,
    byIdsQuery: FetchUnitEMSystemMappingByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectUnitEMSystemMappingById,
      selectUnitEMSystemMappingEntitiesByIds,
      UnitEMSystemMappingRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class UnitEMSystemMappingEntityResolver {
  constructor(private readonly _fetchService: UnitEMSystemMappingEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<UnitEMSystemMappingRecord> {
    const unitEMSystemMappingId: string | undefined = [
      route.params.unitEMSystemMappingId,
      route.params.id,
      route.queryParams.unitEMSystemMappingId,
    ].find((id) => id != null);
    if (unitEMSystemMappingId == null) {
      throw new Error(
        `UnitEMSystemMappingEntityResolver: Unable to resolve entity of type 'UnitEMSystemMapping'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(unitEMSystemMappingId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((unitEMSystemMapping) => {
          if (unitEMSystemMapping == null) {
            throw new Error(
              `UnitEMSystemMappingEntityResolver: unable to resolve entity of type 'UnitEMSystemMapping' for id '${unitEMSystemMappingId}'`,
            );
          }
          return unitEMSystemMapping;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class UnitEntityFetchService extends ClientSyncFetchService<UnitRecord> {
  constructor(
    byIdQuery: FetchUnitByIdGQL,
    byIdsQuery: FetchUnitByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectUnitById,
      selectUnitEntitiesByIds,
      UnitRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class UnitEntityResolver {
  constructor(private readonly _fetchService: UnitEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<UnitRecord> {
    const unitId: string | undefined = [
      route.params.unitId,
      route.params.id,
      route.queryParams.unitId,
    ].find((id) => id != null);
    if (unitId == null) {
      throw new Error(
        `UnitEntityResolver: Unable to resolve entity of type 'Unit'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(unitId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((unit) => {
        if (unit == null) {
          throw new Error(
            `UnitEntityResolver: unable to resolve entity of type 'Unit' for id '${unitId}'`,
          );
        }
        return unit;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class UnitNoteEntityFetchService extends ClientSyncFetchService<UnitNoteRecord> {
  constructor(
    byIdQuery: FetchUnitNoteByIdGQL,
    byIdsQuery: FetchUnitNoteByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectUnitNoteById,
      selectUnitNoteEntitiesByIds,
      UnitNoteRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class UnitNoteEntityResolver {
  constructor(private readonly _fetchService: UnitNoteEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<UnitNoteRecord> {
    const unitNoteId: string | undefined = [
      route.params.unitNoteId,
      route.params.id,
      route.queryParams.unitNoteId,
    ].find((id) => id != null);
    if (unitNoteId == null) {
      throw new Error(
        `UnitNoteEntityResolver: Unable to resolve entity of type 'UnitNote'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(unitNoteId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((unitNote) => {
        if (unitNote == null) {
          throw new Error(
            `UnitNoteEntityResolver: unable to resolve entity of type 'UnitNote' for id '${unitNoteId}'`,
          );
        }
        return unitNote;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class UnitPositionEntityFetchService extends ClientSyncFetchService<UnitPositionRecord> {
  constructor(
    byIdQuery: FetchUnitPositionByIdGQL,
    byIdsQuery: FetchUnitPositionByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectUnitPositionById,
      selectUnitPositionEntitiesByIds,
      UnitPositionRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class UnitPositionEntityResolver {
  constructor(private readonly _fetchService: UnitPositionEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<UnitPositionRecord> {
    const unitPositionId: string | undefined = [
      route.params.unitPositionId,
      route.params.id,
      route.queryParams.unitPositionId,
    ].find((id) => id != null);
    if (unitPositionId == null) {
      throw new Error(
        `UnitPositionEntityResolver: Unable to resolve entity of type 'UnitPosition'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(unitPositionId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((unitPosition) => {
        if (unitPosition == null) {
          throw new Error(
            `UnitPositionEntityResolver: unable to resolve entity of type 'UnitPosition' for id '${unitPositionId}'`,
          );
        }
        return unitPosition;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class UnitShiftEntityFetchService extends ClientSyncFetchService<UnitShiftRecord> {
  constructor(
    byIdQuery: FetchUnitShiftByIdGQL,
    byIdsQuery: FetchUnitShiftByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectUnitShiftById,
      selectUnitShiftEntitiesByIds,
      UnitShiftRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class UnitShiftEntityResolver {
  constructor(private readonly _fetchService: UnitShiftEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<UnitShiftRecord> {
    const unitShiftId: string | undefined = [
      route.params.unitShiftId,
      route.params.id,
      route.queryParams.unitShiftId,
    ].find((id) => id != null);
    if (unitShiftId == null) {
      throw new Error(
        `UnitShiftEntityResolver: Unable to resolve entity of type 'UnitShift'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(unitShiftId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((unitShift) => {
        if (unitShift == null) {
          throw new Error(
            `UnitShiftEntityResolver: unable to resolve entity of type 'UnitShift' for id '${unitShiftId}'`,
          );
        }
        return unitShift;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class UnitStatusHistoryEntryEntityFetchService extends ClientSyncFetchService<UnitStatusHistoryEntryRecord> {
  constructor(
    byIdQuery: FetchUnitStatusHistoryEntryByIdGQL,
    byIdsQuery: FetchUnitStatusHistoryEntryByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectUnitStatusHistoryEntryById,
      selectUnitStatusHistoryEntryEntitiesByIds,
      UnitStatusHistoryEntryRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class UnitStatusHistoryEntryEntityResolver {
  constructor(private readonly _fetchService: UnitStatusHistoryEntryEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<UnitStatusHistoryEntryRecord> {
    const unitStatusHistoryEntryId: string | undefined = [
      route.params.unitStatusHistoryEntryId,
      route.params.id,
      route.queryParams.unitStatusHistoryEntryId,
    ].find((id) => id != null);
    if (unitStatusHistoryEntryId == null) {
      throw new Error(
        `UnitStatusHistoryEntryEntityResolver: Unable to resolve entity of type 'UnitStatusHistoryEntry'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(unitStatusHistoryEntryId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((unitStatusHistoryEntry) => {
          if (unitStatusHistoryEntry == null) {
            throw new Error(
              `UnitStatusHistoryEntryEntityResolver: unable to resolve entity of type 'UnitStatusHistoryEntry' for id '${unitStatusHistoryEntryId}'`,
            );
          }
          return unitStatusHistoryEntry;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class UnitSummaryEntityFetchService extends ClientSyncFetchService<UnitSummaryRecord> {
  constructor(
    byIdQuery: FetchUnitSummaryByIdGQL,
    byIdsQuery: FetchUnitSummaryByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectUnitSummaryById,
      selectUnitSummaryEntitiesByIds,
      UnitSummaryRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class UnitSummaryEntityResolver {
  constructor(private readonly _fetchService: UnitSummaryEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<UnitSummaryRecord> {
    const unitSummaryId: string | undefined = [
      route.params.unitSummaryId,
      route.params.id,
      route.queryParams.unitSummaryId,
    ].find((id) => id != null);
    if (unitSummaryId == null) {
      throw new Error(
        `UnitSummaryEntityResolver: Unable to resolve entity of type 'UnitSummary'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(unitSummaryId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((unitSummary) => {
        if (unitSummary == null) {
          throw new Error(
            `UnitSummaryEntityResolver: unable to resolve entity of type 'UnitSummary' for id '${unitSummaryId}'`,
          );
        }
        return unitSummary;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class VehicleDispositionEntityFetchService extends ClientSyncFetchService<VehicleDispositionRecord> {
  constructor(
    byIdQuery: FetchVehicleDispositionByIdGQL,
    byIdsQuery: FetchVehicleDispositionByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectVehicleDispositionById,
      selectVehicleDispositionEntitiesByIds,
      VehicleDispositionRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class VehicleDispositionEntityResolver {
  constructor(private readonly _fetchService: VehicleDispositionEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<VehicleDispositionRecord> {
    const vehicleDispositionId: string | undefined = [
      route.params.vehicleDispositionId,
      route.params.id,
      route.queryParams.vehicleDispositionId,
    ].find((id) => id != null);
    if (vehicleDispositionId == null) {
      throw new Error(
        `VehicleDispositionEntityResolver: Unable to resolve entity of type 'VehicleDisposition'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(vehicleDispositionId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((vehicleDisposition) => {
          if (vehicleDisposition == null) {
            throw new Error(
              `VehicleDispositionEntityResolver: unable to resolve entity of type 'VehicleDisposition' for id '${vehicleDispositionId}'`,
            );
          }
          return vehicleDisposition;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class VehicleNotificationGroupEntityFetchService extends ClientSyncFetchService<VehicleNotificationGroupRecord> {
  constructor(
    byIdQuery: FetchVehicleNotificationGroupByIdGQL,
    byIdsQuery: FetchVehicleNotificationGroupByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectVehicleNotificationGroupById,
      selectVehicleNotificationGroupEntitiesByIds,
      VehicleNotificationGroupRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class VehicleNotificationGroupEntityResolver {
  constructor(private readonly _fetchService: VehicleNotificationGroupEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<VehicleNotificationGroupRecord> {
    const vehicleNotificationGroupId: string | undefined = [
      route.params.vehicleNotificationGroupId,
      route.params.id,
      route.queryParams.vehicleNotificationGroupId,
    ].find((id) => id != null);
    if (vehicleNotificationGroupId == null) {
      throw new Error(
        `VehicleNotificationGroupEntityResolver: Unable to resolve entity of type 'VehicleNotificationGroup'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(vehicleNotificationGroupId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((vehicleNotificationGroup) => {
          if (vehicleNotificationGroup == null) {
            throw new Error(
              `VehicleNotificationGroupEntityResolver: unable to resolve entity of type 'VehicleNotificationGroup' for id '${vehicleNotificationGroupId}'`,
            );
          }
          return vehicleNotificationGroup;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class VehicleSummaryEntityFetchService extends ClientSyncFetchService<VehicleSummaryRecord> {
  constructor(
    byIdQuery: FetchVehicleSummaryByIdGQL,
    byIdsQuery: FetchVehicleSummaryByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectVehicleSummaryById,
      selectVehicleSummaryEntitiesByIds,
      VehicleSummaryRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class VehicleSummaryEntityResolver {
  constructor(private readonly _fetchService: VehicleSummaryEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<VehicleSummaryRecord> {
    const vehicleSummaryId: string | undefined = [
      route.params.vehicleSummaryId,
      route.params.id,
      route.queryParams.vehicleSummaryId,
    ].find((id) => id != null);
    if (vehicleSummaryId == null) {
      throw new Error(
        `VehicleSummaryEntityResolver: Unable to resolve entity of type 'VehicleSummary'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(vehicleSummaryId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((vehicleSummary) => {
        if (vehicleSummary == null) {
          throw new Error(
            `VehicleSummaryEntityResolver: unable to resolve entity of type 'VehicleSummary' for id '${vehicleSummaryId}'`,
          );
        }
        return vehicleSummary;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class WaypointEntityFetchService extends ClientSyncFetchService<WaypointRecord> {
  constructor(
    byIdQuery: FetchWaypointByIdGQL,
    byIdsQuery: FetchWaypointByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectWaypointById,
      selectWaypointEntitiesByIds,
      WaypointRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class WaypointEntityResolver {
  constructor(private readonly _fetchService: WaypointEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<WaypointRecord> {
    const waypointId: string | undefined = [
      route.params.waypointId,
      route.params.id,
      route.queryParams.waypointId,
    ].find((id) => id != null);
    if (waypointId == null) {
      throw new Error(
        `WaypointEntityResolver: Unable to resolve entity of type 'Waypoint'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(waypointId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((waypoint) => {
        if (waypoint == null) {
          throw new Error(
            `WaypointEntityResolver: unable to resolve entity of type 'Waypoint' for id '${waypointId}'`,
          );
        }
        return waypoint;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class WebOrderLogEntityFetchService extends ClientSyncFetchService<WebOrderLogRecord> {
  constructor(
    byIdQuery: FetchWebOrderLogByIdGQL,
    byIdsQuery: FetchWebOrderLogByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectWebOrderLogById,
      selectWebOrderLogEntitiesByIds,
      WebOrderLogRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class WebOrderLogEntityResolver {
  constructor(private readonly _fetchService: WebOrderLogEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<WebOrderLogRecord> {
    const webOrderLogId: string | undefined = [
      route.params.webOrderLogId,
      route.params.id,
      route.queryParams.webOrderLogId,
    ].find((id) => id != null);
    if (webOrderLogId == null) {
      throw new Error(
        `WebOrderLogEntityResolver: Unable to resolve entity of type 'WebOrderLog'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(webOrderLogId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((webOrderLog) => {
        if (webOrderLog == null) {
          throw new Error(
            `WebOrderLogEntityResolver: unable to resolve entity of type 'WebOrderLog' for id '${webOrderLogId}'`,
          );
        }
        return webOrderLog;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class AccessibleItemEntityFetchService extends ClientSyncFetchService<AccessibleItemRecord> {
  constructor(
    byIdQuery: FetchAccessibleItemByIdGQL,
    byIdsQuery: FetchAccessibleItemByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectAccessibleItemById,
      selectAccessibleItemEntitiesByIds,
      AccessibleItemRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class AccessibleItemEntityResolver {
  constructor(private readonly _fetchService: AccessibleItemEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<AccessibleItemRecord> {
    const accessibleItemId: string | undefined = [
      route.params.accessibleItemId,
      route.params.id,
      route.queryParams.accessibleItemId,
    ].find((id) => id != null);
    if (accessibleItemId == null) {
      throw new Error(
        `AccessibleItemEntityResolver: Unable to resolve entity of type 'AccessibleItem'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(accessibleItemId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((accessibleItem) => {
        if (accessibleItem == null) {
          throw new Error(
            `AccessibleItemEntityResolver: unable to resolve entity of type 'AccessibleItem' for id '${accessibleItemId}'`,
          );
        }
        return accessibleItem;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class AgencyEntityFetchService extends ClientSyncFetchService<AgencyRecord> {
  constructor(
    byIdQuery: FetchAgencyByIdGQL,
    byIdsQuery: FetchAgencyByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectAgencyById,
      selectAgencyEntitiesByIds,
      AgencyRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class AgencyEntityResolver {
  constructor(private readonly _fetchService: AgencyEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<AgencyRecord> {
    const agencyId: string | undefined = [
      route.params.agencyId,
      route.params.id,
      route.queryParams.agencyId,
    ].find((id) => id != null);
    if (agencyId == null) {
      throw new Error(
        `AgencyEntityResolver: Unable to resolve entity of type 'Agency'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(agencyId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((agency) => {
        if (agency == null) {
          throw new Error(
            `AgencyEntityResolver: unable to resolve entity of type 'Agency' for id '${agencyId}'`,
          );
        }
        return agency;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class AgencyLocationEntityFetchService extends ClientSyncFetchService<AgencyLocationRecord> {
  constructor(
    byIdQuery: FetchAgencyLocationByIdGQL,
    byIdsQuery: FetchAgencyLocationByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectAgencyLocationById,
      selectAgencyLocationEntitiesByIds,
      AgencyLocationRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class AgencyLocationEntityResolver {
  constructor(private readonly _fetchService: AgencyLocationEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<AgencyLocationRecord> {
    const agencyLocationId: string | undefined = [
      route.params.agencyLocationId,
      route.params.id,
      route.queryParams.agencyLocationId,
    ].find((id) => id != null);
    if (agencyLocationId == null) {
      throw new Error(
        `AgencyLocationEntityResolver: Unable to resolve entity of type 'AgencyLocation'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(agencyLocationId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((agencyLocation) => {
        if (agencyLocation == null) {
          throw new Error(
            `AgencyLocationEntityResolver: unable to resolve entity of type 'AgencyLocation' for id '${agencyLocationId}'`,
          );
        }
        return agencyLocation;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class AirportEntityFetchService extends ClientSyncFetchService<AirportRecord> {
  constructor(
    byIdQuery: FetchAirportByIdGQL,
    byIdsQuery: FetchAirportByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectAirportById,
      selectAirportEntitiesByIds,
      AirportRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class AirportEntityResolver {
  constructor(private readonly _fetchService: AirportEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<AirportRecord> {
    const airportId: string | undefined = [
      route.params.airportId,
      route.params.id,
      route.queryParams.airportId,
    ].find((id) => id != null);
    if (airportId == null) {
      throw new Error(
        `AirportEntityResolver: Unable to resolve entity of type 'Airport'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(airportId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((airport) => {
        if (airport == null) {
          throw new Error(
            `AirportEntityResolver: unable to resolve entity of type 'Airport' for id '${airportId}'`,
          );
        }
        return airport;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ArchiveLogEntityFetchService extends ClientSyncFetchService<ArchiveLogRecord> {
  constructor(
    byIdQuery: FetchArchiveLogByIdGQL,
    byIdsQuery: FetchArchiveLogByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectArchiveLogById,
      selectArchiveLogEntitiesByIds,
      ArchiveLogRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ArchiveLogEntityResolver {
  constructor(private readonly _fetchService: ArchiveLogEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<ArchiveLogRecord> {
    const archiveLogId: string | undefined = [
      route.params.archiveLogId,
      route.params.id,
      route.queryParams.archiveLogId,
    ].find((id) => id != null);
    if (archiveLogId == null) {
      throw new Error(
        `ArchiveLogEntityResolver: Unable to resolve entity of type 'ArchiveLog'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(archiveLogId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((archiveLog) => {
        if (archiveLog == null) {
          throw new Error(
            `ArchiveLogEntityResolver: unable to resolve entity of type 'ArchiveLog' for id '${archiveLogId}'`,
          );
        }
        return archiveLog;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class AttachmentEntityFetchService extends ClientSyncFetchService<AttachmentRecord> {
  constructor(
    byIdQuery: FetchAttachmentByIdGQL,
    byIdsQuery: FetchAttachmentByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectAttachmentById,
      selectAttachmentEntitiesByIds,
      AttachmentRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class AttachmentEntityResolver {
  constructor(private readonly _fetchService: AttachmentEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<AttachmentRecord> {
    const attachmentId: string | undefined = [
      route.params.attachmentId,
      route.params.id,
      route.queryParams.attachmentId,
    ].find((id) => id != null);
    if (attachmentId == null) {
      throw new Error(
        `AttachmentEntityResolver: Unable to resolve entity of type 'Attachment'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(attachmentId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((attachment) => {
        if (attachment == null) {
          throw new Error(
            `AttachmentEntityResolver: unable to resolve entity of type 'Attachment' for id '${attachmentId}'`,
          );
        }
        return attachment;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class BaseControlZoneEntityFetchService extends ClientSyncFetchService<BaseControlZoneRecord> {
  constructor(
    byIdQuery: FetchBaseControlZoneByIdGQL,
    byIdsQuery: FetchBaseControlZoneByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectBaseControlZoneById,
      selectBaseControlZoneEntitiesByIds,
      BaseControlZoneRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class BaseControlZoneEntityResolver {
  constructor(private readonly _fetchService: BaseControlZoneEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<BaseControlZoneRecord> {
    const baseControlZoneId: string | undefined = [
      route.params.baseControlZoneId,
      route.params.id,
      route.queryParams.baseControlZoneId,
    ].find((id) => id != null);
    if (baseControlZoneId == null) {
      throw new Error(
        `BaseControlZoneEntityResolver: Unable to resolve entity of type 'BaseControlZone'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(baseControlZoneId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((baseControlZone) => {
          if (baseControlZone == null) {
            throw new Error(
              `BaseControlZoneEntityResolver: unable to resolve entity of type 'BaseControlZone' for id '${baseControlZoneId}'`,
            );
          }
          return baseControlZone;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class BaseEntityFetchService extends ClientSyncFetchService<BaseRecord> {
  constructor(
    byIdQuery: FetchBaseByIdGQL,
    byIdsQuery: FetchBaseByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectBaseById,
      selectBaseEntitiesByIds,
      BaseRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class BaseEntityResolver {
  constructor(private readonly _fetchService: BaseEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<BaseRecord> {
    const baseId: string | undefined = [
      route.params.baseId,
      route.params.id,
      route.queryParams.baseId,
    ].find((id) => id != null);
    if (baseId == null) {
      throw new Error(
        `BaseEntityResolver: Unable to resolve entity of type 'Base'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(baseId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((base) => {
        if (base == null) {
          throw new Error(
            `BaseEntityResolver: unable to resolve entity of type 'Base' for id '${baseId}'`,
          );
        }
        return base;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class BaseMedicalControlContactEntityFetchService extends ClientSyncFetchService<BaseMedicalControlContactRecord> {
  constructor(
    byIdQuery: FetchBaseMedicalControlContactByIdGQL,
    byIdsQuery: FetchBaseMedicalControlContactByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectBaseMedicalControlContactById,
      selectBaseMedicalControlContactEntitiesByIds,
      BaseMedicalControlContactRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class BaseMedicalControlContactEntityResolver {
  constructor(private readonly _fetchService: BaseMedicalControlContactEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<BaseMedicalControlContactRecord> {
    const baseMedicalControlContactId: string | undefined = [
      route.params.baseMedicalControlContactId,
      route.params.id,
      route.queryParams.baseMedicalControlContactId,
    ].find((id) => id != null);
    if (baseMedicalControlContactId == null) {
      throw new Error(
        `BaseMedicalControlContactEntityResolver: Unable to resolve entity of type 'BaseMedicalControlContact'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(baseMedicalControlContactId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((baseMedicalControlContact) => {
          if (baseMedicalControlContact == null) {
            throw new Error(
              `BaseMedicalControlContactEntityResolver: unable to resolve entity of type 'BaseMedicalControlContact' for id '${baseMedicalControlContactId}'`,
            );
          }
          return baseMedicalControlContact;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class BaseMedicalControlContactStateEntityFetchService extends ClientSyncFetchService<BaseMedicalControlContactStateRecord> {
  constructor(
    byIdQuery: FetchBaseMedicalControlContactStateByIdGQL,
    byIdsQuery: FetchBaseMedicalControlContactStateByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectBaseMedicalControlContactStateById,
      selectBaseMedicalControlContactStateEntitiesByIds,
      BaseMedicalControlContactStateRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class BaseMedicalControlContactStateEntityResolver {
  constructor(private readonly _fetchService: BaseMedicalControlContactStateEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<BaseMedicalControlContactStateRecord> {
    const baseMedicalControlContactStateId: string | undefined = [
      route.params.baseMedicalControlContactStateId,
      route.params.id,
      route.queryParams.baseMedicalControlContactStateId,
    ].find((id) => id != null);
    if (baseMedicalControlContactStateId == null) {
      throw new Error(
        `BaseMedicalControlContactStateEntityResolver: Unable to resolve entity of type 'BaseMedicalControlContactState'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(baseMedicalControlContactStateId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((baseMedicalControlContactState) => {
          if (baseMedicalControlContactState == null) {
            throw new Error(
              `BaseMedicalControlContactStateEntityResolver: unable to resolve entity of type 'BaseMedicalControlContactState' for id '${baseMedicalControlContactStateId}'`,
            );
          }
          return baseMedicalControlContactState;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class CapabilityEntityFetchService extends ClientSyncFetchService<CapabilityRecord> {
  constructor(
    byIdQuery: FetchCapabilityByIdGQL,
    byIdsQuery: FetchCapabilityByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectCapabilityById,
      selectCapabilityEntitiesByIds,
      CapabilityRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class CapabilityEntityResolver {
  constructor(private readonly _fetchService: CapabilityEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<CapabilityRecord> {
    const capabilityId: string | undefined = [
      route.params.capabilityId,
      route.params.id,
      route.queryParams.capabilityId,
    ].find((id) => id != null);
    if (capabilityId == null) {
      throw new Error(
        `CapabilityEntityResolver: Unable to resolve entity of type 'Capability'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(capabilityId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((capability) => {
        if (capability == null) {
          throw new Error(
            `CapabilityEntityResolver: unable to resolve entity of type 'Capability' for id '${capabilityId}'`,
          );
        }
        return capability;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class CommunicationCenterEntityFetchService extends ClientSyncFetchService<CommunicationCenterRecord> {
  constructor(
    byIdQuery: FetchCommunicationCenterByIdGQL,
    byIdsQuery: FetchCommunicationCenterByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectCommunicationCenterById,
      selectCommunicationCenterEntitiesByIds,
      CommunicationCenterRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class CommunicationCenterEntityResolver {
  constructor(private readonly _fetchService: CommunicationCenterEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<CommunicationCenterRecord> {
    const communicationCenterId: string | undefined = [
      route.params.communicationCenterId,
      route.params.id,
      route.queryParams.communicationCenterId,
    ].find((id) => id != null);
    if (communicationCenterId == null) {
      throw new Error(
        `CommunicationCenterEntityResolver: Unable to resolve entity of type 'CommunicationCenter'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(communicationCenterId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((communicationCenter) => {
          if (communicationCenter == null) {
            throw new Error(
              `CommunicationCenterEntityResolver: unable to resolve entity of type 'CommunicationCenter' for id '${communicationCenterId}'`,
            );
          }
          return communicationCenter;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class CommunicationCenterTransportOfferOptionEntityFetchService extends ClientSyncFetchService<CommunicationCenterTransportOfferOptionRecord> {
  constructor(
    byIdQuery: FetchCommunicationCenterTransportOfferOptionByIdGQL,
    byIdsQuery: FetchCommunicationCenterTransportOfferOptionByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectCommunicationCenterTransportOfferOptionById,
      selectCommunicationCenterTransportOfferOptionEntitiesByIds,
      CommunicationCenterTransportOfferOptionRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class CommunicationCenterTransportOfferOptionEntityResolver {
  constructor(
    private readonly _fetchService: CommunicationCenterTransportOfferOptionEntityFetchService,
  ) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<CommunicationCenterTransportOfferOptionRecord> {
    const communicationCenterTransportOfferOptionId: string | undefined = [
      route.params.communicationCenterTransportOfferOptionId,
      route.params.id,
      route.queryParams.communicationCenterTransportOfferOptionId,
    ].find((id) => id != null);
    if (communicationCenterTransportOfferOptionId == null) {
      throw new Error(
        `CommunicationCenterTransportOfferOptionEntityResolver: Unable to resolve entity of type 'CommunicationCenterTransportOfferOption'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(communicationCenterTransportOfferOptionId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((communicationCenterTransportOfferOption) => {
          if (communicationCenterTransportOfferOption == null) {
            throw new Error(
              `CommunicationCenterTransportOfferOptionEntityResolver: unable to resolve entity of type 'CommunicationCenterTransportOfferOption' for id '${communicationCenterTransportOfferOptionId}'`,
            );
          }
          return communicationCenterTransportOfferOption;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class CompanyEntityFetchService extends ClientSyncFetchService<CompanyRecord> {
  constructor(
    byIdQuery: FetchCompanyByIdGQL,
    byIdsQuery: FetchCompanyByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectCompanyById,
      selectCompanyEntitiesByIds,
      CompanyRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class CompanyEntityResolver {
  constructor(private readonly _fetchService: CompanyEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<CompanyRecord> {
    const companyId: string | undefined = [
      route.params.companyId,
      route.params.id,
      route.queryParams.companyId,
    ].find((id) => id != null);
    if (companyId == null) {
      throw new Error(
        `CompanyEntityResolver: Unable to resolve entity of type 'Company'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(companyId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((company) => {
        if (company == null) {
          throw new Error(
            `CompanyEntityResolver: unable to resolve entity of type 'Company' for id '${companyId}'`,
          );
        }
        return company;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class CompleteFlightInstanceEntityFetchService extends ClientSyncFetchService<CompleteFlightInstanceRecord> {
  constructor(
    byIdQuery: FetchCompleteFlightInstanceByIdGQL,
    byIdsQuery: FetchCompleteFlightInstanceByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectCompleteFlightInstanceById,
      selectCompleteFlightInstanceEntitiesByIds,
      CompleteFlightInstanceRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class CompleteFlightInstanceEntityResolver {
  constructor(private readonly _fetchService: CompleteFlightInstanceEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<CompleteFlightInstanceRecord> {
    const completeFlightInstanceId: string | undefined = [
      route.params.completeFlightInstanceId,
      route.params.id,
      route.queryParams.completeFlightInstanceId,
    ].find((id) => id != null);
    if (completeFlightInstanceId == null) {
      throw new Error(
        `CompleteFlightInstanceEntityResolver: Unable to resolve entity of type 'CompleteFlightInstance'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(completeFlightInstanceId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((completeFlightInstance) => {
          if (completeFlightInstance == null) {
            throw new Error(
              `CompleteFlightInstanceEntityResolver: unable to resolve entity of type 'CompleteFlightInstance' for id '${completeFlightInstanceId}'`,
            );
          }
          return completeFlightInstance;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class ControlZoneEntityFetchService extends ClientSyncFetchService<ControlZoneRecord> {
  constructor(
    byIdQuery: FetchControlZoneByIdGQL,
    byIdsQuery: FetchControlZoneByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectControlZoneById,
      selectControlZoneEntitiesByIds,
      ControlZoneRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ControlZoneEntityResolver {
  constructor(private readonly _fetchService: ControlZoneEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<ControlZoneRecord> {
    const controlZoneId: string | undefined = [
      route.params.controlZoneId,
      route.params.id,
      route.queryParams.controlZoneId,
    ].find((id) => id != null);
    if (controlZoneId == null) {
      throw new Error(
        `ControlZoneEntityResolver: Unable to resolve entity of type 'ControlZone'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(controlZoneId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((controlZone) => {
        if (controlZone == null) {
          throw new Error(
            `ControlZoneEntityResolver: unable to resolve entity of type 'ControlZone' for id '${controlZoneId}'`,
          );
        }
        return controlZone;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class DepartmentEntityFetchService extends ClientSyncFetchService<DepartmentRecord> {
  constructor(
    byIdQuery: FetchDepartmentByIdGQL,
    byIdsQuery: FetchDepartmentByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectDepartmentById,
      selectDepartmentEntitiesByIds,
      DepartmentRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class DepartmentEntityResolver {
  constructor(private readonly _fetchService: DepartmentEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<DepartmentRecord> {
    const departmentId: string | undefined = [
      route.params.departmentId,
      route.params.id,
      route.queryParams.departmentId,
    ].find((id) => id != null);
    if (departmentId == null) {
      throw new Error(
        `DepartmentEntityResolver: Unable to resolve entity of type 'Department'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(departmentId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((department) => {
        if (department == null) {
          throw new Error(
            `DepartmentEntityResolver: unable to resolve entity of type 'Department' for id '${departmentId}'`,
          );
        }
        return department;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class EntityCapabilityEntityFetchService extends ClientSyncFetchService<EntityCapabilityRecord> {
  constructor(
    byIdQuery: FetchEntityCapabilityByIdGQL,
    byIdsQuery: FetchEntityCapabilityByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectEntityCapabilityById,
      selectEntityCapabilityEntitiesByIds,
      EntityCapabilityRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class EntityCapabilityEntityResolver {
  constructor(private readonly _fetchService: EntityCapabilityEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<EntityCapabilityRecord> {
    const entityCapabilityId: string | undefined = [
      route.params.entityCapabilityId,
      route.params.id,
      route.queryParams.entityCapabilityId,
    ].find((id) => id != null);
    if (entityCapabilityId == null) {
      throw new Error(
        `EntityCapabilityEntityResolver: Unable to resolve entity of type 'EntityCapability'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(entityCapabilityId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((entityCapability) => {
          if (entityCapability == null) {
            throw new Error(
              `EntityCapabilityEntityResolver: unable to resolve entity of type 'EntityCapability' for id '${entityCapabilityId}'`,
            );
          }
          return entityCapability;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class ExternalReferenceEntityFetchService extends ClientSyncFetchService<ExternalReferenceRecord> {
  constructor(
    byIdQuery: FetchExternalReferenceByIdGQL,
    byIdsQuery: FetchExternalReferenceByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectExternalReferenceById,
      selectExternalReferenceEntitiesByIds,
      ExternalReferenceRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ExternalReferenceEntityResolver {
  constructor(private readonly _fetchService: ExternalReferenceEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<ExternalReferenceRecord> {
    const externalReferenceId: string | undefined = [
      route.params.externalReferenceId,
      route.params.id,
      route.queryParams.externalReferenceId,
    ].find((id) => id != null);
    if (externalReferenceId == null) {
      throw new Error(
        `ExternalReferenceEntityResolver: Unable to resolve entity of type 'ExternalReference'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(externalReferenceId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((externalReference) => {
          if (externalReference == null) {
            throw new Error(
              `ExternalReferenceEntityResolver: unable to resolve entity of type 'ExternalReference' for id '${externalReferenceId}'`,
            );
          }
          return externalReference;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class FboEntityFetchService extends ClientSyncFetchService<FboRecord> {
  constructor(
    byIdQuery: FetchFboByIdGQL,
    byIdsQuery: FetchFboByIdsGQL,

    _store: StoreService,
  ) {
    super(byIdQuery, byIdsQuery, _store, selectFboById, selectFboEntitiesByIds, FboRecord.fromJS);
  }
}

@Injectable({ providedIn: 'root' })
export class FboEntityResolver {
  constructor(private readonly _fetchService: FboEntityFetchService) {}

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<FboRecord> {
    const fboId: string | undefined = [
      route.params.fboId,
      route.params.id,
      route.queryParams.fboId,
    ].find((id) => id != null);
    if (fboId == null) {
      throw new Error(
        `FboEntityResolver: Unable to resolve entity of type 'Fbo'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(fboId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((fbo) => {
        if (fbo == null) {
          throw new Error(
            `FboEntityResolver: unable to resolve entity of type 'Fbo' for id '${fboId}'`,
          );
        }
        return fbo;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class FuelTankEntityFetchService extends ClientSyncFetchService<FuelTankRecord> {
  constructor(
    byIdQuery: FetchFuelTankByIdGQL,
    byIdsQuery: FetchFuelTankByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectFuelTankById,
      selectFuelTankEntitiesByIds,
      FuelTankRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class FuelTankEntityResolver {
  constructor(private readonly _fetchService: FuelTankEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<FuelTankRecord> {
    const fuelTankId: string | undefined = [
      route.params.fuelTankId,
      route.params.id,
      route.queryParams.fuelTankId,
    ].find((id) => id != null);
    if (fuelTankId == null) {
      throw new Error(
        `FuelTankEntityResolver: Unable to resolve entity of type 'FuelTank'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(fuelTankId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((fuelTank) => {
        if (fuelTank == null) {
          throw new Error(
            `FuelTankEntityResolver: unable to resolve entity of type 'FuelTank' for id '${fuelTankId}'`,
          );
        }
        return fuelTank;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class LocationEntityFetchService extends ClientSyncFetchService<LocationRecord> {
  constructor(
    byIdQuery: FetchLocationByIdGQL,
    byIdsQuery: FetchLocationByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectLocationById,
      selectLocationEntitiesByIds,
      LocationRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class LocationEntityResolver {
  constructor(private readonly _fetchService: LocationEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<LocationRecord> {
    const locationId: string | undefined = [
      route.params.locationId,
      route.params.id,
      route.queryParams.locationId,
    ].find((id) => id != null);
    if (locationId == null) {
      throw new Error(
        `LocationEntityResolver: Unable to resolve entity of type 'Location'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(locationId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((location) => {
        if (location == null) {
          throw new Error(
            `LocationEntityResolver: unable to resolve entity of type 'Location' for id '${locationId}'`,
          );
        }
        return location;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class MaintenanceFacilityEntityFetchService extends ClientSyncFetchService<MaintenanceFacilityRecord> {
  constructor(
    byIdQuery: FetchMaintenanceFacilityByIdGQL,
    byIdsQuery: FetchMaintenanceFacilityByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectMaintenanceFacilityById,
      selectMaintenanceFacilityEntitiesByIds,
      MaintenanceFacilityRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class MaintenanceFacilityEntityResolver {
  constructor(private readonly _fetchService: MaintenanceFacilityEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<MaintenanceFacilityRecord> {
    const maintenanceFacilityId: string | undefined = [
      route.params.maintenanceFacilityId,
      route.params.id,
      route.queryParams.maintenanceFacilityId,
    ].find((id) => id != null);
    if (maintenanceFacilityId == null) {
      throw new Error(
        `MaintenanceFacilityEntityResolver: Unable to resolve entity of type 'MaintenanceFacility'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(maintenanceFacilityId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((maintenanceFacility) => {
          if (maintenanceFacility == null) {
            throw new Error(
              `MaintenanceFacilityEntityResolver: unable to resolve entity of type 'MaintenanceFacility' for id '${maintenanceFacilityId}'`,
            );
          }
          return maintenanceFacility;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class MedicalFacilityContactEntityFetchService extends ClientSyncFetchService<MedicalFacilityContactRecord> {
  constructor(
    byIdQuery: FetchMedicalFacilityContactByIdGQL,
    byIdsQuery: FetchMedicalFacilityContactByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectMedicalFacilityContactById,
      selectMedicalFacilityContactEntitiesByIds,
      MedicalFacilityContactRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class MedicalFacilityContactEntityResolver {
  constructor(private readonly _fetchService: MedicalFacilityContactEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<MedicalFacilityContactRecord> {
    const medicalFacilityContactId: string | undefined = [
      route.params.medicalFacilityContactId,
      route.params.id,
      route.queryParams.medicalFacilityContactId,
    ].find((id) => id != null);
    if (medicalFacilityContactId == null) {
      throw new Error(
        `MedicalFacilityContactEntityResolver: Unable to resolve entity of type 'MedicalFacilityContact'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(medicalFacilityContactId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((medicalFacilityContact) => {
          if (medicalFacilityContact == null) {
            throw new Error(
              `MedicalFacilityContactEntityResolver: unable to resolve entity of type 'MedicalFacilityContact' for id '${medicalFacilityContactId}'`,
            );
          }
          return medicalFacilityContact;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class MedicalFacilityEntityFetchService extends ClientSyncFetchService<MedicalFacilityRecord> {
  constructor(
    byIdQuery: FetchMedicalFacilityByIdGQL,
    byIdsQuery: FetchMedicalFacilityByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectMedicalFacilityById,
      selectMedicalFacilityEntitiesByIds,
      MedicalFacilityRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class MedicalFacilityEntityResolver {
  constructor(private readonly _fetchService: MedicalFacilityEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<MedicalFacilityRecord> {
    const medicalFacilityId: string | undefined = [
      route.params.medicalFacilityId,
      route.params.id,
      route.queryParams.medicalFacilityId,
    ].find((id) => id != null);
    if (medicalFacilityId == null) {
      throw new Error(
        `MedicalFacilityEntityResolver: Unable to resolve entity of type 'MedicalFacility'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(medicalFacilityId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((medicalFacility) => {
          if (medicalFacility == null) {
            throw new Error(
              `MedicalFacilityEntityResolver: unable to resolve entity of type 'MedicalFacility' for id '${medicalFacilityId}'`,
            );
          }
          return medicalFacility;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class MedicalFacilityPhysicianEntityFetchService extends ClientSyncFetchService<MedicalFacilityPhysicianRecord> {
  constructor(
    byIdQuery: FetchMedicalFacilityPhysicianByIdGQL,
    byIdsQuery: FetchMedicalFacilityPhysicianByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectMedicalFacilityPhysicianById,
      selectMedicalFacilityPhysicianEntitiesByIds,
      MedicalFacilityPhysicianRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class MedicalFacilityPhysicianEntityResolver {
  constructor(private readonly _fetchService: MedicalFacilityPhysicianEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<MedicalFacilityPhysicianRecord> {
    const medicalFacilityPhysicianId: string | undefined = [
      route.params.medicalFacilityPhysicianId,
      route.params.id,
      route.queryParams.medicalFacilityPhysicianId,
    ].find((id) => id != null);
    if (medicalFacilityPhysicianId == null) {
      throw new Error(
        `MedicalFacilityPhysicianEntityResolver: Unable to resolve entity of type 'MedicalFacilityPhysician'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(medicalFacilityPhysicianId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((medicalFacilityPhysician) => {
          if (medicalFacilityPhysician == null) {
            throw new Error(
              `MedicalFacilityPhysicianEntityResolver: unable to resolve entity of type 'MedicalFacilityPhysician' for id '${medicalFacilityPhysicianId}'`,
            );
          }
          return medicalFacilityPhysician;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class MedicalFacilityUnitEntityFetchService extends ClientSyncFetchService<MedicalFacilityUnitRecord> {
  constructor(
    byIdQuery: FetchMedicalFacilityUnitByIdGQL,
    byIdsQuery: FetchMedicalFacilityUnitByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectMedicalFacilityUnitById,
      selectMedicalFacilityUnitEntitiesByIds,
      MedicalFacilityUnitRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class MedicalFacilityUnitEntityResolver {
  constructor(private readonly _fetchService: MedicalFacilityUnitEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<MedicalFacilityUnitRecord> {
    const medicalFacilityUnitId: string | undefined = [
      route.params.medicalFacilityUnitId,
      route.params.id,
      route.queryParams.medicalFacilityUnitId,
    ].find((id) => id != null);
    if (medicalFacilityUnitId == null) {
      throw new Error(
        `MedicalFacilityUnitEntityResolver: Unable to resolve entity of type 'MedicalFacilityUnit'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(medicalFacilityUnitId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((medicalFacilityUnit) => {
          if (medicalFacilityUnit == null) {
            throw new Error(
              `MedicalFacilityUnitEntityResolver: unable to resolve entity of type 'MedicalFacilityUnit' for id '${medicalFacilityUnitId}'`,
            );
          }
          return medicalFacilityUnit;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class MedicalUnitEntityFetchService extends ClientSyncFetchService<MedicalUnitRecord> {
  constructor(
    byIdQuery: FetchMedicalUnitByIdGQL,
    byIdsQuery: FetchMedicalUnitByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectMedicalUnitById,
      selectMedicalUnitEntitiesByIds,
      MedicalUnitRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class MedicalUnitEntityResolver {
  constructor(private readonly _fetchService: MedicalUnitEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<MedicalUnitRecord> {
    const medicalUnitId: string | undefined = [
      route.params.medicalUnitId,
      route.params.id,
      route.queryParams.medicalUnitId,
    ].find((id) => id != null);
    if (medicalUnitId == null) {
      throw new Error(
        `MedicalUnitEntityResolver: Unable to resolve entity of type 'MedicalUnit'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(medicalUnitId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((medicalUnit) => {
        if (medicalUnit == null) {
          throw new Error(
            `MedicalUnitEntityResolver: unable to resolve entity of type 'MedicalUnit' for id '${medicalUnitId}'`,
          );
        }
        return medicalUnit;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class OutOfServiceQARReasonEntityFetchService extends ClientSyncFetchService<OutOfServiceQARReasonRecord> {
  constructor(
    byIdQuery: FetchOutOfServiceQARReasonByIdGQL,
    byIdsQuery: FetchOutOfServiceQARReasonByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectOutOfServiceQARReasonById,
      selectOutOfServiceQARReasonEntitiesByIds,
      OutOfServiceQARReasonRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class OutOfServiceQARReasonEntityResolver {
  constructor(private readonly _fetchService: OutOfServiceQARReasonEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<OutOfServiceQARReasonRecord> {
    const outOfServiceQARReasonId: string | undefined = [
      route.params.outOfServiceQARReasonId,
      route.params.id,
      route.queryParams.outOfServiceQARReasonId,
    ].find((id) => id != null);
    if (outOfServiceQARReasonId == null) {
      throw new Error(
        `OutOfServiceQARReasonEntityResolver: Unable to resolve entity of type 'OutOfServiceQARReason'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(outOfServiceQARReasonId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((outOfServiceQARReason) => {
          if (outOfServiceQARReason == null) {
            throw new Error(
              `OutOfServiceQARReasonEntityResolver: unable to resolve entity of type 'OutOfServiceQARReason' for id '${outOfServiceQARReasonId}'`,
            );
          }
          return outOfServiceQARReason;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class PersonEntityFetchService extends ClientSyncFetchService<PersonRecord> {
  constructor(
    byIdQuery: FetchPersonByIdGQL,
    byIdsQuery: FetchPersonByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectPersonById,
      selectPersonEntitiesByIds,
      PersonRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class PersonEntityResolver {
  constructor(private readonly _fetchService: PersonEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<PersonRecord> {
    const personId: string | undefined = [
      route.params.personId,
      route.params.id,
      route.queryParams.personId,
    ].find((id) => id != null);
    if (personId == null) {
      throw new Error(
        `PersonEntityResolver: Unable to resolve entity of type 'Person'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(personId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((person) => {
        if (person == null) {
          throw new Error(
            `PersonEntityResolver: unable to resolve entity of type 'Person' for id '${personId}'`,
          );
        }
        return person;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class PhysicianEntityFetchService extends ClientSyncFetchService<PhysicianRecord> {
  constructor(
    byIdQuery: FetchPhysicianByIdGQL,
    byIdsQuery: FetchPhysicianByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectPhysicianById,
      selectPhysicianEntitiesByIds,
      PhysicianRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class PhysicianEntityResolver {
  constructor(private readonly _fetchService: PhysicianEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<PhysicianRecord> {
    const physicianId: string | undefined = [
      route.params.physicianId,
      route.params.id,
      route.queryParams.physicianId,
    ].find((id) => id != null);
    if (physicianId == null) {
      throw new Error(
        `PhysicianEntityResolver: Unable to resolve entity of type 'Physician'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(physicianId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((physician) => {
        if (physician == null) {
          throw new Error(
            `PhysicianEntityResolver: unable to resolve entity of type 'Physician' for id '${physicianId}'`,
          );
        }
        return physician;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ProgramBaseEntityFetchService extends ClientSyncFetchService<ProgramBaseRecord> {
  constructor(
    byIdQuery: FetchProgramBaseByIdGQL,
    byIdsQuery: FetchProgramBaseByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectProgramBaseById,
      selectProgramBaseEntitiesByIds,
      ProgramBaseRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ProgramBaseEntityResolver {
  constructor(private readonly _fetchService: ProgramBaseEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<ProgramBaseRecord> {
    const programBaseId: string | undefined = [
      route.params.programBaseId,
      route.params.id,
      route.queryParams.programBaseId,
    ].find((id) => id != null);
    if (programBaseId == null) {
      throw new Error(
        `ProgramBaseEntityResolver: Unable to resolve entity of type 'ProgramBase'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(programBaseId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((programBase) => {
        if (programBase == null) {
          throw new Error(
            `ProgramBaseEntityResolver: unable to resolve entity of type 'ProgramBase' for id '${programBaseId}'`,
          );
        }
        return programBase;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ProgramEntityFetchService extends ClientSyncFetchService<ProgramRecord> {
  constructor(
    byIdQuery: FetchProgramByIdGQL,
    byIdsQuery: FetchProgramByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectProgramById,
      selectProgramEntitiesByIds,
      ProgramRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ProgramEntityResolver {
  constructor(private readonly _fetchService: ProgramEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<ProgramRecord> {
    const programId: string | undefined = [
      route.params.programId,
      route.params.id,
      route.queryParams.programId,
    ].find((id) => id != null);
    if (programId == null) {
      throw new Error(
        `ProgramEntityResolver: Unable to resolve entity of type 'Program'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(programId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((program) => {
        if (program == null) {
          throw new Error(
            `ProgramEntityResolver: unable to resolve entity of type 'Program' for id '${programId}'`,
          );
        }
        return program;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class RamcoVehicleConfigurationEntityFetchService extends ClientSyncFetchService<RamcoVehicleConfigurationRecord> {
  constructor(
    byIdQuery: FetchRamcoVehicleConfigurationByIdGQL,
    byIdsQuery: FetchRamcoVehicleConfigurationByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectRamcoVehicleConfigurationById,
      selectRamcoVehicleConfigurationEntitiesByIds,
      RamcoVehicleConfigurationRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class RamcoVehicleConfigurationEntityResolver {
  constructor(private readonly _fetchService: RamcoVehicleConfigurationEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<RamcoVehicleConfigurationRecord> {
    const ramcoVehicleConfigurationId: string | undefined = [
      route.params.ramcoVehicleConfigurationId,
      route.params.id,
      route.queryParams.ramcoVehicleConfigurationId,
    ].find((id) => id != null);
    if (ramcoVehicleConfigurationId == null) {
      throw new Error(
        `RamcoVehicleConfigurationEntityResolver: Unable to resolve entity of type 'RamcoVehicleConfiguration'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(ramcoVehicleConfigurationId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((ramcoVehicleConfiguration) => {
          if (ramcoVehicleConfiguration == null) {
            throw new Error(
              `RamcoVehicleConfigurationEntityResolver: unable to resolve entity of type 'RamcoVehicleConfiguration' for id '${ramcoVehicleConfigurationId}'`,
            );
          }
          return ramcoVehicleConfiguration;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class RegionBaseEntityFetchService extends ClientSyncFetchService<RegionBaseRecord> {
  constructor(
    byIdQuery: FetchRegionBaseByIdGQL,
    byIdsQuery: FetchRegionBaseByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectRegionBaseById,
      selectRegionBaseEntitiesByIds,
      RegionBaseRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class RegionBaseEntityResolver {
  constructor(private readonly _fetchService: RegionBaseEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<RegionBaseRecord> {
    const regionBaseId: string | undefined = [
      route.params.regionBaseId,
      route.params.id,
      route.queryParams.regionBaseId,
    ].find((id) => id != null);
    if (regionBaseId == null) {
      throw new Error(
        `RegionBaseEntityResolver: Unable to resolve entity of type 'RegionBase'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(regionBaseId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((regionBase) => {
        if (regionBase == null) {
          throw new Error(
            `RegionBaseEntityResolver: unable to resolve entity of type 'RegionBase' for id '${regionBaseId}'`,
          );
        }
        return regionBase;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class RegionEntityFetchService extends ClientSyncFetchService<RegionRecord> {
  constructor(
    byIdQuery: FetchRegionByIdGQL,
    byIdsQuery: FetchRegionByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectRegionById,
      selectRegionEntitiesByIds,
      RegionRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class RegionEntityResolver {
  constructor(private readonly _fetchService: RegionEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<RegionRecord> {
    const regionId: string | undefined = [
      route.params.regionId,
      route.params.id,
      route.queryParams.regionId,
    ].find((id) => id != null);
    if (regionId == null) {
      throw new Error(
        `RegionEntityResolver: Unable to resolve entity of type 'Region'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(regionId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((region) => {
        if (region == null) {
          throw new Error(
            `RegionEntityResolver: unable to resolve entity of type 'Region' for id '${regionId}'`,
          );
        }
        return region;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class RegionGroupEntityFetchService extends ClientSyncFetchService<RegionGroupRecord> {
  constructor(
    byIdQuery: FetchRegionGroupByIdGQL,
    byIdsQuery: FetchRegionGroupByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectRegionGroupById,
      selectRegionGroupEntitiesByIds,
      RegionGroupRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class RegionGroupEntityResolver {
  constructor(private readonly _fetchService: RegionGroupEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<RegionGroupRecord> {
    const regionGroupId: string | undefined = [
      route.params.regionGroupId,
      route.params.id,
      route.queryParams.regionGroupId,
    ].find((id) => id != null);
    if (regionGroupId == null) {
      throw new Error(
        `RegionGroupEntityResolver: Unable to resolve entity of type 'RegionGroup'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(regionGroupId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((regionGroup) => {
        if (regionGroup == null) {
          throw new Error(
            `RegionGroupEntityResolver: unable to resolve entity of type 'RegionGroup' for id '${regionGroupId}'`,
          );
        }
        return regionGroup;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ReleaseNoteEntityFetchService extends ClientSyncFetchService<ReleaseNoteRecord> {
  constructor(
    byIdQuery: FetchReleaseNoteByIdGQL,
    byIdsQuery: FetchReleaseNoteByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectReleaseNoteById,
      selectReleaseNoteEntitiesByIds,
      ReleaseNoteRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ReleaseNoteEntityResolver {
  constructor(private readonly _fetchService: ReleaseNoteEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<ReleaseNoteRecord> {
    const releaseNoteId: string | undefined = [
      route.params.releaseNoteId,
      route.params.id,
      route.queryParams.releaseNoteId,
    ].find((id) => id != null);
    if (releaseNoteId == null) {
      throw new Error(
        `ReleaseNoteEntityResolver: Unable to resolve entity of type 'ReleaseNote'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(releaseNoteId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((releaseNote) => {
        if (releaseNote == null) {
          throw new Error(
            `ReleaseNoteEntityResolver: unable to resolve entity of type 'ReleaseNote' for id '${releaseNoteId}'`,
          );
        }
        return releaseNote;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class SpecialtyTeamEntityFetchService extends ClientSyncFetchService<SpecialtyTeamRecord> {
  constructor(
    byIdQuery: FetchSpecialtyTeamByIdGQL,
    byIdsQuery: FetchSpecialtyTeamByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectSpecialtyTeamById,
      selectSpecialtyTeamEntitiesByIds,
      SpecialtyTeamRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class SpecialtyTeamEntityResolver {
  constructor(private readonly _fetchService: SpecialtyTeamEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<SpecialtyTeamRecord> {
    const specialtyTeamId: string | undefined = [
      route.params.specialtyTeamId,
      route.params.id,
      route.queryParams.specialtyTeamId,
    ].find((id) => id != null);
    if (specialtyTeamId == null) {
      throw new Error(
        `SpecialtyTeamEntityResolver: Unable to resolve entity of type 'SpecialtyTeam'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(specialtyTeamId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((specialtyTeam) => {
        if (specialtyTeam == null) {
          throw new Error(
            `SpecialtyTeamEntityResolver: unable to resolve entity of type 'SpecialtyTeam' for id '${specialtyTeamId}'`,
          );
        }
        return specialtyTeam;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class SpecialtyTeamMemberEntityFetchService extends ClientSyncFetchService<SpecialtyTeamMemberRecord> {
  constructor(
    byIdQuery: FetchSpecialtyTeamMemberByIdGQL,
    byIdsQuery: FetchSpecialtyTeamMemberByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectSpecialtyTeamMemberById,
      selectSpecialtyTeamMemberEntitiesByIds,
      SpecialtyTeamMemberRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class SpecialtyTeamMemberEntityResolver {
  constructor(private readonly _fetchService: SpecialtyTeamMemberEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<SpecialtyTeamMemberRecord> {
    const specialtyTeamMemberId: string | undefined = [
      route.params.specialtyTeamMemberId,
      route.params.id,
      route.queryParams.specialtyTeamMemberId,
    ].find((id) => id != null);
    if (specialtyTeamMemberId == null) {
      throw new Error(
        `SpecialtyTeamMemberEntityResolver: Unable to resolve entity of type 'SpecialtyTeamMember'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(specialtyTeamMemberId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((specialtyTeamMember) => {
          if (specialtyTeamMember == null) {
            throw new Error(
              `SpecialtyTeamMemberEntityResolver: unable to resolve entity of type 'SpecialtyTeamMember' for id '${specialtyTeamMemberId}'`,
            );
          }
          return specialtyTeamMember;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class StateEntityFetchService extends ClientSyncFetchService<StateRecord> {
  constructor(
    byIdQuery: FetchStateByIdGQL,
    byIdsQuery: FetchStateByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectStateById,
      selectStateEntitiesByIds,
      StateRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class StateEntityResolver {
  constructor(private readonly _fetchService: StateEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<StateRecord> {
    const stateId: string | undefined = [
      route.params.stateId,
      route.params.id,
      route.queryParams.stateId,
    ].find((id) => id != null);
    if (stateId == null) {
      throw new Error(
        `StateEntityResolver: Unable to resolve entity of type 'State'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(stateId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((state) => {
        if (state == null) {
          throw new Error(
            `StateEntityResolver: unable to resolve entity of type 'State' for id '${stateId}'`,
          );
        }
        return state;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class SupportRequestEntityFetchService extends ClientSyncFetchService<SupportRequestRecord> {
  constructor(
    byIdQuery: FetchSupportRequestByIdGQL,
    byIdsQuery: FetchSupportRequestByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectSupportRequestById,
      selectSupportRequestEntitiesByIds,
      SupportRequestRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class SupportRequestEntityResolver {
  constructor(private readonly _fetchService: SupportRequestEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<SupportRequestRecord> {
    const supportRequestId: string | undefined = [
      route.params.supportRequestId,
      route.params.id,
      route.queryParams.supportRequestId,
    ].find((id) => id != null);
    if (supportRequestId == null) {
      throw new Error(
        `SupportRequestEntityResolver: Unable to resolve entity of type 'SupportRequest'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(supportRequestId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((supportRequest) => {
        if (supportRequest == null) {
          throw new Error(
            `SupportRequestEntityResolver: unable to resolve entity of type 'SupportRequest' for id '${supportRequestId}'`,
          );
        }
        return supportRequest;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TimezoneEntityFetchService extends ClientSyncFetchService<TimezoneRecord> {
  constructor(
    byIdQuery: FetchTimezoneByIdGQL,
    byIdsQuery: FetchTimezoneByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectTimezoneById,
      selectTimezoneEntitiesByIds,
      TimezoneRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TimezoneEntityResolver {
  constructor(private readonly _fetchService: TimezoneEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<TimezoneRecord> {
    const timezoneId: string | undefined = [
      route.params.timezoneId,
      route.params.id,
      route.queryParams.timezoneId,
    ].find((id) => id != null);
    if (timezoneId == null) {
      throw new Error(
        `TimezoneEntityResolver: Unable to resolve entity of type 'Timezone'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(timezoneId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((timezone) => {
        if (timezone == null) {
          throw new Error(
            `TimezoneEntityResolver: unable to resolve entity of type 'Timezone' for id '${timezoneId}'`,
          );
        }
        return timezone;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TransferCenterEntityFetchService extends ClientSyncFetchService<TransferCenterRecord> {
  constructor(
    byIdQuery: FetchTransferCenterByIdGQL,
    byIdsQuery: FetchTransferCenterByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectTransferCenterById,
      selectTransferCenterEntitiesByIds,
      TransferCenterRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TransferCenterEntityResolver {
  constructor(private readonly _fetchService: TransferCenterEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<TransferCenterRecord> {
    const transferCenterId: string | undefined = [
      route.params.transferCenterId,
      route.params.id,
      route.queryParams.transferCenterId,
    ].find((id) => id != null);
    if (transferCenterId == null) {
      throw new Error(
        `TransferCenterEntityResolver: Unable to resolve entity of type 'TransferCenter'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(transferCenterId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((transferCenter) => {
        if (transferCenter == null) {
          throw new Error(
            `TransferCenterEntityResolver: unable to resolve entity of type 'TransferCenter' for id '${transferCenterId}'`,
          );
        }
        return transferCenter;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TrmUserAgencyEntityFetchService extends ClientSyncFetchService<TrmUserAgencyRecord> {
  constructor(
    byIdQuery: FetchTrmUserAgencyByIdGQL,
    byIdsQuery: FetchTrmUserAgencyByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectTrmUserAgencyById,
      selectTrmUserAgencyEntitiesByIds,
      TrmUserAgencyRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TrmUserAgencyEntityResolver {
  constructor(private readonly _fetchService: TrmUserAgencyEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<TrmUserAgencyRecord> {
    const trmUserAgencyId: string | undefined = [
      route.params.trmUserAgencyId,
      route.params.id,
      route.queryParams.trmUserAgencyId,
    ].find((id) => id != null);
    if (trmUserAgencyId == null) {
      throw new Error(
        `TrmUserAgencyEntityResolver: Unable to resolve entity of type 'TrmUserAgency'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(trmUserAgencyId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((trmUserAgency) => {
        if (trmUserAgency == null) {
          throw new Error(
            `TrmUserAgencyEntityResolver: unable to resolve entity of type 'TrmUserAgency' for id '${trmUserAgencyId}'`,
          );
        }
        return trmUserAgency;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TrmUserEntityFetchService extends ClientSyncFetchService<TrmUserRecord> {
  constructor(
    byIdQuery: FetchTrmUserByIdGQL,
    byIdsQuery: FetchTrmUserByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectTrmUserById,
      selectTrmUserEntitiesByIds,
      TrmUserRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TrmUserEntityResolver {
  constructor(private readonly _fetchService: TrmUserEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<TrmUserRecord> {
    const trmUserId: string | undefined = [
      route.params.trmUserId,
      route.params.id,
      route.queryParams.trmUserId,
    ].find((id) => id != null);
    if (trmUserId == null) {
      throw new Error(
        `TrmUserEntityResolver: Unable to resolve entity of type 'TrmUser'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(trmUserId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((trmUser) => {
        if (trmUser == null) {
          throw new Error(
            `TrmUserEntityResolver: unable to resolve entity of type 'TrmUser' for id '${trmUserId}'`,
          );
        }
        return trmUser;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TrmUserMedicalFacilityEntityFetchService extends ClientSyncFetchService<TrmUserMedicalFacilityRecord> {
  constructor(
    byIdQuery: FetchTrmUserMedicalFacilityByIdGQL,
    byIdsQuery: FetchTrmUserMedicalFacilityByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectTrmUserMedicalFacilityById,
      selectTrmUserMedicalFacilityEntitiesByIds,
      TrmUserMedicalFacilityRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TrmUserMedicalFacilityEntityResolver {
  constructor(private readonly _fetchService: TrmUserMedicalFacilityEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<TrmUserMedicalFacilityRecord> {
    const trmUserMedicalFacilityId: string | undefined = [
      route.params.trmUserMedicalFacilityId,
      route.params.id,
      route.queryParams.trmUserMedicalFacilityId,
    ].find((id) => id != null);
    if (trmUserMedicalFacilityId == null) {
      throw new Error(
        `TrmUserMedicalFacilityEntityResolver: Unable to resolve entity of type 'TrmUserMedicalFacility'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(trmUserMedicalFacilityId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((trmUserMedicalFacility) => {
          if (trmUserMedicalFacility == null) {
            throw new Error(
              `TrmUserMedicalFacilityEntityResolver: unable to resolve entity of type 'TrmUserMedicalFacility' for id '${trmUserMedicalFacilityId}'`,
            );
          }
          return trmUserMedicalFacility;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class TrmUserProgramEntityFetchService extends ClientSyncFetchService<TrmUserProgramRecord> {
  constructor(
    byIdQuery: FetchTrmUserProgramByIdGQL,
    byIdsQuery: FetchTrmUserProgramByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectTrmUserProgramById,
      selectTrmUserProgramEntitiesByIds,
      TrmUserProgramRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class TrmUserProgramEntityResolver {
  constructor(private readonly _fetchService: TrmUserProgramEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<TrmUserProgramRecord> {
    const trmUserProgramId: string | undefined = [
      route.params.trmUserProgramId,
      route.params.id,
      route.queryParams.trmUserProgramId,
    ].find((id) => id != null);
    if (trmUserProgramId == null) {
      throw new Error(
        `TrmUserProgramEntityResolver: Unable to resolve entity of type 'TrmUserProgram'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(trmUserProgramId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((trmUserProgram) => {
        if (trmUserProgram == null) {
          throw new Error(
            `TrmUserProgramEntityResolver: unable to resolve entity of type 'TrmUserProgram' for id '${trmUserProgramId}'`,
          );
        }
        return trmUserProgram;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class VehicleControlZoneEntityFetchService extends ClientSyncFetchService<VehicleControlZoneRecord> {
  constructor(
    byIdQuery: FetchVehicleControlZoneByIdGQL,
    byIdsQuery: FetchVehicleControlZoneByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectVehicleControlZoneById,
      selectVehicleControlZoneEntitiesByIds,
      VehicleControlZoneRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class VehicleControlZoneEntityResolver {
  constructor(private readonly _fetchService: VehicleControlZoneEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<VehicleControlZoneRecord> {
    const vehicleControlZoneId: string | undefined = [
      route.params.vehicleControlZoneId,
      route.params.id,
      route.queryParams.vehicleControlZoneId,
    ].find((id) => id != null);
    if (vehicleControlZoneId == null) {
      throw new Error(
        `VehicleControlZoneEntityResolver: Unable to resolve entity of type 'VehicleControlZone'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(vehicleControlZoneId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((vehicleControlZone) => {
          if (vehicleControlZone == null) {
            throw new Error(
              `VehicleControlZoneEntityResolver: unable to resolve entity of type 'VehicleControlZone' for id '${vehicleControlZoneId}'`,
            );
          }
          return vehicleControlZone;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class VehicleEntityFetchService extends ClientSyncFetchService<VehicleRecord> {
  constructor(
    byIdQuery: FetchVehicleByIdGQL,
    byIdsQuery: FetchVehicleByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectVehicleById,
      selectVehicleEntitiesByIds,
      VehicleRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class VehicleEntityResolver {
  constructor(private readonly _fetchService: VehicleEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<VehicleRecord> {
    const vehicleId: string | undefined = [
      route.params.vehicleId,
      route.params.id,
      route.queryParams.vehicleId,
    ].find((id) => id != null);
    if (vehicleId == null) {
      throw new Error(
        `VehicleEntityResolver: Unable to resolve entity of type 'Vehicle'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(vehicleId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((vehicle) => {
        if (vehicle == null) {
          throw new Error(
            `VehicleEntityResolver: unable to resolve entity of type 'Vehicle' for id '${vehicleId}'`,
          );
        }
        return vehicle;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class VehicleMaintenanceEntityFetchService extends ClientSyncFetchService<VehicleMaintenanceRecord> {
  constructor(
    byIdQuery: FetchVehicleMaintenanceByIdGQL,
    byIdsQuery: FetchVehicleMaintenanceByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectVehicleMaintenanceById,
      selectVehicleMaintenanceEntitiesByIds,
      VehicleMaintenanceRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class VehicleMaintenanceEntityResolver {
  constructor(private readonly _fetchService: VehicleMaintenanceEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<VehicleMaintenanceRecord> {
    const vehicleMaintenanceId: string | undefined = [
      route.params.vehicleMaintenanceId,
      route.params.id,
      route.queryParams.vehicleMaintenanceId,
    ].find((id) => id != null);
    if (vehicleMaintenanceId == null) {
      throw new Error(
        `VehicleMaintenanceEntityResolver: Unable to resolve entity of type 'VehicleMaintenance'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(vehicleMaintenanceId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((vehicleMaintenance) => {
          if (vehicleMaintenance == null) {
            throw new Error(
              `VehicleMaintenanceEntityResolver: unable to resolve entity of type 'VehicleMaintenance' for id '${vehicleMaintenanceId}'`,
            );
          }
          return vehicleMaintenance;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class VehicleMakeEntityFetchService extends ClientSyncFetchService<VehicleMakeRecord> {
  constructor(
    byIdQuery: FetchVehicleMakeByIdGQL,
    byIdsQuery: FetchVehicleMakeByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectVehicleMakeById,
      selectVehicleMakeEntitiesByIds,
      VehicleMakeRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class VehicleMakeEntityResolver {
  constructor(private readonly _fetchService: VehicleMakeEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<VehicleMakeRecord> {
    const vehicleMakeId: string | undefined = [
      route.params.vehicleMakeId,
      route.params.id,
      route.queryParams.vehicleMakeId,
    ].find((id) => id != null);
    if (vehicleMakeId == null) {
      throw new Error(
        `VehicleMakeEntityResolver: Unable to resolve entity of type 'VehicleMake'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(vehicleMakeId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((vehicleMake) => {
        if (vehicleMake == null) {
          throw new Error(
            `VehicleMakeEntityResolver: unable to resolve entity of type 'VehicleMake' for id '${vehicleMakeId}'`,
          );
        }
        return vehicleMake;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class VehicleModelEntityFetchService extends ClientSyncFetchService<VehicleModelRecord> {
  constructor(
    byIdQuery: FetchVehicleModelByIdGQL,
    byIdsQuery: FetchVehicleModelByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectVehicleModelById,
      selectVehicleModelEntitiesByIds,
      VehicleModelRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class VehicleModelEntityResolver {
  constructor(private readonly _fetchService: VehicleModelEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<VehicleModelRecord> {
    const vehicleModelId: string | undefined = [
      route.params.vehicleModelId,
      route.params.id,
      route.queryParams.vehicleModelId,
    ].find((id) => id != null);
    if (vehicleModelId == null) {
      throw new Error(
        `VehicleModelEntityResolver: Unable to resolve entity of type 'VehicleModel'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService.getById(vehicleModelId, { fetchPolicy: 'network-then-cache' }).pipe(
      map((vehicleModel) => {
        if (vehicleModel == null) {
          throw new Error(
            `VehicleModelEntityResolver: unable to resolve entity of type 'VehicleModel' for id '${vehicleModelId}'`,
          );
        }
        return vehicleModel;
      }),
      take(1),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class VehicleStateInspectionEntityFetchService extends ClientSyncFetchService<VehicleStateInspectionRecord> {
  constructor(
    byIdQuery: FetchVehicleStateInspectionByIdGQL,
    byIdsQuery: FetchVehicleStateInspectionByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectVehicleStateInspectionById,
      selectVehicleStateInspectionEntitiesByIds,
      VehicleStateInspectionRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class VehicleStateInspectionEntityResolver {
  constructor(private readonly _fetchService: VehicleStateInspectionEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<VehicleStateInspectionRecord> {
    const vehicleStateInspectionId: string | undefined = [
      route.params.vehicleStateInspectionId,
      route.params.id,
      route.queryParams.vehicleStateInspectionId,
    ].find((id) => id != null);
    if (vehicleStateInspectionId == null) {
      throw new Error(
        `VehicleStateInspectionEntityResolver: Unable to resolve entity of type 'VehicleStateInspection'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(vehicleStateInspectionId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((vehicleStateInspection) => {
          if (vehicleStateInspection == null) {
            throw new Error(
              `VehicleStateInspectionEntityResolver: unable to resolve entity of type 'VehicleStateInspection' for id '${vehicleStateInspectionId}'`,
            );
          }
          return vehicleStateInspection;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class ActiveCardUnitOfferingEntityFetchService extends ClientSyncFetchService<ActiveCardUnitOfferingRecord> {
  constructor(
    byIdQuery: FetchActiveCardUnitOfferingByIdGQL,
    byIdsQuery: FetchActiveCardUnitOfferingByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectActiveCardUnitOfferingById,
      selectActiveCardUnitOfferingEntitiesByIds,
      ActiveCardUnitOfferingRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ActiveCardUnitOfferingEntityResolver {
  constructor(private readonly _fetchService: ActiveCardUnitOfferingEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<ActiveCardUnitOfferingRecord> {
    const activeCardUnitOfferingId: string | undefined = [
      route.params.activeCardUnitOfferingId,
      route.params.id,
      route.queryParams.activeCardUnitOfferingId,
    ].find((id) => id != null);
    if (activeCardUnitOfferingId == null) {
      throw new Error(
        `ActiveCardUnitOfferingEntityResolver: Unable to resolve entity of type 'ActiveCardUnitOffering'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(activeCardUnitOfferingId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((activeCardUnitOffering) => {
          if (activeCardUnitOffering == null) {
            throw new Error(
              `ActiveCardUnitOfferingEntityResolver: unable to resolve entity of type 'ActiveCardUnitOffering' for id '${activeCardUnitOfferingId}'`,
            );
          }
          return activeCardUnitOffering;
        }),
        take(1),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class VehiclePositionSummaryEntityFetchService extends ClientSyncFetchService<VehiclePositionSummaryRecord> {
  constructor(
    byIdQuery: FetchVehiclePositionSummaryByIdGQL,
    byIdsQuery: FetchVehiclePositionSummaryByIdsGQL,

    _store: StoreService,
  ) {
    super(
      byIdQuery,
      byIdsQuery,
      _store,
      selectVehiclePositionSummaryById,
      selectVehiclePositionSummaryEntitiesByIds,
      VehiclePositionSummaryRecord.fromJS,
    );
  }
}

@Injectable({ providedIn: 'root' })
export class VehiclePositionSummaryEntityResolver {
  constructor(private readonly _fetchService: VehiclePositionSummaryEntityFetchService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<VehiclePositionSummaryRecord> {
    const vehiclePositionSummaryId: string | undefined = [
      route.params.vehiclePositionSummaryId,
      route.params.id,
      route.queryParams.vehiclePositionSummaryId,
    ].find((id) => id != null);
    if (vehiclePositionSummaryId == null) {
      throw new Error(
        `VehiclePositionSummaryEntityResolver: Unable to resolve entity of type 'VehiclePositionSummary'. No suitable ID was available in the route. ${state.url}`,
      );
    }
    return this._fetchService
      .getById(vehiclePositionSummaryId, { fetchPolicy: 'network-then-cache' })
      .pipe(
        map((vehiclePositionSummary) => {
          if (vehiclePositionSummary == null) {
            throw new Error(
              `VehiclePositionSummaryEntityResolver: unable to resolve entity of type 'VehiclePositionSummary' for id '${vehiclePositionSummaryId}'`,
            );
          }
          return vehiclePositionSummary;
        }),
        take(1),
      );
  }
}

export class EntityStores extends Record({
  activationRule: new EntityStore<ActivationRuleRecord>(),
  activeAlertAcknowledgement: new EntityStore<ActiveAlertAcknowledgementRecord>(),
  activeAlert: new EntityStore<ActiveAlertRecord>(),
  activeTimeline: new EntityStore<ActiveTimelineRecord>(),
  alert: new EntityStore<AlertRecord>(),
  applicationNotification: new EntityStore<ApplicationNotificationRecord>(),
  assignmentDelayedReason: new EntityStore<AssignmentDelayedReasonRecord>(),
  cancellationCategory: new EntityStore<CancellationCategoryRecord>(),
  cancellationReason: new EntityStore<CancellationReasonRecord>(),
  cancellationSecondaryReason: new EntityStore<CancellationSecondaryReasonRecord>(),
  card: new EntityStore<CardRecord>(),
  cardLink: new EntityStore<CardLinkRecord>(),
  cardNoteArchive: new EntityStore<CardNoteArchiveRecord>(),
  cardNote: new EntityStore<CardNoteRecord>(),
  cardReOpenReason: new EntityStore<CardReOpenReasonRecord>(),
  cardSummary: new EntityStore<CardSummaryRecord>(),
  configurationSetting: new EntityStore<ConfigurationSettingRecord>(),
  conversation: new EntityStore<ConversationRecord>(),
  conversationParticipant: new EntityStore<ConversationParticipantRecord>(),
  declineCategory: new EntityStore<DeclineCategoryRecord>(),
  declineReason: new EntityStore<DeclineReasonRecord>(),
  declineSecondaryReason: new EntityStore<DeclineSecondaryReasonRecord>(),
  diversionReason: new EntityStore<DiversionReasonRecord>(),
  escortRequest: new EntityStore<EscortRequestRecord>(),
  estimatedDuration: new EntityStore<EstimatedDurationRecord>(),
  eta: new EntityStore<EtaRecord>(),
  externalAction: new EntityStore<ExternalActionRecord>(),
  externalActionType: new EntityStore<ExternalActionTypeRecord>(),
  externalSystemUnit: new EntityStore<ExternalSystemUnitRecord>(),
  facilityNonAcceptanceReason: new EntityStore<FacilityNonAcceptanceReasonRecord>(),
  firewallRule: new EntityStore<FirewallRuleRecord>(),
  flightFollowingReport: new EntityStore<FlightFollowingReportRecord>(),
  landingZoneOutOfServiceReason: new EntityStore<LandingZoneOutOfServiceReasonRecord>(),
  locationHazardAttachment: new EntityStore<LocationHazardAttachmentRecord>(),
  locationHazard: new EntityStore<LocationHazardRecord>(),
  manifestEntry: new EntityStore<ManifestEntryRecord>(),
  medicalControlContactLogEntry: new EntityStore<MedicalControlContactLogEntryRecord>(),
  messageStatusUpdate: new EntityStore<MessageStatusUpdateRecord>(),
  newAgencyLocationRequest: new EntityStore<NewAgencyLocationRequestRecord>(),
  nextDueType: new EntityStore<NextDueTypeRecord>(),
  nonReferralReason: new EntityStore<NonReferralReasonRecord>(),
  notification: new EntityStore<NotificationRecord>(),
  notificationGroup: new EntityStore<NotificationGroupRecord>(),
  notificationGroupMember: new EntityStore<NotificationGroupMemberRecord>(),
  notificationRecipient: new EntityStore<NotificationRecipientRecord>(),
  notificationSubscription: new EntityStore<NotificationSubscriptionRecord>(),
  notificationTemplate: new EntityStore<NotificationTemplateRecord>(),
  oemActivity: new EntityStore<OemActivityRecord>(),
  oemAsset: new EntityStore<OemAssetRecord>(),
  oemPlanChangeRequest: new EntityStore<OemPlanChangeRequestRecord>(),
  oemPlan: new EntityStore<OemPlanRecord>(),
  offerAlgorithm: new EntityStore<OfferAlgorithmRecord>(),
  operation: new EntityStore<OperationRecord>(),
  outOfServiceEvent: new EntityStore<OutOfServiceEventRecord>(),
  outOfServiceEventNote: new EntityStore<OutOfServiceEventNoteRecord>(),
  outOfServiceReason: new EntityStore<OutOfServiceReasonRecord>(),
  outOfServiceSecondaryReason: new EntityStore<OutOfServiceSecondaryReasonRecord>(),
  outOfServiceTicket: new EntityStore<OutOfServiceTicketRecord>(),
  paipEvent: new EntityStore<PaipEventRecord>(),
  paipReason: new EntityStore<PaipReasonRecord>(),
  passdownLogAcknowledgement: new EntityStore<PassdownLogAcknowledgementRecord>(),
  passdownLogArchivedLog: new EntityStore<PassdownLogArchivedLogRecord>(),
  passdownLog: new EntityStore<PassdownLogRecord>(),
  patient: new EntityStore<PatientRecord>(),
  positionReportAlert: new EntityStore<PositionReportAlertRecord>(),
  positionReportArchive: new EntityStore<PositionReportArchiveRecord>(),
  positionReport: new EntityStore<PositionReportRecord>(),
  questionChoice: new EntityStore<QuestionChoiceRecord>(),
  question: new EntityStore<QuestionRecord>(),
  questionnaire: new EntityStore<QuestionnaireRecord>(),
  questionnaireQuestionResponse: new EntityStore<QuestionnaireQuestionResponseRecord>(),
  questionnaireQuestionResponseNote: new EntityStore<QuestionnaireQuestionResponseNoteRecord>(),
  questionnaireResponse: new EntityStore<QuestionnaireResponseRecord>(),
  questionnaireSection: new EntityStore<QuestionnaireSectionRecord>(),
  questionnaireSectionQuestion: new EntityStore<QuestionnaireSectionQuestionRecord>(),
  receivingFacilityRequest: new EntityStore<ReceivingFacilityRequestRecord>(),
  rendezvousRequest: new EntityStore<RendezvousRequestRecord>(),
  request: new EntityStore<RequestRecord>(),
  requester: new EntityStore<RequesterRecord>(),
  requesterReferralReason: new EntityStore<RequesterReferralReasonRecord>(),
  requesterRole: new EntityStore<RequesterRoleRecord>(),
  requestLocation: new EntityStore<RequestLocationRecord>(),
  requestPatient: new EntityStore<RequestPatientRecord>(),
  systemTimer: new EntityStore<SystemTimerRecord>(),
  timeline: new EntityStore<TimelineRecord>(),
  timelineItem: new EntityStore<TimelineItemRecord>(),
  timestamp: new EntityStore<TimestampRecord>(),
  timestampType: new EntityStore<TimestampTypeRecord>(),
  trackedMessage: new EntityStore<TrackedMessageRecord>(),
  transferReason: new EntityStore<TransferReasonRecord>(),
  transportOffer: new EntityStore<TransportOfferRecord>(),
  transportOfferOption: new EntityStore<TransportOfferOptionRecord>(),
  transportReason: new EntityStore<TransportReasonRecord>(),
  trip: new EntityStore<TripRecord>(),
  tripLeg: new EntityStore<TripLegRecord>(),
  tripPassenger: new EntityStore<TripPassengerRecord>(),
  unitActivationRule: new EntityStore<UnitActivationRuleRecord>(),
  unitEMSystemMapping: new EntityStore<UnitEMSystemMappingRecord>(),
  unit: new EntityStore<UnitRecord>(),
  unitNote: new EntityStore<UnitNoteRecord>(),
  unitPosition: new EntityStore<UnitPositionRecord>(),
  unitShift: new EntityStore<UnitShiftRecord>(),
  unitStatusHistoryEntry: new EntityStore<UnitStatusHistoryEntryRecord>(),
  unitSummary: new EntityStore<UnitSummaryRecord>(),
  vehicleDisposition: new EntityStore<VehicleDispositionRecord>(),
  vehicleNotificationGroup: new EntityStore<VehicleNotificationGroupRecord>(),
  vehicleSummary: new EntityStore<VehicleSummaryRecord>(),
  waypoint: new EntityStore<WaypointRecord>(),
  webOrderLog: new EntityStore<WebOrderLogRecord>(),
  accessibleItem: new EntityStore<AccessibleItemRecord>(),
  agency: new EntityStore<AgencyRecord>(),
  agencyLocation: new EntityStore<AgencyLocationRecord>(),
  airport: new EntityStore<AirportRecord>(),
  archiveLog: new EntityStore<ArchiveLogRecord>(),
  attachment: new EntityStore<AttachmentRecord>(),
  baseControlZone: new EntityStore<BaseControlZoneRecord>(),
  base: new EntityStore<BaseRecord>(),
  baseMedicalControlContact: new EntityStore<BaseMedicalControlContactRecord>(),
  baseMedicalControlContactState: new EntityStore<BaseMedicalControlContactStateRecord>(),
  capability: new EntityStore<CapabilityRecord>(),
  communicationCenter: new EntityStore<CommunicationCenterRecord>(),
  communicationCenterTransportOfferOption:
    new EntityStore<CommunicationCenterTransportOfferOptionRecord>(),
  company: new EntityStore<CompanyRecord>(),
  completeFlightInstance: new EntityStore<CompleteFlightInstanceRecord>(),
  controlZone: new EntityStore<ControlZoneRecord>(),
  department: new EntityStore<DepartmentRecord>(),
  entityCapability: new EntityStore<EntityCapabilityRecord>(),
  externalReference: new EntityStore<ExternalReferenceRecord>(),
  fbo: new EntityStore<FboRecord>(),
  fuelTank: new EntityStore<FuelTankRecord>(),
  location: new EntityStore<LocationRecord>(),
  maintenanceFacility: new EntityStore<MaintenanceFacilityRecord>(),
  medicalFacilityContact: new EntityStore<MedicalFacilityContactRecord>(),
  medicalFacility: new EntityStore<MedicalFacilityRecord>(),
  medicalFacilityPhysician: new EntityStore<MedicalFacilityPhysicianRecord>(),
  medicalFacilityUnit: new EntityStore<MedicalFacilityUnitRecord>(),
  medicalUnit: new EntityStore<MedicalUnitRecord>(),
  outOfServiceQARReason: new EntityStore<OutOfServiceQARReasonRecord>(),
  person: new EntityStore<PersonRecord>(),
  physician: new EntityStore<PhysicianRecord>(),
  programBase: new EntityStore<ProgramBaseRecord>(),
  program: new EntityStore<ProgramRecord>(),
  ramcoVehicleConfiguration: new EntityStore<RamcoVehicleConfigurationRecord>(),
  regionBase: new EntityStore<RegionBaseRecord>(),
  region: new EntityStore<RegionRecord>(),
  regionGroup: new EntityStore<RegionGroupRecord>(),
  releaseNote: new EntityStore<ReleaseNoteRecord>(),
  specialtyTeam: new EntityStore<SpecialtyTeamRecord>(),
  specialtyTeamMember: new EntityStore<SpecialtyTeamMemberRecord>(),
  state: new EntityStore<StateRecord>(),
  supportRequest: new EntityStore<SupportRequestRecord>(),
  timezone: new EntityStore<TimezoneRecord>(),
  transferCenter: new EntityStore<TransferCenterRecord>(),
  trmUserAgency: new EntityStore<TrmUserAgencyRecord>(),
  trmUser: new EntityStore<TrmUserRecord>(),
  trmUserMedicalFacility: new EntityStore<TrmUserMedicalFacilityRecord>(),
  trmUserProgram: new EntityStore<TrmUserProgramRecord>(),
  vehicleControlZone: new EntityStore<VehicleControlZoneRecord>(),
  vehicle: new EntityStore<VehicleRecord>(),
  vehicleMaintenance: new EntityStore<VehicleMaintenanceRecord>(),
  vehicleMake: new EntityStore<VehicleMakeRecord>(),
  vehicleModel: new EntityStore<VehicleModelRecord>(),
  vehicleStateInspection: new EntityStore<VehicleStateInspectionRecord>(),
  activeCardUnitOffering: new EntityStore<ActiveCardUnitOfferingRecord>(),
  vehiclePositionSummary: new EntityStore<VehiclePositionSummaryRecord>(),
}) {
  public activationRule: EntityStore<ActivationRuleRecord>;
  public activeAlertAcknowledgement: EntityStore<ActiveAlertAcknowledgementRecord>;
  public activeAlert: EntityStore<ActiveAlertRecord>;
  public activeTimeline: EntityStore<ActiveTimelineRecord>;
  public alert: EntityStore<AlertRecord>;
  public applicationNotification: EntityStore<ApplicationNotificationRecord>;
  public assignmentDelayedReason: EntityStore<AssignmentDelayedReasonRecord>;
  public cancellationCategory: EntityStore<CancellationCategoryRecord>;
  public cancellationReason: EntityStore<CancellationReasonRecord>;
  public cancellationSecondaryReason: EntityStore<CancellationSecondaryReasonRecord>;
  public card: EntityStore<CardRecord>;
  public cardLink: EntityStore<CardLinkRecord>;
  public cardNoteArchive: EntityStore<CardNoteArchiveRecord>;
  public cardNote: EntityStore<CardNoteRecord>;
  public cardReOpenReason: EntityStore<CardReOpenReasonRecord>;
  public cardSummary: EntityStore<CardSummaryRecord>;
  public configurationSetting: EntityStore<ConfigurationSettingRecord>;
  public conversation: EntityStore<ConversationRecord>;
  public conversationParticipant: EntityStore<ConversationParticipantRecord>;
  public declineCategory: EntityStore<DeclineCategoryRecord>;
  public declineReason: EntityStore<DeclineReasonRecord>;
  public declineSecondaryReason: EntityStore<DeclineSecondaryReasonRecord>;
  public diversionReason: EntityStore<DiversionReasonRecord>;
  public escortRequest: EntityStore<EscortRequestRecord>;
  public estimatedDuration: EntityStore<EstimatedDurationRecord>;
  public eta: EntityStore<EtaRecord>;
  public externalAction: EntityStore<ExternalActionRecord>;
  public externalActionType: EntityStore<ExternalActionTypeRecord>;
  public externalSystemUnit: EntityStore<ExternalSystemUnitRecord>;
  public facilityNonAcceptanceReason: EntityStore<FacilityNonAcceptanceReasonRecord>;
  public firewallRule: EntityStore<FirewallRuleRecord>;
  public flightFollowingReport: EntityStore<FlightFollowingReportRecord>;
  public landingZoneOutOfServiceReason: EntityStore<LandingZoneOutOfServiceReasonRecord>;
  public locationHazardAttachment: EntityStore<LocationHazardAttachmentRecord>;
  public locationHazard: EntityStore<LocationHazardRecord>;
  public manifestEntry: EntityStore<ManifestEntryRecord>;
  public medicalControlContactLogEntry: EntityStore<MedicalControlContactLogEntryRecord>;
  public messageStatusUpdate: EntityStore<MessageStatusUpdateRecord>;
  public newAgencyLocationRequest: EntityStore<NewAgencyLocationRequestRecord>;
  public nextDueType: EntityStore<NextDueTypeRecord>;
  public nonReferralReason: EntityStore<NonReferralReasonRecord>;
  public notification: EntityStore<NotificationRecord>;
  public notificationGroup: EntityStore<NotificationGroupRecord>;
  public notificationGroupMember: EntityStore<NotificationGroupMemberRecord>;
  public notificationRecipient: EntityStore<NotificationRecipientRecord>;
  public notificationSubscription: EntityStore<NotificationSubscriptionRecord>;
  public notificationTemplate: EntityStore<NotificationTemplateRecord>;
  public oemActivity: EntityStore<OemActivityRecord>;
  public oemAsset: EntityStore<OemAssetRecord>;
  public oemPlanChangeRequest: EntityStore<OemPlanChangeRequestRecord>;
  public oemPlan: EntityStore<OemPlanRecord>;
  public offerAlgorithm: EntityStore<OfferAlgorithmRecord>;
  public operation: EntityStore<OperationRecord>;
  public outOfServiceEvent: EntityStore<OutOfServiceEventRecord>;
  public outOfServiceEventNote: EntityStore<OutOfServiceEventNoteRecord>;
  public outOfServiceReason: EntityStore<OutOfServiceReasonRecord>;
  public outOfServiceSecondaryReason: EntityStore<OutOfServiceSecondaryReasonRecord>;
  public outOfServiceTicket: EntityStore<OutOfServiceTicketRecord>;
  public paipEvent: EntityStore<PaipEventRecord>;
  public paipReason: EntityStore<PaipReasonRecord>;
  public passdownLogAcknowledgement: EntityStore<PassdownLogAcknowledgementRecord>;
  public passdownLogArchivedLog: EntityStore<PassdownLogArchivedLogRecord>;
  public passdownLog: EntityStore<PassdownLogRecord>;
  public patient: EntityStore<PatientRecord>;
  public positionReportAlert: EntityStore<PositionReportAlertRecord>;
  public positionReportArchive: EntityStore<PositionReportArchiveRecord>;
  public positionReport: EntityStore<PositionReportRecord>;
  public questionChoice: EntityStore<QuestionChoiceRecord>;
  public question: EntityStore<QuestionRecord>;
  public questionnaire: EntityStore<QuestionnaireRecord>;
  public questionnaireQuestionResponse: EntityStore<QuestionnaireQuestionResponseRecord>;
  public questionnaireQuestionResponseNote: EntityStore<QuestionnaireQuestionResponseNoteRecord>;
  public questionnaireResponse: EntityStore<QuestionnaireResponseRecord>;
  public questionnaireSection: EntityStore<QuestionnaireSectionRecord>;
  public questionnaireSectionQuestion: EntityStore<QuestionnaireSectionQuestionRecord>;
  public receivingFacilityRequest: EntityStore<ReceivingFacilityRequestRecord>;
  public rendezvousRequest: EntityStore<RendezvousRequestRecord>;
  public request: EntityStore<RequestRecord>;
  public requester: EntityStore<RequesterRecord>;
  public requesterReferralReason: EntityStore<RequesterReferralReasonRecord>;
  public requesterRole: EntityStore<RequesterRoleRecord>;
  public requestLocation: EntityStore<RequestLocationRecord>;
  public requestPatient: EntityStore<RequestPatientRecord>;
  public systemTimer: EntityStore<SystemTimerRecord>;
  public timeline: EntityStore<TimelineRecord>;
  public timelineItem: EntityStore<TimelineItemRecord>;
  public timestamp: EntityStore<TimestampRecord>;
  public timestampType: EntityStore<TimestampTypeRecord>;
  public trackedMessage: EntityStore<TrackedMessageRecord>;
  public transferReason: EntityStore<TransferReasonRecord>;
  public transportOffer: EntityStore<TransportOfferRecord>;
  public transportOfferOption: EntityStore<TransportOfferOptionRecord>;
  public transportReason: EntityStore<TransportReasonRecord>;
  public trip: EntityStore<TripRecord>;
  public tripLeg: EntityStore<TripLegRecord>;
  public tripPassenger: EntityStore<TripPassengerRecord>;
  public unitActivationRule: EntityStore<UnitActivationRuleRecord>;
  public unitEMSystemMapping: EntityStore<UnitEMSystemMappingRecord>;
  public unit: EntityStore<UnitRecord>;
  public unitNote: EntityStore<UnitNoteRecord>;
  public unitPosition: EntityStore<UnitPositionRecord>;
  public unitShift: EntityStore<UnitShiftRecord>;
  public unitStatusHistoryEntry: EntityStore<UnitStatusHistoryEntryRecord>;
  public unitSummary: EntityStore<UnitSummaryRecord>;
  public vehicleDisposition: EntityStore<VehicleDispositionRecord>;
  public vehicleNotificationGroup: EntityStore<VehicleNotificationGroupRecord>;
  public vehicleSummary: EntityStore<VehicleSummaryRecord>;
  public waypoint: EntityStore<WaypointRecord>;
  public webOrderLog: EntityStore<WebOrderLogRecord>;
  public accessibleItem: EntityStore<AccessibleItemRecord>;
  public agency: EntityStore<AgencyRecord>;
  public agencyLocation: EntityStore<AgencyLocationRecord>;
  public airport: EntityStore<AirportRecord>;
  public archiveLog: EntityStore<ArchiveLogRecord>;
  public attachment: EntityStore<AttachmentRecord>;
  public baseControlZone: EntityStore<BaseControlZoneRecord>;
  public base: EntityStore<BaseRecord>;
  public baseMedicalControlContact: EntityStore<BaseMedicalControlContactRecord>;
  public baseMedicalControlContactState: EntityStore<BaseMedicalControlContactStateRecord>;
  public capability: EntityStore<CapabilityRecord>;
  public communicationCenter: EntityStore<CommunicationCenterRecord>;
  public communicationCenterTransportOfferOption: EntityStore<CommunicationCenterTransportOfferOptionRecord>;
  public company: EntityStore<CompanyRecord>;
  public completeFlightInstance: EntityStore<CompleteFlightInstanceRecord>;
  public controlZone: EntityStore<ControlZoneRecord>;
  public department: EntityStore<DepartmentRecord>;
  public entityCapability: EntityStore<EntityCapabilityRecord>;
  public externalReference: EntityStore<ExternalReferenceRecord>;
  public fbo: EntityStore<FboRecord>;
  public fuelTank: EntityStore<FuelTankRecord>;
  public location: EntityStore<LocationRecord>;
  public maintenanceFacility: EntityStore<MaintenanceFacilityRecord>;
  public medicalFacilityContact: EntityStore<MedicalFacilityContactRecord>;
  public medicalFacility: EntityStore<MedicalFacilityRecord>;
  public medicalFacilityPhysician: EntityStore<MedicalFacilityPhysicianRecord>;
  public medicalFacilityUnit: EntityStore<MedicalFacilityUnitRecord>;
  public medicalUnit: EntityStore<MedicalUnitRecord>;
  public outOfServiceQARReason: EntityStore<OutOfServiceQARReasonRecord>;
  public person: EntityStore<PersonRecord>;
  public physician: EntityStore<PhysicianRecord>;
  public programBase: EntityStore<ProgramBaseRecord>;
  public program: EntityStore<ProgramRecord>;
  public ramcoVehicleConfiguration: EntityStore<RamcoVehicleConfigurationRecord>;
  public regionBase: EntityStore<RegionBaseRecord>;
  public region: EntityStore<RegionRecord>;
  public regionGroup: EntityStore<RegionGroupRecord>;
  public releaseNote: EntityStore<ReleaseNoteRecord>;
  public specialtyTeam: EntityStore<SpecialtyTeamRecord>;
  public specialtyTeamMember: EntityStore<SpecialtyTeamMemberRecord>;
  public state: EntityStore<StateRecord>;
  public supportRequest: EntityStore<SupportRequestRecord>;
  public timezone: EntityStore<TimezoneRecord>;
  public transferCenter: EntityStore<TransferCenterRecord>;
  public trmUserAgency: EntityStore<TrmUserAgencyRecord>;
  public trmUser: EntityStore<TrmUserRecord>;
  public trmUserMedicalFacility: EntityStore<TrmUserMedicalFacilityRecord>;
  public trmUserProgram: EntityStore<TrmUserProgramRecord>;
  public vehicleControlZone: EntityStore<VehicleControlZoneRecord>;
  public vehicle: EntityStore<VehicleRecord>;
  public vehicleMaintenance: EntityStore<VehicleMaintenanceRecord>;
  public vehicleMake: EntityStore<VehicleMakeRecord>;
  public vehicleModel: EntityStore<VehicleModelRecord>;
  public vehicleStateInspection: EntityStore<VehicleStateInspectionRecord>;
  public activeCardUnitOffering: EntityStore<ActiveCardUnitOfferingRecord>;
  public vehiclePositionSummary: EntityStore<VehiclePositionSummaryRecord>;
}
